<template>
    <div class="page">
        <div class="checklistBar2" @click.stop="hintTextWin">
            <div class="barTitle">定制选项基本操作</div>
        </div>
        <div class="imgLoad">
            <div class="playVideoIcon"></div>
        </div>
        <div class="fill50"></div>
        <div class="wrap" style="position: relative; z-index: 9">
            <div class="topFlexBox">
                <pageBreadcrumb :option="nav_option" />
                <div class="title">3D图展示</div>
            </div>
        </div>
        <div class="wrap martop">
            <div class="topBoxTop" v-if="!isH5">
                <model_3d ref="model_3d" v-show="modelUrl && caizhiName && yanseName" />
                <el-carousel :height="'100%'" v-show="!modelUrl || !caizhiName || !yanseName" class="topBoxImg">
                    <el-carousel-item class="bannerItem" v-for="(item, index) in bannerList" :key="index">
                        <el-image class="img" :src="item.image" fit="contain"></el-image>
                    </el-carousel-item>
                </el-carousel>
                <!-- <div class="redText">
                    <span style="letter-spacing: 0.55px">定制选项基本操作：从上到下，从左到右<br /></span>
                    鼠标指针放在3D图展示区域，长按鼠标左键并移动，可旋转3D展示图<br />
                    拨动鼠标滚轮，可放大或缩小3D展示图<br />
                    长按Ctrl + 鼠标左键不放，在展示区域拖动鼠标，可移动鼓组位置
                </div> -->
            </div>

            <div class="topBoxTop" v-else>
                <ali-video ref="topVideo" v-if="topVideoUrl && !videoWinShow" :mediaUrl="topVideoUrl"></ali-video>
            </div>
        </div>
        <div class="whiteLineBox"></div>
        <div class="bgBox">
            <div class="wrap" style="background: #f1f1f1">
                <div class="contentScrollView" v-if="supporterList.info && supporterList.info.length > 0 && planeList.length > 0">
                    <div class="fill30"></div>
                    <!-- 鼓组数量＆嗵鼓支撑器 -->
                    <div class="flexWrapBox7">
                        <div class="topBox">
                            <div class="titleBox">
                                <div class="title">鼓组数量＆嗵鼓支撑器</div>
                            </div>
                            <table class="tableBox">
                                <tr>
                                    <td rowspan="2" class="tableTitle biaotou">
                                        <span class="leftTitle">鼓组数量</span>
                                        <span class="leftTitle2">嗵鼓支撑器</span>
                                    </td>
                                    <!-- <td colspan="6" class="greyBg tableTitle"><div class="tableItemBox">嗵鼓支撑器</div></td> -->
                                </tr>
                                <tr>
                                    <td v-for="(item, index) in supporterList.info" :key="index">
                                        <el-popover placement="right" :disabled="!item.image" trigger="hover" :open-delay="700">
                                            <div class="previewImgBox">
                                                <img class="previewImg" :src="item.image" alt="" />
                                                <div class="previewImgText">{{ item.title }}</div>
                                            </div>
                                            <div class="tableItemBox tableTitle" slot="reference">{{ item.title }}</div>
                                        </el-popover>
                                        <!-- <div class="tableItemBox tableTitle">{{ item }}</div> -->
                                    </td>
                                </tr>
                                <tr v-for="(item, index) in planeList" :key="index">
                                    <td>
                                        <div class="tableTitle2">
                                            {{ item.title }}
                                            <span class="tableTitle3">
                                                （底鼓×{{ item.heaving_floor_num }} 军鼓×{{ item.military_drum_num }} 嗵鼓×{{
                                                    item.tom_drum_num
                                                }}
                                                落地嗵×{{ item.landing_punch_num }}）
                                            </span>
                                        </div>
                                    </td>
                                    <td v-for="(item2, index2) in supporterList.list[index]" :key="index2">
                                        <el-popover placement="right" :disabled="true" trigger="hover" :open-delay="700">
                                            <div class="previewImgBox">
                                                <img class="previewImg" :src="item2.image" alt="" />
                                                <div class="previewImgText">{{ item2.title }}</div>
                                            </div>
                                            <div class="flexBox" @click="selectPlane(item, item2.id, item2)" v-if="item2.num > 0" slot="reference">
                                                <div
                                                    class="dianBox"
                                                    :class="{
                                                        active: supportIsActive(item2.id),
                                                    }"
                                                >
                                                    <div class="dianActive"></div>
                                                </div>
                                                &nbsp&nbsp
                                                <div class="smallTitle">{{ item2.num }}</div>
                                            </div>
                                        </el-popover>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <!-- <div class="commonLine"></div> -->
                        <!-- 鼓腔材质 -->
                        <div class="titleBox">
                            <div class="title">鼓腔材质</div>
                        </div>
                        <div class="flexWrapBox11">
                            <el-row :gutter="40">
                                <el-col :span="12">
                                    <div class="greyTitleBox">
                                        外层
                                        <!-- <span class="small">（大理石纹，黑白檀，龙鳞木PVC的颜色没有渲染效果展示。）</span> -->
                                    </div>
                                    <div class="wrapBox">
                                        <el-popover
                                            :disabled="!item.image"
                                            v-for="(item, index) in materialList.wai_arr"
                                            :key="item.id"
                                            placement="right"
                                            trigger="hover"
                                            :open-delay="700"
                                            v-if="item.title != '亚克力'"
                                        >
                                            <div class="previewImgBox">
                                                <img class="previewImg" :src="item.thumb" alt="" />
                                                <div class="previewImgText">{{ item.title }}</div>
                                            </div>
                                            <div class="item" slot="reference">
                                                <div class="title">{{ item.title }}</div>
                                                <div class="elImgBox">
                                                    <el-image :src="item.thumb" fit="fill" class="img"></el-image>
                                                </div>
                                                <div class="bottomFlexBox">
                                                    <div
                                                        class="selectBtn"
                                                        :class="{ active: materialObj.outside == item.id }"
                                                        @click="selectMaterial(item, 1)"
                                                    >
                                                        <div class="selectBtnActive"></div>
                                                    </div>
                                                    <div class="playVideoIcon" @click="showVideo(item)">
                                                        <div class="hintVideoText">音色视听</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </el-popover>
                                    </div>
                                </el-col>
                                <el-col :span="12">
                                    <div class="greyTitleBox">内层</div>
                                    <div class="wrapBox">
                                        <!-- <transition-group name="cell" tag="span" class="wrapBox"> -->
                                        <el-popover
                                            :disabled="!item.image"
                                            v-for="(item, index) in materialList.nei_arr"
                                            :key="item.id"
                                            placement="right"
                                            trigger="hover"
                                            :open-delay="700"
                                            v-if="item.title != '亚克力'"
                                        >
                                            <div class="previewImgBox">
                                                <img class="previewImg" :src="item.thumb" alt="" />
                                                <div class="previewImgText">{{ item.title }}</div>
                                            </div>
                                            <div class="item" slot="reference">
                                                <div class="title">{{ item.title }}</div>
                                                <div class="elImgBox">
                                                    <el-image :src="item.thumb" fit="fill" class="img"></el-image>
                                                </div>
                                                <div class="bottomFlexBox">
                                                    <div
                                                        class="selectBtn"
                                                        :class="{ active: materialObj.inside == item.id }"
                                                        @click="selectMaterial(item, 2)"
                                                    >
                                                        <div class="selectBtnActive"></div>
                                                    </div>
                                                    <div class="recommend" v-if="item.is_recommend && item.is_recommend == 1">推荐</div>
                                                    <!-- <div class="playVideoIcon" @click="showVideo(item)">
                                                    <div class="hintVideoText">音色视听</div>
                                                </div> -->
                                                </div>
                                            </div>
                                        </el-popover>
                                        <!-- </transition-group> -->
                                    </div>
                                </el-col>
                            </el-row>
                            <div class="centerLine"></div>
                        </div>
                        <div class="commonLine"></div>

                        <!-- 鼓腔表面处理 -->
                        <div class="titleBox">
                            <div class="title">鼓腔表面处理</div>
                        </div>
                        <div class="flexWrapBox12">
                            <el-row :gutter="20">
                                <el-col :span="24">
                                    <div class="greyTitleBox">烤漆</div>
                                    <div class="flexWrapBox12ScrollBox" ref="scrollBox">
                                        <el-popover
                                            :disabled="!item.image"
                                            v-for="(item, index) in colorList.kq_arr"
                                            :key="item.id"
                                            placement="right"
                                            trigger="hover"
                                            :open-delay="700"
                                        >
                                            <div class="previewImgBox">
                                                <img class="previewImg" :src="item.thumb" alt="" />
                                                <div class="previewImgText">{{ item.title }}</div>
                                            </div>
                                            <div class="itemBox" :ref="'colorBox' + index" slot="reference">
                                                <div class="title">{{ item.title }}</div>
                                                <div class="elImgBox">
                                                    <el-image :src="item.thumb" fit="fill" class="img"></el-image>
                                                </div>
                                                <div class="bottomFlexBox">
                                                    <div class="selectBtn" :class="{ active: item.id == colorListId }" @click="selectColor(item)">
                                                        <div class="selectBtnActive"></div>
                                                    </div>
                                                    <div class="recommend" v-if="item.is_recommend && item.is_recommend == 1">推荐</div>
                                                </div>
                                            </div>
                                        </el-popover>
                                    </div>
                                </el-col>
                                <el-col :span="12" v-if="false">
                                    <div class="greyTitleBox">PVC</div>
                                    <div class="flexWrapBox12ScrollBox1-2" ref="scrollBox2">
                                        <el-popover
                                            :disabled="!item.image"
                                            v-for="(item, index) in colorList.pvc_arr"
                                            :key="item.id"
                                            placement="right"
                                            trigger="hover"
                                            :open-delay="700"
                                        >
                                            <div class="previewImgBox">
                                                <img class="previewImg" :src="item.thumb" alt="" />
                                                <div class="previewImgText">{{ item.title }}</div>
                                            </div>
                                            <div class="itemBox" slot="reference">
                                                <div class="title">{{ item.title }}</div>
                                                <div class="elImgBox">
                                                    <el-image :src="item.thumb" fit="fill" class="img"></el-image>
                                                </div>
                                                <div class="bottomFlexBox">
                                                    <div class="selectBtn" :class="{ active: item.id == colorListId }" @click="selectColor(item)">
                                                        <div class="selectBtnActive"></div>
                                                    </div>
                                                    <div class="recommend" v-if="item.is_recommend && item.is_recommend == 1">推荐</div>
                                                </div>
                                            </div>
                                        </el-popover>
                                    </div>
                                </el-col>
                                <!-- <el-col :span="3">
                                    <div class="greyTitleBox">亚克力</div>
                                    <div class="flexWrapBox12ScrollBox2" ref="scrollBox3">
                                        <el-popover
                                            :disabled="!item.image"
                                            v-for="(item, index) in colorList.ykl_arr"
                                            :key="item.id"
                                            placement="right"
                                            trigger="hover"
                                            :open-delay="700"
                                        >
                                            <div class="previewImgBox">
                                                <img class="previewImg" :src="item.thumb" alt="" />
                                                <div class="previewImgText">{{ item.title }}</div>
                                            </div>
                                            <div class="itemBox" slot="reference">
                                                <div class="title">{{ item.title }}</div>
                                                <div class="elImgBox">
                                                    <img
                                                        :src="item.thumb"
                                                        class="img"
                                                        style="border: 1px solid #707070; box-sizing: border-box"
                                                        alt=""
                                                    />
                                                </div>
                                                <div class="bottomFlexBox">
                                                    <div class="selectBtn" :class="{ active: item.id == colorListId }" @click="selectColor(item)">
                                                        <div class="selectBtnActive"></div>
                                                    </div>
                                                    <div class="recommend" v-if="item.is_recommend && item.is_recommend == 1">推荐</div>
                                                </div>
                                            </div>
                                        </el-popover>
                                    </div>
                                </el-col> -->
                            </el-row>
                        </div>
                        <div class="commonLine"></div>

                        <!-- 鼓腔尺寸 -->
                        <div class="titleBox">
                            <div class="title">鼓腔尺寸</div>
                        </div>
                        <div class="flexWrapBox">
                            <div class="sizeSwitchBigBox">
                                <div class="item" @click="switchSizeTab(1)" :class="{ active: 1 == sizeListId }">底鼓</div>
                                <div class="item" @click="switchSizeTab(2)" :class="{ active: 2 == sizeListId }">军鼓</div>
                                <div class="item" @click="switchSizeTab(3)" :class="{ active: 3 == sizeListId }">嗵鼓</div>
                                <div class="item" @click="switchSizeTab(4)" :class="{ active: 4 == sizeListId }">落地嗵</div>
                            </div>
                            <div class="myFlex">
                                <div class="sizeBigBoxContent">
                                    <div class="sizeBigBox" v-for="(item, index) in sizeList[1]" :key="index">
                                        <div class="item" v-if="1 == sizeListId">
                                            <div class="sizeTitle">鼓腔直径</div>
                                            <div class="sizeFlexBox">
                                                <el-popover
                                                    :disabled="!item2.image"
                                                    placement="right"
                                                    trigger="hover"
                                                    v-for="(item2, index2) in item.diameter"
                                                    :open-delay="700"
                                                >
                                                    <div class="previewImgBox">
                                                        <img class="previewImg" :src="item2.image" alt="" />
                                                        <div class="previewImgText">{{ item2.title }}</div>
                                                    </div>

                                                    <div class="sizeBtnFlexBox" slot="reference" @click="selectSize(item2, index, 'diameter')">
                                                        <div class="dianBox" :class="{ active: sizeObj[sizeListId][index]['diameter'] == item2.id }">
                                                            <div class="dianActive"></div>
                                                        </div>
                                                        <div class="title">{{ item2.title }}</div>
                                                    </div>
                                                </el-popover>
                                            </div>
                                        </div>
                                        <div class="item" v-if="1 == sizeListId">
                                            <div class="sizeTitle">鼓腔深度</div>
                                            <div class="sizeFlexBox">
                                                <el-popover
                                                    :disabled="!item2.image"
                                                    placement="right"
                                                    trigger="hover"
                                                    v-for="(item2, index2) in item.depth"
                                                    :open-delay="700"
                                                >
                                                    <div class="previewImgBox">
                                                        <img class="previewImg" :src="item2.image" alt="" />
                                                        <div class="previewImgText">{{ item2.title }}</div>
                                                    </div>

                                                    <div class="sizeBtnFlexBox" slot="reference" @click="selectSize(item2, index, 'depth')">
                                                        <div class="dianBox" :class="{ active: sizeObj[sizeListId][index]['depth'] == item2.id }">
                                                            <div class="dianActive"></div>
                                                        </div>
                                                        <div class="title">{{ item2.title }}</div>
                                                    </div>
                                                </el-popover>
                                            </div>
                                        </div>
                                        <div class="item" v-if="1 == sizeListId">
                                            <div class="sizeTitle">钉数</div>
                                            <div class="sizeFlexBox">
                                                <el-popover
                                                    :disabled="!item2.image"
                                                    placement="right"
                                                    trigger="hover"
                                                    v-for="(item2, index2) in item.nail"
                                                    :open-delay="700"
                                                >
                                                    <div class="previewImgBox">
                                                        <img class="previewImg" :src="item2.image" alt="" />
                                                        <div class="previewImgText">{{ item2.title }}</div>
                                                    </div>

                                                    <div class="sizeBtnFlexBox" slot="reference" @click="selectSize(item2, index, 'nail')">
                                                        <div
                                                            class="dianBox"
                                                            :class="{
                                                                unActive: sizeList[sizeListId][index]['nail'].length == 1,
                                                                active: sizeObj[sizeListId][index]['nail'] == item2.id,
                                                            }"
                                                            @click="openHintWin5(sizeList[sizeListId][index]['nail'].length == 1)"
                                                        >
                                                            <div class="dianActive"></div>
                                                        </div>
                                                        <div class="title">{{ item2.title }}</div>
                                                    </div>
                                                </el-popover>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="sizeBigBoxContent">
                                    <div class="sizeBigBox" v-for="(item, index) in sizeList[2]" :key="index + 'jun'">
                                        <div class="item" v-if="2 == sizeListId">
                                            <div class="sizeTitle">鼓腔直径</div>
                                            <div class="sizeFlexBox">
                                                <el-popover
                                                    :disabled="!item2.image"
                                                    placement="right"
                                                    trigger="hover"
                                                    v-for="(item2, index2) in item.diameter"
                                                    :open-delay="700"
                                                >
                                                    <div class="previewImgBox">
                                                        <img class="previewImg" :src="item2.image" alt="" />
                                                        <div class="previewImgText">{{ item2.title }}</div>
                                                    </div>

                                                    <div class="sizeBtnFlexBox" slot="reference" @click="selectSize(item2, index, 'diameter')">
                                                        <div class="dianBox" :class="{ active: sizeObj[sizeListId][index]['diameter'] == item2.id }">
                                                            <div class="dianActive"></div>
                                                        </div>
                                                        <div class="title">{{ item2.title }}</div>
                                                    </div>
                                                </el-popover>
                                            </div>
                                        </div>
                                        <div class="item" v-if="2 == sizeListId">
                                            <div class="sizeTitle">鼓腔深度</div>
                                            <div class="sizeFlexBox">
                                                <el-popover
                                                    :disabled="!item2.image"
                                                    placement="right"
                                                    trigger="hover"
                                                    v-for="(item2, index2) in item.depth"
                                                    :open-delay="700"
                                                >
                                                    <div class="previewImgBox">
                                                        <img class="previewImg" :src="item2.image" alt="" />
                                                        <div class="previewImgText">{{ item2.title }}</div>
                                                    </div>

                                                    <div class="sizeBtnFlexBox" slot="reference" @click="selectSize(item2, index, 'depth')">
                                                        <div class="dianBox" :class="{ active: sizeObj[sizeListId][index]['depth'] == item2.id }">
                                                            <div class="dianActive"></div>
                                                        </div>
                                                        <div class="title">{{ item2.title }}</div>
                                                    </div>
                                                </el-popover>
                                            </div>
                                        </div>
                                        <div class="item" v-if="2 == sizeListId">
                                            <div class="sizeTitle">钉数</div>
                                            <div class="sizeFlexBox">
                                                <el-popover
                                                    :disabled="!item2.image"
                                                    placement="right"
                                                    trigger="hover"
                                                    v-for="(item2, index2) in item.nail"
                                                    :open-delay="700"
                                                >
                                                    <div class="previewImgBox">
                                                        <img class="previewImg" :src="item2.image" alt="" />
                                                        <div class="previewImgText">{{ item2.title }}</div>
                                                    </div>

                                                    <div class="sizeBtnFlexBox" slot="reference" @click="selectSize(item2, index, 'nail')">
                                                        <div
                                                            class="dianBox"
                                                            :class="{
                                                                unActive: sizeList[sizeListId][index]['nail'].length == 1,
                                                                active: sizeObj[sizeListId][index]['nail'] == item2.id,
                                                            }"
                                                            @click="openHintWin5(sizeList[sizeListId][index]['nail'].length == 1)"
                                                        >
                                                            <div class="dianActive"></div>
                                                        </div>
                                                        <div class="title">{{ item2.title }}</div>
                                                    </div>
                                                </el-popover>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="sizeBigBoxContent">
                                    <div class="sizeBigBox" v-for="(item, index) in sizeList[3]" :key="index + 'tong'">
                                        <div class="item" v-if="3 == sizeListId">
                                            <div class="sizeTitle">鼓腔直径</div>
                                            <div class="sizeFlexBox">
                                                <el-popover
                                                    :disabled="!item2.image"
                                                    placement="right"
                                                    trigger="hover"
                                                    v-for="(item2, index2) in item.diameter"
                                                    :open-delay="700"
                                                >
                                                    <div class="previewImgBox">
                                                        <img class="previewImg" :src="item2.image" alt="" />
                                                        <div class="previewImgText">{{ item2.title }}</div>
                                                    </div>

                                                    <div class="sizeBtnFlexBox" slot="reference" @click="selectSize(item2, index, 'diameter')">
                                                        <div class="dianBox" :class="{ active: sizeObj[sizeListId][index]['diameter'] == item2.id }">
                                                            <div class="dianActive"></div>
                                                        </div>
                                                        <div class="title">{{ item2.title }}</div>
                                                    </div>
                                                </el-popover>
                                            </div>
                                        </div>
                                        <div class="item" v-if="3 == sizeListId">
                                            <div class="sizeTitle">鼓腔深度</div>
                                            <div class="sizeFlexBox">
                                                <el-popover
                                                    :disabled="!item2.image"
                                                    placement="right"
                                                    trigger="hover"
                                                    v-for="(item2, index2) in item.depth"
                                                    :open-delay="700"
                                                >
                                                    <div class="previewImgBox">
                                                        <img class="previewImg" :src="item2.image" alt="" />
                                                        <div class="previewImgText">{{ item2.title }}</div>
                                                    </div>

                                                    <div class="sizeBtnFlexBox" slot="reference" @click="selectSize(item2, index, 'depth')">
                                                        <div class="dianBox" :class="{ active: sizeObj[sizeListId][index]['depth'] == item2.id }">
                                                            <div class="dianActive"></div>
                                                        </div>
                                                        <div class="title">{{ item2.title }}</div>
                                                    </div>
                                                </el-popover>
                                            </div>
                                        </div>
                                        <div class="item" v-if="3 == sizeListId">
                                            <div class="sizeTitle">钉数</div>
                                            <div class="sizeFlexBox">
                                                <el-popover
                                                    :disabled="!item2.image"
                                                    placement="right"
                                                    trigger="hover"
                                                    v-for="(item2, index2) in item.nail"
                                                    :open-delay="700"
                                                >
                                                    <div class="previewImgBox">
                                                        <img class="previewImg" :src="item2.image" alt="" />
                                                        <div class="previewImgText">{{ item2.title }}</div>
                                                    </div>

                                                    <div class="sizeBtnFlexBox" slot="reference" @click="selectSize(item2, index, 'nail')">
                                                        <div
                                                            class="dianBox"
                                                            :class="{
                                                                unActive: sizeList[sizeListId][index]['nail'].length == 1,
                                                                active: sizeObj[sizeListId][index]['nail'] == item2.id,
                                                            }"
                                                            @click="openHintWin5(sizeList[sizeListId][index]['nail'].length == 1)"
                                                        >
                                                            <div class="dianActive"></div>
                                                        </div>
                                                        <div class="title">{{ item2.title }}</div>
                                                    </div>
                                                </el-popover>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="sizeBigBoxContent">
                                    <div class="sizeBigBox" v-for="(item, index) in sizeList[4]" :key="index + 'longditong'">
                                        <div class="item" v-if="4 == sizeListId">
                                            <div class="sizeTitle">鼓腔直径</div>
                                            <div class="sizeFlexBox">
                                                <el-popover
                                                    :disabled="!item2.image"
                                                    placement="right"
                                                    trigger="hover"
                                                    v-for="(item2, index2) in item.diameter"
                                                    :open-delay="700"
                                                >
                                                    <div class="previewImgBox">
                                                        <img class="previewImg" :src="item2.image" alt="" />
                                                        <div class="previewImgText">{{ item2.title }}</div>
                                                    </div>

                                                    <div class="sizeBtnFlexBox" slot="reference" @click="selectSize(item2, index, 'diameter')">
                                                        <div class="dianBox" :class="{ active: sizeObj[sizeListId][index]['diameter'] == item2.id }">
                                                            <div class="dianActive"></div>
                                                        </div>
                                                        <div class="title">{{ item2.title }}</div>
                                                    </div>
                                                </el-popover>
                                            </div>
                                        </div>
                                        <div class="item" v-if="4 == sizeListId">
                                            <div class="sizeTitle">鼓腔深度</div>
                                            <div class="sizeFlexBox">
                                                <el-popover
                                                    :disabled="!item2.image"
                                                    placement="right"
                                                    trigger="hover"
                                                    v-for="(item2, index2) in item.depth"
                                                    :open-delay="700"
                                                >
                                                    <div class="previewImgBox">
                                                        <img class="previewImg" :src="item2.image" alt="" />
                                                        <div class="previewImgText">{{ item2.title }}</div>
                                                    </div>

                                                    <div class="sizeBtnFlexBox" slot="reference" @click="selectSize(item2, index, 'depth')">
                                                        <div class="dianBox" :class="{ active: sizeObj[sizeListId][index]['depth'] == item2.id }">
                                                            <div class="dianActive"></div>
                                                        </div>
                                                        <div class="title">{{ item2.title }}</div>
                                                    </div>
                                                </el-popover>
                                            </div>
                                        </div>
                                        <div class="item" v-if="4 == sizeListId">
                                            <div class="sizeTitle">钉数</div>
                                            <div class="sizeFlexBox">
                                                <el-popover
                                                    :disabled="!item2.image"
                                                    placement="right"
                                                    trigger="hover"
                                                    v-for="(item2, index2) in item.nail"
                                                    :open-delay="700"
                                                >
                                                    <div class="previewImgBox">
                                                        <img class="previewImg" :src="item2.image" alt="" />
                                                        <div class="previewImgText">{{ item2.title }}</div>
                                                    </div>

                                                    <div class="sizeBtnFlexBox" slot="reference" @click="selectSize(item2, index, 'nail')">
                                                        <div
                                                            class="dianBox"
                                                            :class="{
                                                                unActive: sizeList[sizeListId][index]['nail'].length == 1,
                                                                active: sizeObj[sizeListId][index]['nail'] == item2.id,
                                                            }"
                                                            @click="openHintWin5(sizeList[sizeListId][index]['nail'].length == 1)"
                                                        >
                                                            <div class="dianActive"></div>
                                                        </div>
                                                        <div class="title">{{ item2.title }}</div>
                                                    </div>
                                                </el-popover>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="commonLine"></div>

                        <!-- 单鼓另购 -->
                        <div class="titleBox">
                            <div class="title">单鼓另购</div>
                        </div>
                        <div class="flexWrapBox13">
                            <div class="flexBox">
                                <div class="flexBtnBox">
                                    <div class="title">底鼓&nbsp&nbsp&nbsp</div>
                                    <div class="otherBuyBtn btn-ripple" @click="buyGu(1)">{{ another_heaving_floor == 0 ? '另购' : '编辑' }}</div>
                                </div>
                                <div class="flexBtnBox">
                                    <div class="title">军鼓&nbsp&nbsp&nbsp</div>
                                    <div class="otherBuyBtn btn-ripple" @click="buyGu(2)">{{ another_military == 0 ? '另购' : '编辑' }}</div>
                                </div>
                                <div class="flexBtnBox">
                                    <div class="title">嗵鼓&nbsp&nbsp&nbsp</div>
                                    <div class="otherBuyBtn btn-ripple" @click="buyGu(3)">{{ another_tom == 0 ? '另购' : '编辑' }}</div>
                                </div>
                                <div class="flexBtnBox">
                                    <div class="title">落地嗵&nbsp&nbsp&nbsp</div>
                                    <div class="otherBuyBtn btn-ripple" @click="buyGu(4)">{{ another_landing_punch == 0 ? '另购' : '编辑' }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="commonLine"></div>

                        <!-- 鼓压圈 -->
                        <div class="titleBox">
                            <div class="title">鼓压圈</div>
                        </div>
                        <div class="flexWrapBox5">
                            <div class="switchBigBox">
                                <div class="item">军鼓</div>
                                <div class="item">嗵鼓</div>
                                <div class="item">落地嗵</div>
                            </div>
                            <!-- 标准鼓 军鼓 鼓压圈 -->
                            <div class="flexBoxM">
                                <div class="itemBox">
                                    <div class="selectBigFlexBox" v-for="(item, index) in ringList[2]" :key="index">
                                        <el-select
                                            class="select"
                                            v-show="ringList[2][index].length > 0"
                                            v-model="ringObj[2][index]"
                                            placeholder="请选择鼓压圈"
                                            @change="selectRing"
                                        >
                                            <el-option
                                                v-for="(item2, index2) in ringList[2][index]"
                                                :key="'taogu' + index2"
                                                :label="item2.title"
                                                :value="item2.id"
                                            >
                                                <el-popover :disabled="!item2.image" placement="right" trigger="hover">
                                                    <div class="previewImgBox">
                                                        <img class="previewImg" :src="item2.image" alt="" />
                                                        <div class="previewImgText">{{ item2.title }}</div>
                                                    </div>
                                                    <div class="item" slot="reference">
                                                        <div class="selectTitleFlexBox">
                                                            <div class="mySelectTitle">{{ item2.title }}</div>
                                                            <div class="mySelectNum">×{{ item2.num }}</div>
                                                        </div>
                                                    </div>
                                                </el-popover>
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div class="selectBigFlexBox" v-if="ringList2[2].length > 0" style="margin-top: 10px">
                                        <el-select class="select" v-model="ringObj2[2]" placeholder="请选择鼓压圈">
                                            <el-option
                                                v-for="(item2, index2) in ringList2[2]"
                                                :key="'linggou' + index2"
                                                :label="item2.title"
                                                :value="item2.id"
                                            >
                                                <el-popover :disabled="!item2.image" placement="right" trigger="hover">
                                                    <div class="previewImgBox">
                                                        <img class="previewImg" :src="item2.image" alt="" />
                                                        <div class="previewImgText">{{ item2.title }}</div>
                                                    </div>
                                                    <div class="item" slot="reference">
                                                        <div class="selectTitleFlexBox">
                                                            <div class="mySelectTitle">{{ item2.title }}</div>
                                                            <div class="mySelectNum">×{{ item2.num }}</div>
                                                        </div>
                                                    </div>
                                                </el-popover>
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                                <div class="itemBox">
                                    <div class="ringItem">
                                        <div class="ringItemMyBox" v-for="(item, index) in ringList[3]" :key="index">
                                            <el-popover placement="right" :disabled="!item.image" trigger="hover" :open-delay="700">
                                                <div class="previewImgBox">
                                                    <img class="previewImg" :src="item.image" alt="" />
                                                    <div class="previewImgText">{{ item.title }}</div>
                                                </div>
                                                <div class="item" slot="reference">
                                                    <div class="dianBox unActive" @click="openHintWin">
                                                        <div class="dianActive"></div>
                                                    </div>
                                                    <div class="smallTitle">{{ item.title }}</div>
                                                    <div class="selectNum">×{{ item.num }}</div>
                                                </div>
                                            </el-popover>
                                        </div>
                                        <div class="ringItemMyBox" v-for="(item, index) in ringList2[3]" :key="'dingzhi' + index">
                                            <el-popover placement="right" :disabled="!item.image" trigger="hover" :open-delay="700">
                                                <div class="previewImgBox">
                                                    <img class="previewImg" :src="item.image" alt="" />
                                                    <div class="previewImgText">{{ item.title }}</div>
                                                </div>
                                                <div class="item" slot="reference">
                                                    <div class="dianBox unActive" @click="openHintWin">
                                                        <div class="dianActive"></div>
                                                    </div>
                                                    <div class="smallTitle">{{ item.title }}</div>
                                                    <div class="selectNum">×{{ item.num }}</div>
                                                </div>
                                            </el-popover>
                                        </div>
                                    </div>
                                </div>
                                <div class="itemBox">
                                    <div class="ringItem">
                                        <div class="ringItemMyBox" v-for="(item, index) in ringList[4]" :key="index">
                                            <el-popover placement="right" :disabled="!item.image" trigger="hover" :open-delay="700">
                                                <div class="previewImgBox">
                                                    <img class="previewImg" :src="item.image" alt="" />
                                                    <div class="previewImgText">{{ item.title }}</div>
                                                </div>
                                                <div class="item" slot="reference">
                                                    <div class="dianBox unActive" @click="openHintWin">
                                                        <div class="dianActive"></div>
                                                    </div>
                                                    <div class="smallTitle">{{ item.title }}</div>
                                                    <div class="selectNum">×{{ item.num }}</div>
                                                </div>
                                            </el-popover>
                                        </div>
                                        <div class="ringItemMyBox" v-for="(item, index) in ringList2[4]" :key="'dingzhi' + index">
                                            <el-popover placement="right" :disabled="!item.image" trigger="hover" :open-delay="700">
                                                <div class="previewImgBox">
                                                    <img class="previewImg" :src="item.image" alt="" />
                                                    <div class="previewImgText">{{ item.title }}</div>
                                                </div>
                                                <div class="item" slot="reference">
                                                    <div class="dianBox unActive" @click="openHintWin">
                                                        <div class="dianActive"></div>
                                                    </div>
                                                    <div class="smallTitle">{{ item.title }}</div>
                                                    <div class="selectNum">×{{ item.num }}</div>
                                                </div>
                                            </el-popover>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="commonLine"></div>

                        <!-- 悬挂系统 -->
                        <div class="titleBox">
                            <div class="title">悬挂系统</div>
                        </div>
                        <div class="flexWrapBox6">
                            <div class="switchBigBox">
                                <div class="item">嗵鼓悬挂系统</div>
                                <div class="item">落地嗵悬挂系统</div>
                                <div class="item">落地嗵腿</div>
                            </div>
                            <div class="flexWrapBox6FlexBox">
                                <div class="flexWrapBox6FlexBoxItemBox">
                                    <div class="itemBoxM">
                                        <div class="selectBigFlexBox" v-for="(item, index) in hangList[3]" :key="index">
                                            <el-select
                                                class="select"
                                                v-if="index == 0"
                                                v-model="hangObj[3][index]"
                                                placeholder="请选择悬挂系统"
                                                @change="selectHang"
                                            >
                                                <el-option
                                                    v-for="(item2, index2) in hangList[3][index]"
                                                    :key="index2"
                                                    :label="item2.title"
                                                    :value="item2.id"
                                                >
                                                    <el-popover :disabled="!item2.image" placement="right" trigger="hover">
                                                        <div class="previewImgBox">
                                                            <img class="previewImg" :src="item2.image" alt="" />
                                                            <div class="previewImgText">{{ item2.title }}</div>
                                                        </div>
                                                        <div class="item" slot="reference">
                                                            <div class="selectTitleFlexBox">
                                                                <div class="mySelectTitle">{{ item2.title }}</div>
                                                                <div class="mySelectNum">×{{ item2.num }}</div>
                                                            </div>
                                                        </div>
                                                    </el-popover>
                                                </el-option>
                                            </el-select>
                                            <div class="hangItemBox" v-if="index > 0">
                                                <el-popover
                                                    placement="right"
                                                    :disabled="!item2.image"
                                                    trigger="hover"
                                                    v-for="(item2, index2) in hangList[3][index]"
                                                >
                                                    <div class="previewImgBox">
                                                        <img class="previewImg" :src="item2.image" alt="" />
                                                        <div class="previewImgText">{{ item2.title }}</div>
                                                    </div>
                                                    <div class="myItem" slot="reference">
                                                        <div class="dianBox unActive" @click="openHintWin2">
                                                            <div class="dianActive"></div>
                                                        </div>
                                                        <div class="smallTitle">{{ item2.title }}</div>
                                                        <div class="selectNum">×{{ item2.num }}</div>
                                                    </div>
                                                </el-popover>
                                            </div>
                                        </div>
                                        <div class="selectBigFlexBox" v-for="(item2, index2) in hangList2[3]" :key="'linggou' + index2">
                                            <el-popover placement="right" :disabled="!item2.image" trigger="hover">
                                                <div class="previewImgBox">
                                                    <img class="previewImg" :src="item2.image" alt="" />
                                                    <div class="previewImgText">{{ item2.title }}</div>
                                                </div>
                                                <div class="myItem" slot="reference">
                                                    <div class="dianBox unActive" @click="openHintWin2">
                                                        <div class="dianActive"></div>
                                                    </div>
                                                    <div class="smallTitle">{{ item2.title }}</div>
                                                    <div class="selectNum">×{{ item2.num }}</div>
                                                </div>
                                            </el-popover>
                                        </div>
                                    </div>
                                    <div class="itemBoxM">
                                        <div class="selectBigFlexBox" v-for="(item, index) in hangList[4]" :key="index">
                                            <el-popover
                                                placement="right"
                                                :disabled="!item2.image"
                                                trigger="hover"
                                                v-for="(item2, index2) in hangList[4][index]"
                                            >
                                                <div class="previewImgBox">
                                                    <img class="previewImg" :src="item2.image" alt="" />
                                                    <div class="previewImgText">{{ item2.title }}</div>
                                                </div>
                                                <div class="myItem auto" slot="reference">
                                                    <div class="dianBox unActive" @click="openHintWin2">
                                                        <div class="dianActive"></div>
                                                    </div>
                                                    <div class="smallTitle">{{ item2.title }}</div>
                                                    <div class="selectNum">×{{ item2.num }}</div>
                                                </div>
                                            </el-popover>
                                        </div>
                                        <div class="selectBigFlexBox" v-for="(item2, index2) in hangList2[4]" :key="'linggo' + index2">
                                            <el-popover placement="right" :disabled="!item2.image" trigger="hover">
                                                <div class="previewImgBox">
                                                    <img class="previewImg" :src="item2.image" alt="" />
                                                    <div class="previewImgText">{{ item2.title }}</div>
                                                </div>
                                                <div class="myItem auto" slot="reference">
                                                    <div class="dianBox unActive" @click="openHintWin2">
                                                        <div class="dianActive"></div>
                                                    </div>
                                                    <div class="smallTitle">{{ item2.title }}</div>
                                                    <div class="selectNum">×{{ item2.num }}</div>
                                                </div>
                                            </el-popover>
                                        </div>
                                    </div>
                                    <div class="itemBoxM">
                                        <el-popover
                                            :disabled="!tongLeg.image"
                                            placement="right"
                                            trigger="hover"
                                            :open-delay="700"
                                            v-if="tongLeg.title"
                                        >
                                            <div class="previewImgBox">
                                                <img class="previewImg" :src="tongLeg.image" alt="" />
                                                <div class="previewImgText">{{ tongLeg.title }}</div>
                                            </div>
                                            <div class="selectBigFlexBox" slot="reference">
                                                <div class="selectflexTextBox">
                                                    <div class="dianBox unActive" @click="openHintWin3">
                                                        <div class="dianActive"></div>
                                                    </div>
                                                    <div class="title">{{ tongLeg.title }}</div>
                                                    <div class="num">×{{ tongLeg.num }}</div>
                                                </div>
                                            </div>
                                        </el-popover>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="commonLine"></div>

                        <!-- 鼓耳 -->
                        <div class="titleBox" v-if="!vuex_h5">
                            <div class="title">鼓耳</div>
                        </div>
                        <div class="flexWrapBox6" v-if="!vuex_h5">
                            <div class="switchBigBox">
                                <div class="item">底鼓</div>
                                <div class="item">军鼓</div>
                                <div class="item">嗵鼓</div>
                            </div>
                            <div class="flexBox">
                                <div class="flexItem">
                                    <el-select
                                        class="select"
                                        v-if="earList[1] && earList[1].length > 0"
                                        v-model="earObj[1]"
                                        placeholder="请选择底鼓鼓耳"
                                        @change="selectEar"
                                        :disabled="earList[1].length == 1"
                                    >
                                        <el-option v-for="(item2, index2) in earList[1]" :key="index2" :label="item2.title" :value="item2.id">
                                            <el-popover :disabled="!item2.image" placement="right" trigger="hover">
                                                <div class="previewImgBox">
                                                    <img class="previewImg" :src="item2.image" alt="" />
                                                    <div class="previewImgText">{{ item2.title }}</div>
                                                </div>
                                                <div class="item" slot="reference">
                                                    <div class="selectTitleFlexBox">
                                                        <div class="mySelectTitle">{{ item2.title }}</div>
                                                        <div class="mySelectNum">×{{ item2.num }}</div>
                                                    </div>
                                                </div>
                                            </el-popover>
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="flexItem">
                                    <el-popover
                                        :disabled="!item.image"
                                        placement="right"
                                        trigger="hover"
                                        v-for="(item, index) in earList[2]"
                                        :key="index"
                                        :open-delay="700"
                                    >
                                        <div class="previewImgBox">
                                            <img class="previewImg" :src="item.image" alt="" />
                                            <div class="previewImgText">{{ item.title }}</div>
                                        </div>
                                        <div class="item" slot="reference">
                                            <div class="lineFlexBox">
                                                <div
                                                    class="dianBox"
                                                    :class="{ active: earObj[2] == item.id, unActive: earList[2].length == 1 }"
                                                    @click="openHintWin4(earList[2].length == 1)"
                                                >
                                                    <div class="dianActive"></div>
                                                </div>
                                                <div class="title">{{ item.title }}</div>
                                            </div>
                                            <div class="num">×{{ item.num }}</div>
                                        </div>
                                    </el-popover>
                                </div>
                                <div class="flexItem">
                                    <el-popover
                                        :disabled="!item.image"
                                        placement="right"
                                        trigger="hover"
                                        v-for="(item, index) in earList[3]"
                                        :key="index"
                                        :open-delay="700"
                                    >
                                        <div class="previewImgBox">
                                            <img class="previewImg" :src="item.image" alt="" />
                                            <div class="previewImgText">{{ item.title }}</div>
                                        </div>
                                        <div class="item" slot="reference">
                                            <div class="lineFlexBox">
                                                <div
                                                    class="dianBox"
                                                    :class="{ active: earObj[3] == item.id, unActive: earList[3].length == 1 }"
                                                    @click="openHintWin4(earList[3].length == 1)"
                                                >
                                                    <div class="dianActive"></div>
                                                </div>
                                                <div class="title">{{ item.title }}</div>
                                            </div>
                                            <div class="num">×{{ item.num }}</div>
                                        </div>
                                    </el-popover>
                                </div>
                            </div>
                        </div>
                        <div class="commonLine"></div>
                    </div>

                    <!-- 鼓螺丝 && 响弦开关 && 响弦 -->
                    <div class="flexWrapBox8">
                        <el-row :gutter="30">
                            <el-col :span="8">
                                <div class="flexItem">
                                    <div class="titleBox">
                                        <div class="title">鼓螺丝</div>
                                    </div>
                                    <el-popover
                                        :disabled="!item.image"
                                        placement="right"
                                        trigger="hover"
                                        v-for="(item, index) in screwList"
                                        :key="index"
                                        :open-delay="700"
                                    >
                                        <div class="previewImgBox">
                                            <img class="previewImg" :src="item.image" alt="" />
                                            <div class="previewImgText">{{ item.title }}</div>
                                        </div>
                                        <div class="itemLineBox" slot="reference">
                                            <div class="dianBox unActive" @click="openHintWin6">
                                                <div class="dianActive"></div>
                                            </div>
                                            <div class="smallTitle">{{ item.title }}</div>
                                            <div class="selectNum">×{{ item.num }}</div>
                                        </div>
                                    </el-popover>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="titleBox">
                                    <div class="title">响弦开关</div>
                                </div>
                                <el-row :gutter="30">
                                    <el-col :span="12">
                                        <div class="centerItem" v-if="snareSwitchList.a.length > 0">
                                            <div class="title">{{ getJunSize() }}</div>
                                            <div class="title">A端</div>
                                            <el-popover
                                                :disabled="!item.image"
                                                placement="right"
                                                trigger="hover"
                                                v-for="(item, index) in snareSwitchList.a"
                                                :key="index"
                                                :open-delay="700"
                                            >
                                                <div class="previewImgBox">
                                                    <img class="previewImg" :src="item.image" alt="" />
                                                    <div class="previewImgText">{{ item.title }}</div>
                                                </div>
                                                <div class="item" slot="reference">
                                                    <div
                                                        class="dianBox"
                                                        @click="selectsnareSwitch(item, 'a')"
                                                        :class="{ active: snareSwitchObj.a == item.id }"
                                                    >
                                                        <div class="dianActive"></div>
                                                    </div>
                                                    <div class="smallTitle">{{ item.title }}</div>
                                                    <div class="selectNumBox">
                                                        <div class="del" @click="snareOnOffSwitch(2, 'a', item, index)">
                                                            <img src="@/assets/img/productList/jian.png" class="jianIcon" alt="" />
                                                        </div>
                                                        <div class="numInput">{{ item.num }}</div>
                                                        <div class="add" @click="snareOnOffSwitch(1, 'a', item, index)">
                                                            <img src="@/assets/img/productList/jia.png" class="jiaIcon" alt="" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </el-popover>
                                        </div>
                                    </el-col>
                                    <el-col :span="12">
                                        <div class="centerItem" v-if="snareSwitchList.b.length > 0">
                                            <div class="title" style="opacity: 0">12寸</div>
                                            <div class="title">B端</div>
                                            <el-popover
                                                :disabled="!item.image"
                                                placement="right"
                                                trigger="hover"
                                                v-for="(item, index) in snareSwitchList.b"
                                                :key="index"
                                                :open-delay="700"
                                            >
                                                <div class="previewImgBox">
                                                    <img class="previewImg" :src="item.image" alt="" />
                                                    <div class="previewImgText">{{ item.title }}</div>
                                                </div>
                                                <div class="item" slot="reference">
                                                    <div
                                                        class="dianBox"
                                                        @click="selectsnareSwitch(item, 'b')"
                                                        :class="{ active: snareSwitchObj.b == item.id }"
                                                    >
                                                        <div class="dianActive"></div>
                                                    </div>
                                                    <div class="smallTitle">{{ item.title }}</div>
                                                    <div class="selectNumBox">
                                                        <div class="del" @click="snareOnOffSwitch(2, 'b', item, index)">
                                                            <img src="@/assets/img/productList/jian.png" class="jianIcon" alt="" />
                                                        </div>
                                                        <div class="numInput">{{ item.num }}</div>
                                                        <div class="add" @click="snareOnOffSwitch(1, 'b', item, index)">
                                                            <img src="@/assets/img/productList/jia.png" class="jiaIcon" alt="" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </el-popover>
                                        </div>
                                    </el-col>
                                </el-row>
                                <div style="width: 100%; height: 10px" v-if="snareSwitchList2.a.length > 0"></div>
                                <el-row :gutter="30">
                                    <el-col :span="12">
                                        <div class="centerItem" v-if="snareSwitchList2.a.length > 0">
                                            <div class="title">{{ getJunSize('other') }}</div>
                                            <div class="title">A端</div>
                                            <el-popover
                                                :disabled="!item.image"
                                                placement="right"
                                                trigger="hover"
                                                v-for="(item, index) in snareSwitchList2.a"
                                                :key="index"
                                                :open-delay="700"
                                            >
                                                <div class="previewImgBox">
                                                    <img class="previewImg" :src="item.image" alt="" />
                                                    <div class="previewImgText">{{ item.title }}</div>
                                                </div>
                                                <div class="item" slot="reference">
                                                    <div
                                                        class="dianBox"
                                                        @click="selectsnareSwitch2(item, 'a')"
                                                        :class="{ active: snareSwitchObj2.a == item.id }"
                                                    >
                                                        <div class="dianActive"></div>
                                                    </div>
                                                    <div class="smallTitle">{{ item.title }}</div>
                                                    <div class="selectNumBox">
                                                        <div class="del" @click="snareOnOffSwitch2(2, 'a', item, index)">
                                                            <img src="@/assets/img/productList/jian.png" class="jianIcon" alt="" />
                                                        </div>
                                                        <div class="numInput">{{ item.num }}</div>
                                                        <div class="add" @click="snareOnOffSwitch2(1, 'a', item, index)">
                                                            <img src="@/assets/img/productList/jia.png" class="jiaIcon" alt="" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </el-popover>
                                        </div>
                                    </el-col>
                                    <el-col :span="12">
                                        <div class="centerItem" v-if="snareSwitchList2.b.length > 0">
                                            <div class="title" style="opacity: 0">12寸</div>
                                            <div class="title">B端</div>
                                            <el-popover
                                                :disabled="!item.image"
                                                placement="right"
                                                trigger="hover"
                                                v-for="(item, index) in snareSwitchList2.b"
                                                :key="index"
                                                :open-delay="700"
                                            >
                                                <div class="previewImgBox">
                                                    <img class="previewImg" :src="item.image" alt="" />
                                                    <div class="previewImgText">{{ item.title }}</div>
                                                </div>
                                                <div class="item" slot="reference">
                                                    <div
                                                        class="dianBox"
                                                        @click="selectsnareSwitch2(item, 'b')"
                                                        :class="{ active: snareSwitchObj2.b == item.id }"
                                                    >
                                                        <div class="dianActive"></div>
                                                    </div>
                                                    <div class="smallTitle">{{ item.title }}</div>
                                                    <div class="selectNumBox">
                                                        <div class="del" @click="snareOnOffSwitch2(2, 'b', item, index)">
                                                            <img src="@/assets/img/productList/jian.png" class="jianIcon" alt="" />
                                                        </div>
                                                        <div class="numInput">{{ item.num }}</div>
                                                        <div class="add" @click="snareOnOffSwitch2(1, 'b', item, index)">
                                                            <img src="@/assets/img/productList/jia.png" class="jiaIcon" alt="" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </el-popover>
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-col>
                            <el-col :span="8">
                                <div class="titleBox">
                                    <div class="title">响弦</div>
                                </div>
                                <div class="xianFlexBox">
                                    <div
                                        class="centerItem2"
                                        :class="{ justone: snareList2.length == 0 }"
                                        v-for="(item, index) in snareList"
                                        :key="index"
                                    >
                                        <div class="title">{{ item.title }}寸</div>
                                        <el-popover
                                            :disabled="!item2.image"
                                            placement="right"
                                            trigger="hover"
                                            v-for="(item2, index2) in item.list"
                                            :key="index2"
                                            :open-delay="700"
                                        >
                                            <div class="previewImgBox">
                                                <img class="previewImg" :src="item2.image" alt="" />
                                                <div class="previewImgText">{{ item2.title }}</div>
                                            </div>
                                            <div class="item" slot="reference">
                                                <div
                                                    class="dianBox"
                                                    :class="{ active: snareObj[index]['id'] == item2.id }"
                                                    @click="selectSnare(item2, index)"
                                                >
                                                    <div class="dianActive"></div>
                                                </div>
                                                <div class="smallTitle">{{ item2.title }}</div>
                                                <div class="selectNumBox">
                                                    <div class="del" @click="snareSwitch(2, item2, index, index2)">
                                                        <img src="@/assets/img/productList/jian.png" class="jianIcon" alt="" />
                                                    </div>
                                                    <div class="numInput">{{ item2.num }}</div>
                                                    <div class="add" @click="snareSwitch(1, item2, index, index2)">
                                                        <img src="@/assets/img/productList/jia.png" class="jiaIcon" alt="" />
                                                    </div>
                                                </div>
                                            </div>
                                        </el-popover>
                                    </div>
                                    <div class="centerItem2" v-for="(item, index) in snareList2" :key="'o' + index">
                                        <div class="title">{{ item.title }}寸</div>
                                        <el-popover
                                            :disabled="!item2.image"
                                            placement="right"
                                            trigger="hover"
                                            v-for="(item2, index2) in item.list"
                                            :key="index2"
                                            :open-delay="700"
                                        >
                                            <div class="previewImgBox">
                                                <img class="previewImg" :src="item2.image" alt="" />
                                                <div class="previewImgText">{{ item2.title }}</div>
                                            </div>
                                            <div class="item" slot="reference">
                                                <div
                                                    class="dianBox"
                                                    :class="{ active: snareObj2[index]['id'] == item2.id }"
                                                    @click="selectSnare2(item2, index)"
                                                >
                                                    <div class="dianActive"></div>
                                                </div>
                                                <div class="smallTitle">{{ item2.title }}</div>
                                                <div class="selectNumBox">
                                                    <div class="del" @click="snareSwitch2(2, item2, index, index2)">
                                                        <img src="@/assets/img/productList/jian.png" class="jianIcon" alt="" />
                                                    </div>
                                                    <div class="numInput">{{ item2.num }}</div>
                                                    <div class="add" @click="snareSwitch2(1, item2, index, index2)">
                                                        <img src="@/assets/img/productList/jia.png" class="jiaIcon" alt="" />
                                                    </div>
                                                </div>
                                            </div>
                                        </el-popover>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="commonLine"></div>

                    <!-- 底鼓腿 && 底鼓抓钩 && 鼓腔附属件表面工艺 -->
                    <div class="flexWrapBox9">
                        <el-row :gutter="30">
                            <el-col :span="8">
                                <div class="titleBox">
                                    <div class="title">底鼓腿</div>
                                </div>
                                <div class="centerItem" v-if="diLegList.length > 0">
                                    <el-popover
                                        :disabled="!item.image"
                                        placement="right"
                                        trigger="hover"
                                        v-for="(item, index) in diLegList"
                                        :open-delay="700"
                                    >
                                        <div class="previewImgBox">
                                            <img class="previewImg" :src="item.image" alt="" />
                                            <div class="previewImgText">{{ item.title }}</div>
                                        </div>
                                        <div class="item" slot="reference">
                                            <div class="dianBox" @click="selectDiLeg(item)" :class="{ active: diLegObj == item.id }">
                                                <div class="dianActive"></div>
                                            </div>
                                            <div class="smallTitle">{{ item.title }}</div>
                                            <div class="selectNum">×{{ item.num }}</div>
                                        </div>
                                    </el-popover>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="titleBox">
                                    <div class="title">底鼓抓钩</div>
                                </div>
                                <div class="centerItem">
                                    <el-popover
                                        :disabled="!item.image"
                                        placement="right"
                                        trigger="hover"
                                        v-for="(item, index) in grappleList"
                                        :key="index"
                                        :open-delay="700"
                                    >
                                        <div class="previewImgBox">
                                            <img class="previewImg" :src="item.image" alt="" />
                                            <div class="previewImgText">{{ item.title }}</div>
                                        </div>
                                        <div class="item" slot="reference">
                                            <div
                                                class="dianBox"
                                                :class="{ active: grappleObj == item.id, unActive: grappleList.length == 1 }"
                                                @click="selectGrapple(item, grappleList.length == 1)"
                                            >
                                                <div class="dianActive"></div>
                                            </div>
                                            <div class="smallTitle">{{ item.title }}</div>
                                            <div class="selectNum">×{{ item.num }}</div>
                                        </div>
                                    </el-popover>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="titleBox">
                                    <div class="title">鼓腔附属件表面工艺（默认镀铬）</div>
                                </div>
                                <div v-for="(item, index) in technologyList" :key="index">
                                    <el-popover
                                        :disabled="!item.image"
                                        v-if="item.title != '镀铬'"
                                        placement="right"
                                        trigger="hover"
                                        :open-delay="700"
                                    >
                                        <div class="previewImgBox">
                                            <img class="previewImg" :src="item.image" alt="" />
                                            <div class="previewImgText">{{ item.title }}</div>
                                        </div>
                                        <div class="newFlexBox" slot="reference">
                                            <div class="dianBox" :class="{ active: item.id == technologyObj }" @click="selectTechnology(item)">
                                                <div class="dianActive"></div>
                                            </div>
                                            <div class="smallTitle">{{ item.title }}</div>
                                            <div class="selectNum">×{{ item.num }}</div>
                                        </div>
                                    </el-popover>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="commonLine"></div>

                    <!-- 鼓皮 -->
                    <div class="titleBox">
                        <div class="title">鼓皮</div>
                    </div>
                    <div class="flexWrapBox2">
                        <div class="switchBigBox">
                            <div class="item" @click="switchSkin(1)" :class="{ active: skinListId == 1 }">底鼓皮</div>
                            <div class="item" @click="switchSkin(2)" :class="{ active: skinListId == 2 }">军鼓皮</div>
                            <div class="item" @click="switchSkin(3)" :class="{ active: skinListId == 3 }">嗵鼓皮</div>
                        </div>

                        <div class="gupiFlexBox" :class="{ start: skinListId == 1, center: skinListId == 2, end: skinListId == 3 }">
                            <div class="gupiWidthBox">
                                <div class="gupiWidthBox100" v-if="skinListId == 1 || skinListId == 2">
                                    <div
                                        class="selectLineBox"
                                        v-if="
                                            skinList[skinListId][index]['strike_arr'].length > 0 ||
                                            skinList[skinListId][index]['resonance_arr'].length > 0
                                        "
                                        v-for="(item, index) in skinList[skinListId]"
                                        :key="index"
                                    >
                                        <div class="item" v-show="skinList[skinListId][index]['strike_arr'].length > 0">
                                            <div class="orangeTitle">打击皮</div>
                                            <el-select
                                                class="select"
                                                v-model="skinObj[skinListId][index]['strike_arr']"
                                                placeholder="请选择打击皮"
                                                clearable
                                            >
                                                <el-option
                                                    v-for="(item2, index2) in skinList[skinListId][index]['strike_arr']"
                                                    :key="index2"
                                                    :label="item2.title"
                                                    :value="item2.id"
                                                >
                                                    <el-popover :disabled="!item2.image" placement="right" trigger="hover">
                                                        <div class="previewImgBox">
                                                            <img class="previewImg" :src="item2.image" alt="" />
                                                            <div class="previewImgText">{{ item2.title }}</div>
                                                        </div>
                                                        <div class="item" slot="reference">
                                                            <div class="selectTitleFlexBox">
                                                                <div class="mySelectTitle">{{ item2.title }}</div>
                                                                <div class="mySelectNum">×{{ item2.num }}</div>
                                                            </div>
                                                        </div>
                                                    </el-popover>
                                                </el-option>
                                            </el-select>
                                        </div>
                                        <div class="item" v-show="skinList[skinListId][index]['resonance_arr'].length > 0">
                                            <div class="orangeTitle">共鸣皮</div>
                                            <el-select
                                                class="select"
                                                v-model="skinObj[skinListId][index]['resonance_arr']"
                                                placeholder="请选择共鸣皮"
                                                clearable
                                            >
                                                <el-option
                                                    v-for="(item2, index2) in skinList[skinListId][index]['resonance_arr']"
                                                    :key="index2"
                                                    :label="item2.title"
                                                    :value="item2.id"
                                                >
                                                    <el-popover :disabled="!item2.image" placement="right" trigger="hover">
                                                        <div class="previewImgBox">
                                                            <img class="previewImg" :src="item2.image" alt="" />
                                                            <div class="previewImgText">{{ item2.title }}</div>
                                                        </div>
                                                        <div class="item" slot="reference">
                                                            <div class="selectTitleFlexBox">
                                                                <div class="mySelectTitle">{{ item2.title }}</div>
                                                                <div class="mySelectNum">×{{ item2.num }}</div>
                                                            </div>
                                                        </div>
                                                    </el-popover>
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="gupiWidthBox100" v-if="skinListId == 3">
                                    <!-- 嗵鼓皮 -->
                                    <div
                                        class="selectLineBox"
                                        v-if="skinList[3][index]['strike_arr'].length > 0 || skinList[3][index]['resonance_arr'].length > 0"
                                        v-for="(item, index) in skinList[3]"
                                        :key="'3' + index"
                                    >
                                        <div class="item" v-show="skinList[3][index]['strike_arr'].length > 0">
                                            <div class="orangeTitle">嗵鼓打击皮</div>
                                            <el-select
                                                class="select"
                                                @change="
                                                    (val) => {
                                                        skinSelectChange(val, '1')
                                                    }
                                                "
                                                :disabled="index > 0"
                                                v-model="skinObj[3][index]['strike_arr']"
                                                placeholder="请选择第一个嗵鼓打击皮"
                                            >
                                                <el-option
                                                    v-for="(item2, index2) in skinList[3][index]['strike_arr']"
                                                    :key="index2"
                                                    :label="item2.title"
                                                    :value="item2.id"
                                                >
                                                    <el-popover :disabled="!item2.image" placement="right" trigger="hover">
                                                        <div class="previewImgBox">
                                                            <img class="previewImg" :src="item2.image" alt="" />
                                                            <div class="previewImgText">{{ item2.title }}</div>
                                                        </div>
                                                        <div class="item" slot="reference">
                                                            <div class="selectTitleFlexBox">
                                                                <div class="mySelectTitle">{{ item2.title }}</div>
                                                                <div class="mySelectNum">×{{ item2.num }}</div>
                                                            </div>
                                                        </div>
                                                    </el-popover>
                                                </el-option>
                                            </el-select>
                                        </div>
                                        <div class="item" v-show="skinList[3][index]['resonance_arr'].length > 0">
                                            <div class="orangeTitle">嗵鼓共鸣皮</div>
                                            <el-select
                                                @change="
                                                    (val) => {
                                                        skinSelectChange(val, '2')
                                                    }
                                                "
                                                class="select"
                                                :disabled="index > 0"
                                                v-model="skinObj[3][index]['resonance_arr']"
                                                placeholder="请选择第一个嗵鼓共鸣皮"
                                            >
                                                <el-option
                                                    v-for="(item2, index2) in skinList[3][index]['resonance_arr']"
                                                    :key="index2"
                                                    :label="item2.title"
                                                    :value="item2.id"
                                                >
                                                    <el-popover :disabled="!item2.image" placement="right" trigger="hover">
                                                        <div class="previewImgBox">
                                                            <img class="previewImg" :src="item2.image" alt="" />
                                                            <div class="previewImgText">{{ item2.title }}</div>
                                                        </div>
                                                        <div class="item" slot="reference">
                                                            <div class="selectTitleFlexBox">
                                                                <div class="mySelectTitle">{{ item2.title }}</div>
                                                                <div class="mySelectNum">×{{ item2.num }}</div>
                                                            </div>
                                                        </div>
                                                    </el-popover>
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                    <!-- 落地嗵 -->
                                    <div
                                        class="selectLineBox"
                                        v-if="skinList[4][index]['strike_arr'].length > 0 || skinList[4][index]['resonance_arr'].length > 0"
                                        v-for="(item, index) in skinList[4]"
                                        :key="'4' + index"
                                    >
                                        <div class="item" v-show="skinList[4][index]['strike_arr'].length > 0">
                                            <div class="orangeTitle">落地嗵打击皮</div>
                                            <el-select
                                                disabled
                                                class="select"
                                                v-model="skinObj[4][index]['strike_arr']"
                                                placeholder="请选择第一个嗵鼓打击皮"
                                                clearable
                                            >
                                                <el-option
                                                    v-for="(item2, index2) in skinList[4][index]['strike_arr']"
                                                    :key="index2"
                                                    :label="item2.title"
                                                    :value="item2.id"
                                                >
                                                    <el-popover :disabled="!item2.image" placement="right" trigger="hover">
                                                        <div class="previewImgBox">
                                                            <img class="previewImg" :src="item2.image" alt="" />
                                                            <div class="previewImgText">{{ item2.title }}</div>
                                                        </div>
                                                        <div class="item" slot="reference">
                                                            <div class="selectTitleFlexBox">
                                                                <div class="mySelectTitle">{{ item2.title }}</div>
                                                                <div class="mySelectNum">×{{ item2.num }}</div>
                                                            </div>
                                                        </div>
                                                    </el-popover>
                                                </el-option>
                                            </el-select>
                                        </div>
                                        <div class="item" v-show="skinList[4][index]['resonance_arr'].length > 0">
                                            <div class="orangeTitle">落地嗵共鸣皮</div>
                                            <el-select
                                                class="select"
                                                disabled
                                                v-model="skinObj[4][index]['resonance_arr']"
                                                placeholder="请选择第一个嗵鼓共鸣皮"
                                                clearable
                                            >
                                                <el-option
                                                    v-for="(item2, index2) in skinList[4][index]['resonance_arr']"
                                                    :key="index2"
                                                    :label="item2.title"
                                                    :value="item2.id"
                                                >
                                                    <el-popover :disabled="!item2.image" placement="right" trigger="hover">
                                                        <div class="previewImgBox">
                                                            <img class="previewImg" :src="item2.image" alt="" />
                                                            <div class="previewImgText">{{ item2.title }}</div>
                                                        </div>
                                                        <div class="item" slot="reference">
                                                            <div class="selectTitleFlexBox">
                                                                <div class="mySelectTitle">{{ item2.title }}</div>
                                                                <div class="mySelectNum">×{{ item2.num }}</div>
                                                            </div>
                                                        </div>
                                                    </el-popover>
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                </div>

                                <!-- 另购-鼓皮 -->
                                <div class="gupiWidthBox100" v-if="skinListId == 1 || skinListId == 2">
                                    <div
                                        class="selectLineBox"
                                        v-if="
                                            (skinList2[skinListId] && skinList2[skinListId]['strike_arr'].length > 0) ||
                                            (skinList2[skinListId] && skinList2[skinListId]['resonance_arr'].length > 0)
                                        "
                                    >
                                        <div class="item" v-if="skinList2[skinListId] && skinList2[skinListId]['strike_arr'].length > 0">
                                            <div class="orangeTitle">打击皮</div>
                                            <el-select
                                                class="select"
                                                v-model="skinObj2[skinListId]['strike_arr']"
                                                placeholder="请选择打击皮"
                                                clearable
                                            >
                                                <el-option
                                                    v-for="(item2, index2) in skinList2[skinListId]['strike_arr']"
                                                    :key="index2"
                                                    :label="item2.title"
                                                    :value="item2.id"
                                                >
                                                    <el-popover :disabled="!item2.image" placement="right" trigger="hover">
                                                        <div class="previewImgBox">
                                                            <img class="previewImg" :src="item2.image" alt="" />
                                                            <div class="previewImgText">{{ item2.title }}</div>
                                                        </div>
                                                        <div class="item" slot="reference">
                                                            <div class="selectTitleFlexBox">
                                                                <div class="mySelectTitle">{{ item2.title }}</div>
                                                                <div class="mySelectNum">×{{ item2.num }}</div>
                                                            </div>
                                                        </div>
                                                    </el-popover>
                                                </el-option>
                                            </el-select>
                                        </div>
                                        <div class="item" v-if="skinList2[skinListId] && skinList2[skinListId]['resonance_arr'].length > 0">
                                            <div class="orangeTitle">共鸣皮</div>
                                            <el-select
                                                class="select"
                                                v-model="skinObj2[skinListId]['resonance_arr']"
                                                placeholder="请选择共鸣皮"
                                                clearable
                                            >
                                                <el-option
                                                    v-for="(item2, index2) in skinList2[skinListId]['resonance_arr']"
                                                    :key="index2"
                                                    :label="item2.title"
                                                    :value="item2.id"
                                                >
                                                    <el-popover :disabled="!item2.image" placement="right" trigger="hover">
                                                        <div class="previewImgBox">
                                                            <img class="previewImg" :src="item2.image" alt="" />
                                                            <div class="previewImgText">{{ item2.title }}</div>
                                                        </div>
                                                        <div class="item" slot="reference">
                                                            <div class="selectTitleFlexBox">
                                                                <div class="mySelectTitle">{{ item2.title }}</div>
                                                                <div class="mySelectNum">×{{ item2.num }}</div>
                                                            </div>
                                                        </div>
                                                    </el-popover>
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="gupiWidthBox100" v-if="skinListId == 3">
                                    <!-- 嗵鼓皮 -->
                                    <div
                                        class="selectLineBox"
                                        v-if="
                                            (skinList2[3] && skinList2[3]['strike_arr'] && skinList2[3]['strike_arr'].length > 0) ||
                                            (skinList2[3] && skinList2[3]['resonance_arr'] && skinList2[3]['resonance_arr'].length > 0)
                                        "
                                    >
                                        <div class="item" v-if="skinList2[3] && skinList2[3]['strike_arr'] && skinList2[3]['strike_arr'].length > 0">
                                            <div class="orangeTitle">嗵鼓打击皮</div>
                                            <el-select
                                                class="select"
                                                disabled
                                                v-model="skinObj2[3]['strike_arr']"
                                                placeholder="请选择第一个嗵鼓打击皮"
                                                clearable
                                            >
                                                <el-option
                                                    v-for="(item2, index2) in skinList2[3]['strike_arr']"
                                                    :key="index2"
                                                    :label="item2.title"
                                                    :value="item2.id"
                                                >
                                                    <el-popover :disabled="!item2.image" placement="right" trigger="hover">
                                                        <div class="previewImgBox">
                                                            <img class="previewImg" :src="item2.image" alt="" />
                                                            <div class="previewImgText">{{ item2.title }}</div>
                                                        </div>
                                                        <div class="item" slot="reference">
                                                            <div class="selectTitleFlexBox">
                                                                <div class="mySelectTitle">{{ item2.title }}</div>
                                                                <div class="mySelectNum">×{{ item2.num }}</div>
                                                            </div>
                                                        </div>
                                                    </el-popover>
                                                </el-option>
                                            </el-select>
                                        </div>
                                        <div
                                            class="item"
                                            v-if="skinList2[3] && skinList2[3]['resonance_arr'] && skinList2[3]['resonance_arr'].length > 0"
                                        >
                                            <div class="orangeTitle">嗵鼓共鸣皮</div>
                                            <el-select
                                                class="select"
                                                disabled
                                                v-model="skinObj2[3]['resonance_arr']"
                                                placeholder="请选择第一个嗵鼓共鸣皮"
                                                clearable
                                            >
                                                <el-option
                                                    v-for="(item2, index2) in skinList2[3]['resonance_arr']"
                                                    :key="index2"
                                                    :label="item2.title"
                                                    :value="item2.id"
                                                >
                                                    <el-popover :disabled="!item2.image" placement="right" trigger="hover">
                                                        <div class="previewImgBox">
                                                            <img class="previewImg" :src="item2.image" alt="" />
                                                            <div class="previewImgText">{{ item2.title }}</div>
                                                        </div>
                                                        <div class="item" slot="reference">
                                                            <div class="selectTitleFlexBox">
                                                                <div class="mySelectTitle">{{ item2.title }}</div>
                                                                <div class="mySelectNum">×{{ item2.num }}</div>
                                                            </div>
                                                        </div>
                                                    </el-popover>
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                    <!-- 落地嗵 -->
                                    <div
                                        class="selectLineBox"
                                        v-if="skinList2[4] && skinList2[4]['strike_arr'] && skinList2[4]['strike_arr'].length > 0"
                                    >
                                        <div class="item">
                                            <div class="orangeTitle">落地嗵打击皮</div>
                                            <el-select
                                                class="select"
                                                disabled
                                                v-model="skinObj2[4]['strike_arr']"
                                                placeholder="请选择第一个嗵鼓打击皮"
                                                clearable
                                            >
                                                <el-option
                                                    v-for="(item2, index2) in skinList2[4]['strike_arr']"
                                                    :key="index2"
                                                    :label="item2.title"
                                                    :value="item2.id"
                                                >
                                                    <el-popover :disabled="!item2.image" placement="right" trigger="hover">
                                                        <div class="previewImgBox">
                                                            <img class="previewImg" :src="item2.image" alt="" />
                                                            <div class="previewImgText">{{ item2.title }}</div>
                                                        </div>
                                                        <div class="item" slot="reference">
                                                            <div class="selectTitleFlexBox">
                                                                <div class="mySelectTitle">{{ item2.title }}</div>
                                                                <div class="mySelectNum">×{{ item2.num }}</div>
                                                            </div>
                                                        </div>
                                                    </el-popover>
                                                </el-option>
                                            </el-select>
                                        </div>
                                        <div
                                            class="item"
                                            v-if="skinList2[4] && skinList2[4]['resonance_arr'] && skinList2[4]['resonance_arr'].length > 0"
                                        >
                                            <div class="orangeTitle">落地嗵共鸣皮</div>
                                            <el-select
                                                class="select"
                                                disabled
                                                v-model="skinObj2[4]['resonance_arr']"
                                                placeholder="请选择第一个嗵鼓共鸣皮"
                                                clearable
                                            >
                                                <el-option
                                                    v-for="(item2, index2) in skinList2[4]['resonance_arr']"
                                                    :key="index2"
                                                    :label="item2.title"
                                                    :value="item2.id"
                                                >
                                                    <el-popover :disabled="!item2.image" placement="right" trigger="hover">
                                                        <div class="previewImgBox">
                                                            <img class="previewImg" :src="item2.image" alt="" />
                                                            <div class="previewImgText">{{ item2.title }}</div>
                                                        </div>
                                                        <div class="item" slot="reference">
                                                            <div class="selectTitleFlexBox">
                                                                <div class="mySelectTitle">{{ item2.title }}</div>
                                                                <div class="mySelectNum">×{{ item2.num }}</div>
                                                            </div>
                                                        </div>
                                                    </el-popover>
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="commonLine"></div>

                    <!-- 个性定制 -->
                    <div class="titleBox">
                        <div class="title">个性定制</div>
                    </div>
                    <div class="flexWrapBox3">
                        <div class="item">
                            <div class="uploadBigLine">
                                <div class="dianBox" @click="selectMade(1)" :class="{ active: madeType[1] }">
                                    <div class="dianActive"></div>
                                </div>
                                <div class="uploadIntroTitle" @click="uploadFun(1)">鼓腔个性铭牌定制</div>
                                <div class="redHintText" @click="uploadFun(1)">
                                    {{ uploadFileList[0] == '' ? '点击上传铭牌源文件（ai文件或pdf文件）' : '已上传' }}
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <div class="uploadBigLine">
                                <div class="dianBox" @click="selectMade(2)" :class="{ active: madeType[2] }">
                                    <div class="dianActive"></div>
                                </div>
                                <div class="uploadIntroTitle" @click="uploadFun(2)">共鸣皮个性图案定制</div>
                                <div class="redHintText" @click="uploadFun(2)">
                                    {{ uploadFileList[1] == '' ? '点击上传铭牌源文件（ai文件或pdf文件）' : '已上传' }}
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <div class="uploadBigLine">
                                <div class="dianBox" @click="selectMade(3)" :class="{ active: madeType[3] }">
                                    <div class="dianActive"></div>
                                </div>
                                <div class="uploadIntroTitle">
                                    底鼓压圈表面处理<span class="redHintText">（默认同鼓腔颜色，如定制其他颜色请联系客服）</span>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="kefuBtnYellow btn-ripple">
                            <div class="kefuText">联系客服</div>
                            <i class="el-icon-service"></i>
                        </div> -->
                    </div>
                    <div class="commonLine"></div>

                    <!-- 硬件配置 -->
                    <div class="titleBox">
                        <div class="title">硬件配置</div>
                    </div>
                    <div class="flexWrapBox10">
                        <div class="switchBigBox">
                            <div
                                class="item"
                                v-for="(item, index) in hardwareList"
                                :key="index"
                                @click="switchHardware(Number(index) + 1)"
                                :class="{ active: hardwareId == Number(index) + 1 }"
                            >
                                {{ item.title }}
                            </div>
                        </div>
                        <div class="myFlexBox" v-if="hardwareList[Number(hardwareId) - 1]">
                            <el-popover
                                :disabled="!item.image"
                                placement="right"
                                trigger="hover"
                                v-for="(item, index) in hardwareList[Number(hardwareId) - 1].child"
                                :key="index"
                                :open-delay="700"
                            >
                                <div class="previewImgBox">
                                    <img class="previewImg" :src="item.image" alt="" />
                                    <div class="previewImgText">{{ item.title }}</div>
                                </div>
                                <div class="item" slot="reference">
                                    <div class="dianBox" @click="selectHardWare(item, index)" :class="{ active: item.select == 1 }">
                                        <div class="dianActive"></div>
                                    </div>
                                    <div class="smallTitle">{{ item.title }}</div>
                                    <div class="selectNumBox">
                                        <div class="del" @click="delHardWare(item, index)">
                                            <img src="@/assets/img/productList/jian.png" class="jianIcon" alt="" />
                                        </div>
                                        <div class="numInput">{{ item.num }}</div>
                                        <div class="add" @click="addHardWare(item, index)">
                                            <img src="@/assets/img/productList/jia.png" class="jiaIcon" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </el-popover>
                        </div>
                    </div>
                    <el-button type="primary" class="bottomMyBtnBox" @click.stop="queryCheckList">保存</el-button>
                    <div class="fill60"></div>
                </div>
            </div>
        </div>

        <!-- 配置清单弹窗 -->
        <el-drawer :size="'600px'" :visible.sync="checklistWin" :with-header="false" class="checklistWin">
            <div class="drawerTitleBox">
                <div class="title">配置清单</div>
                <!-- <div class="barResetBtn btn-ripple" @click.stop="resetCheckList">
                    <div class="btnTitle">重置</div>
                    <img src="@/assets/img/productList/reset.png" class="resetIcon" alt="" />
                </div> -->
                <i class="el-icon-close winCloseImg" @click="checklistWin = false"></i>
            </div>
            <div class="drawerContentBox">
                <div class="scrollView">
                    <div class="drItem" v-for="(item, index) in queryForm" :key="index">
                        <div class="leftBox">
                            <div class="title">{{ item.title }}</div>
                        </div>
                        <div class="rightBox">
                            <div class="checkItemBox" v-for="(item2, index2) in item.child" :key="index2">
                                <div class="title">{{ item2.name }}{{ item.title == '鼓腔尺寸' ? 'B' : '' }}</div>
                                <div class="num">{{ item2.num }}</div>
                                <div class="money">
                                    <div v-if="item2.price">¥&nbsp{{ item2.price }}&nbsp元</div>
                                </div>
                                <!-- <div class="deleteBtn"></div> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="orangeLineBox"></div>
                <div class="countBigBox">
                    <div class="title">总价：</div>
                    <div class="money">￥{{ queryPrice }}</div>
                    <!-- <div class="changePriceBtn btn-ripple" >申请改价</div> -->
                </div>
                <div class="remarkBox">
                    <div class="title">备注</div>
                    <div class="textareaBox">
                        <textarea class="textarea" v-model="remark" cols="30" rows="10" placeholder="请输入您的备注信息"></textarea>
                    </div>
                </div>
                <div class="winHintBox">
                    <img src="@/assets/img/productList/icon.png" class="icon" alt="" />
                    <div class="hintText">
                        CUSTOM
                        私人定制鼓组，完全根据您的具体需求定制，具有独特性和专属性，生产订单一旦生成或完成，鼓组质量没问题，如您觉得音色不如您意，公司不予退货退款，但您享有公司优秀的售后服务。
                    </div>
                </div>
                <div class="drawerBottomBtnFlexBox">
                    <el-button class="btn btn-ripple" @click="formSub" type="primary">申请折扣</el-button>
                    <el-button class="btn2 btn-ripple" @click="kefuBtn">联系客服</el-button>
                </div>
            </div>
        </el-drawer>

        <!-- 查看配置清单 -->
        <div class="checklistBar" @click.stop="queryCheckList">
            <div class="barTitle">查看配置清单</div>
            <!-- <div class="barResetBtn btn-ripple" @click.stop="resetCheckList">
                <div class="btnTitle">重置</div>
                <img src="@/assets/img/productList/reset.png" class="resetIcon" alt="" />
            </div> -->
        </div>

        <input type="file" accept="*" @change="imgInputChange" style="position: fixed; top: 1000000px; left: 1000000px" ref="fileInput" />

        <el-dialog
            title="播放视频"
            custom-class="modal-custom"
            :close-on-click-modal="false"
            :visible.sync="videoWinShow"
            :before-close="onModalClose"
        >
            <div class="videoBox" v-if="videoUrl && videoWinShow">
                <ali-video ref="introVideo" :mediaUrl="videoUrl"></ali-video>
            </div>
        </el-dialog>

        <!-- 另购弹窗 -->
        <div class="otherWin" v-show="otherBuyWin">
            <div class="winBox">
                <div class="titleBox">
                    <div class="title">{{ otherWinTitle }}</div>
                    <i class="el-icon-close winCloseBtnI" @click="otherBuyWin = false"></i>
                </div>
                <div class="winContentScrollBox">
                    <div class="greyTitleBox" style="justify-content: center; text-align: center">
                        {{ otherWinTitle2 }}
                        <el-button v-if="otherNumMath > 0" type="danger" class="delOther" @click="delOther">删除</el-button>
                    </div>
                    <div class="winTitleComm">鼓腔材质</div>
                    <div class="caizhiBox">
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <div class="greyTitleBox">外层</div>
                                <div class="wrapBox">
                                    <el-popover
                                        :disabled="!item.image"
                                        v-for="(item, index) in materialLists.wai_arr"
                                        :key="item.id"
                                        placement="right"
                                        trigger="hover"
                                        :open-delay="700"
                                        v-if="item.title != '亚克力'"
                                    >
                                        <div class="previewImgBox">
                                            <img class="previewImg" :src="item.thumb" alt="" />
                                            <div class="previewImgText">{{ item.title }}</div>
                                        </div>
                                        <div class="item" slot="reference">
                                            <div class="title">{{ item.title }}</div>
                                            <div class="elImgBox">
                                                <img :src="item.thumb" class="img" alt="" />
                                            </div>
                                            <div class="bottomFlexBox">
                                                <div
                                                    class="selectBtn"
                                                    :class="{ active: materialObj2Show[otherBuyType].outside == item.id }"
                                                    @click="selectMaterial2(item, 1)"
                                                >
                                                    <div class="selectBtnActive"></div>
                                                </div>
                                                <div class="playVideoIcon" @click="showVideo(item)">
                                                    <div class="hintVideoText">音色视听</div>
                                                </div>
                                            </div>
                                        </div>
                                    </el-popover>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="greyTitleBox">内层</div>
                                <div class="wrapBox">
                                    <!-- <transition-group name="cell" tag="span" class="wrapBox"> -->
                                    <el-popover
                                        :disabled="!item.image"
                                        v-for="(item, index) in materialLists.nei_arr"
                                        :key="item.id"
                                        placement="right"
                                        trigger="hover"
                                        :open-delay="700"
                                        v-if="item.title != '亚克力'"
                                    >
                                        <div class="previewImgBox">
                                            <img class="previewImg" :src="item.thumb" alt="" />
                                            <div class="previewImgText">{{ item.title }}</div>
                                        </div>
                                        <div class="item" slot="reference">
                                            <div class="title">{{ item.title }}</div>
                                            <div class="elImgBox">
                                                <img :src="item.thumb" class="img" alt="" />
                                            </div>
                                            <div class="bottomFlexBox">
                                                <div
                                                    class="selectBtn"
                                                    :class="{ active: materialObj2Show[otherBuyType].inside == item.id }"
                                                    @click="selectMaterial2(item, 2)"
                                                >
                                                    <div class="selectBtnActive"></div>
                                                </div>
                                                <div class="recommend" v-if="item.is_recommend && item.is_recommend == 1">推荐</div>
                                                <!-- <div class="playVideoIcon" @click="showVideo(item)">
                                                    <div class="hintVideoText">音色视听</div>
                                                </div> -->
                                            </div>
                                        </div>
                                    </el-popover>
                                    <!-- </transition-group> -->
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="winTitleComm">鼓腔表面处理</div>
                    <div class="colorBox">
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <div class="greyTitleBox">烤漆</div>
                                <div class="flexWrapBox12ScrollBox" ref="scrollBoxWin">
                                    <el-popover
                                        :disabled="!item.image"
                                        v-for="(item, index) in colorLists.kq_arr"
                                        :key="item.id"
                                        placement="right"
                                        trigger="hover"
                                        :open-delay="700"
                                    >
                                        <div class="previewImgBox">
                                            <img class="previewImg" :src="item.thumb" alt="" />
                                            <div class="previewImgText">{{ item.title }}</div>
                                        </div>
                                        <div class="itemBox" slot="reference" :ref="'winColorBox' + index">
                                            <div class="title">{{ item.title }}</div>
                                            <div class="elImgBox">
                                                <img :src="item.thumb" class="img" alt="" />
                                            </div>
                                            <div class="bottomFlexBox">
                                                <div
                                                    class="selectBtn"
                                                    :class="{ active: item.id == colorListId2Show[otherBuyType] }"
                                                    @click="selectColor2(item)"
                                                >
                                                    <div class="selectBtnActive"></div>
                                                </div>
                                                <div class="recommend" v-if="item.is_recommend && item.is_recommend == 1">推荐</div>
                                            </div>
                                        </div>
                                    </el-popover>
                                </div>
                            </el-col>
                            <el-col :span="12" v-if="false">
                                <div class="greyTitleBox">PVC</div>
                                <div class="flexWrapBox12ScrollBox1-2" ref="scrollBoxWin2">
                                    <el-popover
                                        :disabled="!item.image"
                                        v-for="(item, index) in colorLists.pvc_arr"
                                        :key="item.id"
                                        placement="right"
                                        trigger="hover"
                                        :open-delay="700"
                                    >
                                        <div class="previewImgBox">
                                            <img class="previewImg" :src="item.thumb" alt="" />
                                            <div class="previewImgText">{{ item.title }}</div>
                                        </div>
                                        <div class="itemBox" slot="reference">
                                            <div class="title">{{ item.title }}</div>
                                            <div class="elImgBox">
                                                <img :src="item.thumb" class="img" alt="" />
                                            </div>
                                            <div class="bottomFlexBox">
                                                <div
                                                    class="selectBtn"
                                                    :class="{ active: item.id == colorListId2Show[otherBuyType] }"
                                                    @click="selectColor2(item)"
                                                >
                                                    <div class="selectBtnActive"></div>
                                                </div>
                                                <div class="recommend" v-if="item.is_recommend && item.is_recommend == 1">推荐</div>
                                            </div>
                                        </div>
                                    </el-popover>
                                </div>
                            </el-col>
                            <!-- <el-col :span="3">
                                <div class="greyTitleBox">亚克力</div>
                                <div class="flexWrapBox12ScrollBox2" ref="scrollBoxWin3">
                                    <el-popover
                                        :disabled="!item.image"
                                        v-for="(item, index) in colorLists.ykl_arr"
                                        :key="item.id"
                                        placement="right"
                                        trigger="hover"
                                        :open-delay="700"
                                    >
                                        <div class="previewImgBox">
                                            <img class="previewImg" :src="item.thumb" alt="" />
                                            <div class="previewImgText">{{ item.title }}</div>
                                        </div>
                                        <div class="itemBox" slot="reference">
                                            <div class="title">{{ item.title }}</div>
                                            <div class="elImgBox">
                                                <img :src="item.thumb" class="img" style="border: 1px solid #707070; box-sizing: border-box" alt="" />
                                            </div>
                                            <div class="bottomFlexBox">
                                                <div
                                                    class="selectBtn"
                                                    :class="{ active: item.id == colorListId2Show[otherBuyType] }"
                                                    @click="selectColor2(item)"
                                                >
                                                    <div class="selectBtnActive"></div>
                                                </div>
                                                <div class="recommend" v-if="item.is_recommend && item.is_recommend == 1">推荐</div>
                                            </div>
                                        </div>
                                    </el-popover>
                                </div>
                            </el-col> -->
                        </el-row>
                    </div>
                    <div class="winTitleComm">鼓腔尺寸</div>
                    <div class="winContentBox">
                        <el-row :gutter="30">
                            <el-col :span="8">
                                <div class="item">
                                    <div class="greyTitleBox">鼓腔直径</div>
                                    <div class="flexBox">
                                        <el-popover
                                            :disabled="!item.image"
                                            placement="right"
                                            trigger="hover"
                                            :open-delay="700"
                                            v-for="(item, index) in otherSizeList.diameter"
                                            :key="index"
                                        >
                                            <div class="previewImgBox">
                                                <img class="previewImg" :src="item.image" alt="" />
                                                <div class="previewImgText">{{ item.title }}</div>
                                            </div>
                                            <div class="flexItemBox" slot="reference">
                                                <div
                                                    class="dianBox"
                                                    :class="{ active: otherSizeObjShow[otherBuyType].diameter == item.id }"
                                                    @click="selectSize2(item, index, 'diameter')"
                                                >
                                                    <div class="dianActive"></div>
                                                </div>
                                                <div class="itemTitle">{{ item.title }}</div>
                                            </div>
                                        </el-popover>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="item">
                                    <div class="greyTitleBox">鼓腔深度</div>
                                    <div class="flexBox">
                                        <el-popover
                                            :disabled="!item.image"
                                            placement="right"
                                            trigger="hover"
                                            :open-delay="700"
                                            v-for="(item, index) in otherSizeList.depth"
                                            :key="index"
                                        >
                                            <div class="previewImgBox">
                                                <img class="previewImg" :src="item.image" alt="" />
                                                <div class="previewImgText">{{ item.title }}</div>
                                            </div>
                                            <div class="flexItemBox" slot="reference">
                                                <div
                                                    class="dianBox"
                                                    :class="{ active: otherSizeObjShow[otherBuyType].depth == item.id }"
                                                    @click="selectSize2(item, index, 'depth')"
                                                >
                                                    <div class="dianActive"></div>
                                                </div>
                                                <div class="itemTitle">{{ item.title }}</div>
                                            </div>
                                        </el-popover>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="item">
                                    <div class="greyTitleBox">钉数</div>
                                    <div class="flexBox">
                                        <el-popover
                                            :disabled="!item.image"
                                            placement="right"
                                            trigger="hover"
                                            :open-delay="700"
                                            v-for="(item, index) in otherSizeList.nail"
                                            :key="index"
                                        >
                                            <div class="previewImgBox">
                                                <img class="previewImg" :src="item.image" alt="" />
                                                <div class="previewImgText">{{ item.title }}</div>
                                            </div>
                                            <div class="flexItemBox" @click="selectSize2(item, index, 'nail')" slot="reference">
                                                <div
                                                    class="dianBox"
                                                    :class="{
                                                        active: otherSizeObjShow[otherBuyType].nail == item.id,
                                                        unActive: otherSizeList.nail.length == 1,
                                                    }"
                                                    @click="openHintWin5(otherSizeList.nail.length == 1)"
                                                >
                                                    <div class="dianActive"></div>
                                                </div>
                                                <div class="itemTitle">{{ item.title }}</div>
                                            </div>
                                        </el-popover>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
                <div class="bottomBtnBox">
                    <el-button class="subWinBtn" @click="saveOtherWin" type="primary">保存</el-button>
                </div>
            </div>
        </div>
        <HintTextWin ref="HintTextWin"></HintTextWin>

        <!-- 联系客服弹窗 -->
        <el-dialog title="联系客服" custom-class="modal-custom" :close-on-click-modal="false" :visible.sync="kefuWin">
            <img class="kefuImg" src="@/assets/img/kefu.jpg" alt="" />
        </el-dialog>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import pageBreadcrumb from '@/components/page/page-breadcrumb.vue'
import selectNum from '@/components/product/selectNum'
import selectCircle from '@/components/product/selectCircle'

import model_3d from '@/components/model/model_3d.vue'
import aliVideo from '@/components/aliVideo/aliVideo'

import HintTextWin from '@/components/model/HintWin'

import axios from 'axios'

export default {
    name: 'product-made',
    components: {
        pageBreadcrumb,
        selectNum,
        selectCircle,
        model_3d,
        aliVideo,
        HintTextWin,
    },
    data() {
        return {
            isH5: false,
            topVideoUrl: '', // 顶部要播放的视频

            kefuWin: false, // 客户二维码弹窗

            compress3d: true, // 3d模型是否压缩

            bannerList: [],

            videoWinShow: false,
            videoUrl: '',

            nav_option: [
                {
                    title: '首页',
                    path: '/',
                },
                {
                    title: '私人定制',
                    path: '',
                },
            ],
            checklistWin: false, // 配置清单弹窗

            // 鼓方案
            planeList: [], // 鼓方案
            planeObj: {}, // 选择方案
            planeColumn: 0, // 方案列下标
            supporterList: {
                title: [],
                list: [],
            }, // 支撑器数组
            supporterObj: '', // 支撑器选中id

            // 材质
            materialList: [], // 材质
            materialObj: {
                inside: '',
                outside: '',
            },

            // 颜色
            colorList: [], // 颜色
            colorListId: '', // 选中颜色id

            // 鼓尺寸
            sizeList: {}, // 鼓尺寸
            sizeObj: {}, // 鼓尺寸选中
            sizeListId: 1, // 选中鼓尺寸id：1.底鼓，2.军鼓，3.嗵鼓，4.落地嗵

            // 鼓压圈
            ringList: {}, // 鼓压圈
            ringObj: {}, // 鼓压圈选中

            // 悬挂系统
            hangList: {}, // 悬挂系统
            hangObj: {}, // 悬挂系统选中

            // 落地嗵腿
            tongLeg: {},

            // 鼓耳
            earList: [],
            earObj: {}, // 鼓耳选中

            // 鼓螺丝
            screwList: [], // 鼓螺丝

            // 响弦开关
            snareSwitchList: {
                a: [],
                b: [],
            },
            snareSwitchObj: {
                a: '',
                b: '',
            },

            // 响弦
            snareList: [],
            snareObj: [],

            // 底鼓腿
            diLegList: [],
            diLegObj: '',

            // 底鼓抓钩
            grappleList: [],
            grappleObj: '',

            // 工艺
            technologyList: [],
            technologyObj: '',

            // 鼓皮
            skinList: {}, // 鼓皮
            skinObj: {}, // 鼓皮选中
            skinListId: 1, // 鼓皮选中id：1.底鼓，2.军鼓，3.嗵鼓

            // 铭牌定制上传
            madeType: {
                1: false,
                2: false,
                3: false,
            }, // 1.鼓腔个性铭牌定制，2.共鸣皮个性铭牌定制，3.底鼓压圈表面处理
            inputType: 0, // 上传类型：1.鼓腔，2.共鸣皮
            uploadFileList: ['', ''], // 上传定制文件，0.鼓腔个性铭牌，1.共鸣皮个性铭牌

            // 硬件配置
            hardwareList: [],
            hardwareId: 1,

            // 查看清单
            queryForm: [],
            queryPrice: '--',

            remark: '', // 备注

            // ------另购------
            otherBuyWin: false, // 另购鼓弹窗：0.关闭，1.开启
            otherBuyType: 1, // 另购鼓状态：1.底鼓，2.军鼓，3.嗵鼓，4.落地嗵
            otherSizeList: {
                diameter: [],
                depth: [],
                nail: [],
            }, // 另购-鼓尺寸
            otherSizeObjShow: {
                1: {},
                2: {},
                3: {},
                4: {},
            }, // 另购-鼓尺寸选中
            otherSizeObj: {
                1: {},
                2: {},
                3: {},
                4: {},
            }, // 另购-鼓尺寸选中
            another_heaving_floor: 0, // 底鼓数量
            another_military: 0, // 军鼓数量
            another_tom: 0, // 嗵鼓数量
            another_landing_punch: 0, // 落地嗵数量

            materialList2: [], // 材质
            colorList2: [], // 颜色

            materialList3: [], // 材质
            colorList3: [], // 颜色

            materialList4: [], // 材质
            colorList4: [], // 颜色

            materialList5: [], // 材质
            colorList5: [], // 颜色

            // 内外层材质
            materialObj2Show: {
                1: {
                    inside: '',
                    outside: '',
                },
                2: {
                    inside: '',
                    outside: '',
                },
                3: {
                    inside: '',
                    outside: '',
                },
                4: {
                    inside: '',
                    outside: '',
                },
            },
            materialObj2: {
                1: {
                    inside: '',
                    outside: '',
                },
                2: {
                    inside: '',
                    outside: '',
                },
                3: {
                    inside: '',
                    outside: '',
                },
                4: {
                    inside: '',
                    outside: '',
                },
            },

            // 选中颜色
            colorListId2Show: {
                1: '',
                2: '',
                3: '',
                4: '',
            },
            colorListId2: {
                1: '',
                2: '',
                3: '',
                4: '',
            },

            // 响弦
            snareList2: [],
            snareObj2: [],

            // 鼓皮
            skinList2: {
                1: {
                    resonance_arr: [],
                    strike_arr: [],
                },
                2: {
                    resonance_arr: [],
                    strike_arr: [],
                },
                3: {
                    resonance_arr: [],
                    strike_arr: [],
                },
                4: {
                    resonance_arr: [],
                    strike_arr: [],
                },
            }, // 鼓皮
            skinObj2: {
                1: {
                    resonance_arr: '',
                    strike_arr: '',
                },
                2: {
                    resonance_arr: '',
                    strike_arr: '',
                },
                3: {
                    resonance_arr: '',
                    strike_arr: '',
                },
                4: {
                    resonance_arr: '',
                    strike_arr: '',
                },
            }, // 鼓皮选中

            // 鼓压圈
            ringList2: {
                2: [],
                3: [],
                4: [],
            }, // 鼓压圈
            ringObj2: {
                2: '',
                3: '',
                4: '',
            }, // 鼓压圈选中

            // 悬挂系统
            hangList2: {
                3: [],
                4: [],
            }, // 悬挂系统
            hangObj2: {
                3: '',
                4: '',
            }, // 悬挂系统选中

            // 响弦开关
            snareSwitchList2: {
                a: [],
                b: [],
            },
            snareSwitchObj2: {
                a: '',
                b: '',
            },

            caizhiName: '',
            yanseName: '',

            mathHeightTimer: null,

            modelUrl: '',
        }
    },
    computed: {
        ...mapState(['vuex_is_login']),
        // 响弦开关获取军鼓尺寸
        getJunSize() {
            return (type) => {
                if (type == 'other') {
                    // 获取另购鼓
                    let list = this.sizeList[2][0]['diameter']
                    let id = this.otherSizeObj[2]['diameter']
                    for (let i = 0; i < list.length; i++) {
                        let item = list[i]
                        if (item.id == id) {
                            return item.title + '寸'
                        }
                    }
                    return ''
                } else {
                    // 获取普通鼓
                    let list = this.sizeList[2][0]['diameter']
                    let id = this.sizeObj[2][0]['diameter']
                    for (let i = 0; i < list.length; i++) {
                        let item = list[i]
                        if (item.id == id) {
                            return item.title + '寸'
                        }
                    }
                    return ''
                }
            }
        },
        supportIsActive() {
            return (id) => {
                if ((id == 28 || id == 27) && (this.supporterObj == 28 || this.supporterObj == 27)) {
                    return true
                } else if (id == this.supporterObj) {
                    return true
                } else {
                    return false
                }
            }
        },
        materialLists() {
            if (this.otherBuyType == 1) {
                return this.materialList2
            } else if (this.otherBuyType == 2) {
                return this.materialList3
            } else if (this.otherBuyType == 3) {
                return this.materialList4
            } else if (this.otherBuyType == 4) {
                return this.materialList5
            }
        },
        colorLists() {
            if (this.otherBuyType == 1) {
                return this.colorList2
            } else if (this.otherBuyType == 2) {
                return this.colorList3
            } else if (this.otherBuyType == 3) {
                return this.colorList4
            } else if (this.otherBuyType == 4) {
                return this.colorList5
            }
        },
        otherNumMath() {
            let type = this.otherBuyType
            if (type == 1) {
                // 底鼓
                return this.another_heaving_floor
            } else if (type == 2) {
                // 军鼓
                return this.another_military
            } else if (type == 3) {
                // 嗵鼓
                return this.another_tom
            } else if (type == 4) {
                // 落地嗵
                return this.another_landing_punch
            }
        },
        otherWinTitle() {
            let type = this.otherBuyType
            if (type == 1) {
                // 底鼓
                return '底鼓另购'
            } else if (type == 2) {
                // 军鼓
                return '军鼓另购'
            } else if (type == 3) {
                // 嗵鼓
                return '嗵鼓另购'
            } else if (type == 4) {
                // 落地嗵
                return '落地嗵另购'
            }
        },
        otherWinTitle2() {
            let type = this.otherBuyType
            if (type == 1) {
                // 底鼓
                return '底鼓'
            } else if (type == 2) {
                // 军鼓
                return '军鼓'
            } else if (type == 3) {
                // 嗵鼓
                return '嗵鼓'
            } else if (type == 4) {
                // 落地嗵
                return '落地嗵'
            }
        },
    },
    beforeDestroy() {
        if (this.mathHeightTimer) {
            clearInterval(this.mathHeightTimer)
            this.mathHeightTimer = null
        }
    },
    watch: {
        checklistWin(newV) {
            if (newV) {
                if (this.madeType[1] && this.uploadFileList[0] == '' && this.madeType[2] && this.uploadFileList[1] == '') {
                    // this.$alert('请上传鼓腔个性铭牌/共鸣皮个性图案源文件！', '提示', {
                    //     confirmButtonText: '确定',
                    //     callback: (action) => {
                    //         this.checklistWin = false
                    //     },
                    // })
                    this.$refs['HintTextWin'].init('请上传鼓腔个性铭牌/共鸣皮个性图案源文件！')
                } else if (this.madeType[1] && this.uploadFileList[0] == '') {
                    // this.$alert('请上传鼓腔个性铭牌源文件！', '提示', {
                    //     confirmButtonText: '确定',
                    //     callback: (action) => {
                    //         this.checklistWin = false
                    //     },
                    // })
                    this.$refs['HintTextWin'].init('请上传鼓腔个性铭牌源文件！')
                } else if (this.madeType[2] && this.uploadFileList[1] == '') {
                    // this.$alert('请上传共鸣皮个性图案源文件！', '提示', {
                    //     confirmButtonText: '确定',
                    //     callback: (action) => {
                    //         this.checklistWin = false
                    //     },
                    // })
                    this.$refs['HintTextWin'].init('请上传共鸣皮个性图案源文件！')
                }
            }
        },
    },
    created() {
        // this.isH5 = this.mix_isH5()
        if (this.isH5) {
            this.$api('index_config').then((res) => {
                if (res.data) {
                    this.topVideoUrl = res.data.videoUrl
                }
            })
        }
        window.addEventListener('touchmove', function () {
            // if(this.vuex_h5){
            var myElement = document.querySelectorAll('div[role="tooltip"]')
            myElement.forEach((e) => {
                e.style.display = 'none'
            })
            // }
        })
    },
    async mounted() {
        this.mathColorHeight()
        this.getBanner()
        this.$load.open()
        setTimeout(async () => {
            if (this.vuex_is_login) {
                let res = await this.getDraftAjax({
                    version: this.$store.state.vuex_config.version,
                })
                if (res && res.code == 200 && res.data) {
                    let data = res.data
                    if (data.info && data.info != 'undefined') {
                        let newData = JSON.parse(data.info)
                        for (let k in newData) {
                            let v = newData[k]
                            this[k] = v
                        }
                        this.$load.close()
                        if (!this.isH5) {
                            this.$load.open()
                            await this.$refs['model_3d'].loadNewModel(this.modelUrl) // 切换模型
                            await this.get3dData() // 给新模型渲染颜色和材质
                            this.$refs['model_3d'].changeTop(this.planeObj.id)
                            this.$load.close()
                        }
                        return
                    }
                }
            }
            await Promise.all([
                this.getDrumPlaneLists(),
                this.getDrumMaterialLists(),
                this.getDrumColorLists(),
                // this.getDrumHardwareLists(),
                this.drumSupporterLists(),
            ])
            this.$load.close()
        }, 500)
    },
    methods: {
        // 私人定制操作方案
        hintTextWin() {
            this.$refs['HintTextWin'].init(
                '定制选项基本操作：从上到下，从左到右。<br />鼠标指针放在3D图展示区域，长按鼠标左键并移动，可旋转3D展示图。<br />拨动鼠标滚轮，可放大或缩小3D展示图。<br />长按Ctrl + 鼠标左键不放，在展示区域拖动鼠标，可移动鼓组位置。'
            )
            // this.$alert(
            //     '定制选项基本操作：从上到下，从左到右。<br />鼠标指针放在3D图展示区域，长按鼠标左键并移动，可旋转3D展示图。<br />拨动鼠标滚轮，可放大或缩小3D展示图。<br />长按Ctrl + 鼠标左键不放，在展示区域拖动鼠标，可移动鼓组位置。',
            //     '提示',
            //     {
            //         confirmButtonText: '确定',
            //         dangerouslyUseHTMLString: true,
            //         callback: (action) => {},
            //     }
            // )
        },
        // 鼓压圈提示弹窗
        openHintWin() {
            // this.$alert('选择军鼓鼓压圈后，嗵鼓/落地嗵鼓压圈自动生成，无需重复选择。', '提示', {
            //     confirmButtonText: '确定',
            //     callback: (action) => {},
            // })
            this.$refs['HintTextWin'].init('选择军鼓鼓压圈后，嗵鼓/落地嗵鼓压圈自动生成，无需重复选择。')
        },
        // 悬挂系统提示弹窗
        openHintWin2() {
            // this.$alert('选择第一个嗵鼓悬挂系统后，嗵鼓/落地嗵悬挂系统自动生成，无需重复选择。', '提示', {
            //     confirmButtonText: '确定',
            //     callback: (action) => {},
            // })
            this.$refs['HintTextWin'].init('选择第一个嗵鼓悬挂系统后，嗵鼓/落地嗵悬挂系统自动生成，无需重复选择。')
        },
        // 落地嗵腿提示弹窗
        openHintWin3() {
            // this.$alert('落地嗵腿自动生成，无需重复选择。', '提示', {
            //     confirmButtonText: '确定',
            //     callback: (action) => {},
            // })
            this.$refs['HintTextWin'].init('落地嗵腿自动生成，无需重复选择。')
        },
        // 鼓耳提示弹窗
        openHintWin4(bol) {
            if (bol) {
                // this.$alert('选择底鼓鼓耳后，军鼓/嗵鼓鼓耳自动生成，无需重复选择。', '提示', {
                //     confirmButtonText: '确定',
                //     callback: (action) => {},
                // })
                this.$refs['HintTextWin'].init('选择底鼓鼓耳后，军鼓/嗵鼓鼓耳自动生成，无需重复选择。')
            }
        },
        // 钉数提示弹窗
        openHintWin5(bol) {
            if (bol) {
                // this.$alert('钉数已根据鼓腔直径和鼓腔深度自动生成，无需重复选择。', '提示', {
                //     confirmButtonText: '确定',
                //     callback: (action) => {},
                // })
                this.$refs['HintTextWin'].init('钉数已根据鼓腔直径和鼓腔深度自动生成，无需重复选择。')
            }
        },
        // 鼓螺丝提示弹窗
        openHintWin6() {
            // this.$alert('鼓螺丝自动生成，无需重复选择。', '提示', {
            //     confirmButtonText: '确定',
            //     callback: (action) => {},
            // })
            this.$refs['HintTextWin'].init('鼓螺丝自动生成，无需重复选择。')
        },
        // 选择底鼓鼓耳，获取嗵鼓和落地嗵的鼓耳
        selectEar() {
            this.getEar('other')
        },
        async getBanner() {
            let res = await this.bannerIndexAjax()
            if (res && res.code == 200) {
                for (let i = 0; i < res.data.length; i++) {
                    let item = res.data[i]
                    if (item.id == 179) {
                        this.bannerList = item.images
                        break
                    }
                }
            }
        },
        bannerIndexAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'banner_index',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        async skinSelectChange(val, type) {
            this.checkOtherSelect()
            if (type == 1) {
                // 获取嗵鼓剩下的打击皮
                for (let i = 0; i < this.sizeObj[3].length; i++) {
                    let item = this.sizeObj[3][i]
                    if (item.diameter && i > 0) {
                        let res = await this.drumSkinLists({
                            diameter_id: item.diameter,
                            skin_id: val,
                        })
                        if (res && res.code == 200) {
                            let data = res.data
                            let skinList = this.$cloneDeep(this.skinList)
                            let skinObj = this.$cloneDeep(this.skinObj)
                            skinList[3][i]['strike_arr'] = data.list['strike_arr']
                            skinObj[3][i]['strike_arr'] = data.list['strike_arr'][0].id
                            this.skinList = skinList
                            this.skinObj = skinObj
                        }
                    }
                }

                // 获取另购嗵鼓打击皮
                if (this.another_tom == 1) {
                    let obj3 = {
                        diameter_id: this.otherSizeObj[3]['diameter'],
                        skin_id: val,
                    }
                    let res3 = await this.drumSkinLists(obj3)
                    if (res3 && res3.code == 200) {
                        let data = res3.data
                        let skinList2 = this.$cloneDeep(this.skinList2)
                        let skinObj2 = this.$cloneDeep(this.skinObj2)
                        skinList2[3]['strike_arr'] = data.list['strike_arr']
                        skinObj2[3]['strike_arr'] = data.list['strike_arr'][0].id
                        this.skinList2 = skinList2
                        this.skinObj2 = skinObj2
                    }
                }

                // 获取落地嗵剩下的鼓皮
                for (let i = 0; i < this.sizeObj[4].length; i++) {
                    let item = this.sizeObj[4][i]
                    if (item.diameter) {
                        let res = await this.drumSkinLists({
                            diameter_id: item.diameter,
                            gl_id: val,
                        })
                        if (res && res.code == 200) {
                            let data = res.data
                            let skinList = this.$cloneDeep(this.skinList)
                            let skinObj = this.$cloneDeep(this.skinObj)
                            skinList[4][i]['strike_arr'] = data.list['strike_arr']
                            skinObj[4][i]['strike_arr'] = data.list['strike_arr'][0].id
                            this.skinList = skinList
                            this.skinObj = skinObj
                        }
                    }
                }

                // 获取另购落地嗵鼓皮
                if (this.another_landing_punch == 1) {
                    let obj3 = {
                        diameter_id: this.otherSizeObj[4]['diameter'],
                        gl_id: val,
                    }
                    let res3 = await this.drumSkinLists(obj3)
                    if (res3 && res3.code == 200) {
                        let data = res3.data
                        let skinList2 = this.$cloneDeep(this.skinList2)
                        let skinObj2 = this.$cloneDeep(this.skinObj2)
                        skinList2[4]['strike_arr'] = data.list['strike_arr']
                        skinObj2[4]['strike_arr'] = data.list['strike_arr'][0].id
                        this.skinList2 = skinList2
                        this.skinObj2 = skinObj2
                    }
                }
            } else {
                // 获取嗵鼓剩下的共鸣皮
                for (let i = 0; i < this.sizeObj[3].length; i++) {
                    let item = this.sizeObj[3][i]
                    if (item.diameter && i > 0) {
                        let res = await this.drumSkinLists({
                            diameter_id: item.diameter,
                            skin_id: val,
                        })
                        if (res && res.code == 200) {
                            let data = res.data
                            let skinList = this.$cloneDeep(this.skinList)
                            let skinObj = this.$cloneDeep(this.skinObj)
                            skinList[3][i]['resonance_arr'] = data.list['resonance_arr']
                            skinObj[3][i]['resonance_arr'] = data.list['resonance_arr'][0].id
                            this.skinList = skinList
                            this.skinObj = skinObj
                        }
                    }
                }

                // 获取另购嗵鼓鼓皮
                if (this.another_tom == 1) {
                    let obj3 = {
                        diameter_id: this.otherSizeObj[3]['diameter'],
                        skin_id: val,
                    }
                    let res3 = await this.drumSkinLists(obj3)
                    if (res3 && res3.code == 200) {
                        let data = res3.data
                        let skinList2 = this.$cloneDeep(this.skinList2)
                        let skinObj2 = this.$cloneDeep(this.skinObj2)
                        skinList2[3]['resonance_arr'] = data.list['resonance_arr']
                        skinObj2[3]['resonance_arr'] = data.list['resonance_arr'][0].id
                        this.skinList2 = skinList2
                        this.skinObj2 = skinObj2
                    }
                }

                // 获取落地嗵剩下的共鸣皮
                for (let i = 0; i < this.sizeObj[4].length; i++) {
                    let item = this.sizeObj[4][i]
                    if (item.diameter) {
                        let res = await this.drumSkinLists({
                            diameter_id: item.diameter,
                            gl_id: val,
                        })
                        if (res && res.code == 200) {
                            let data = res.data
                            let skinList = this.$cloneDeep(this.skinList)
                            let skinObj = this.$cloneDeep(this.skinObj)
                            skinList[4][i]['resonance_arr'] = data.list['resonance_arr']
                            skinObj[4][i]['resonance_arr'] = data.list['resonance_arr'][0].id
                            this.skinList = skinList
                            this.skinObj = skinObj
                        }
                    }
                }

                // 获取另购落地嗵鼓皮
                if (this.another_landing_punch == 1) {
                    let obj3 = {
                        diameter_id: this.otherSizeObj[4]['diameter'],
                        gl_id: val,
                    }
                    let res3 = await this.drumSkinLists(obj3)
                    if (res3 && res3.code == 200) {
                        let data = res3.data
                        let skinList2 = this.$cloneDeep(this.skinList2)
                        let skinObj2 = this.$cloneDeep(this.skinObj2)
                        skinList2[4]['resonance_arr'] = data.list['resonance_arr']
                        skinObj2[4]['resonance_arr'] = data.list['resonance_arr'][0].id
                        this.skinList2 = skinList2
                        this.skinObj2 = skinObj2
                    }
                }
            }
        },
        // 获取鼓皮
        async getDrumSkinList() {
            return new Promise(async (resolve, reject) => {
                this.checkOtherSelect()
                this.skinObjInit()

                // 标准鼓
                // 获取底鼓皮
                for (let i = 0; i < this.sizeObj[1].length; i++) {
                    let item = this.sizeObj[1][i]
                    if (item.diameter) {
                        let res = await this.drumSkinLists({
                            diameter_id: item.diameter,
                        })
                        if (res && res.code == 200) {
                            let data = res.data
                            let skinList = this.$cloneDeep(this.skinList)
                            let skinObj = this.$cloneDeep(this.skinObj)
                            skinList[1][i] = data.list
                            skinObj[1][i] = {
                                strike_arr: '',
                                resonance_arr: '',
                            }
                            this.skinList = skinList
                            this.skinObj = skinObj
                        }
                    }
                }

                // 获取军鼓皮
                for (let i = 0; i < this.sizeObj[2].length; i++) {
                    let item = this.sizeObj[2][i]
                    if (item.diameter) {
                        let res = await this.drumSkinLists({
                            diameter_id: item.diameter,
                        })
                        if (res && res.code == 200) {
                            let data = res.data
                            let skinList = this.$cloneDeep(this.skinList)
                            let skinObj = this.$cloneDeep(this.skinObj)
                            skinList[2][i] = data.list
                            skinObj[2][i] = {
                                strike_arr: '',
                                resonance_arr: '',
                            }
                            this.skinList = skinList
                            this.skinObj = skinObj
                        }
                    }
                }

                // 获取第一个嗵鼓皮
                if (this.sizeObj[3][0] && this.sizeObj[3][0].diameter) {
                    let diameter = this.sizeObj[3][0].diameter
                    let res = await this.drumSkinLists({
                        diameter_id: diameter,
                    })
                    if (res && res.code == 200) {
                        let data = res.data
                        let skinList = this.$cloneDeep(this.skinList)
                        let skinObj = this.$cloneDeep(this.skinObj)
                        skinList[3][0] = data.list
                        skinObj[3][0] = {
                            strike_arr: '',
                            resonance_arr: '',
                        }
                        this.skinList = skinList
                        this.skinObj = skinObj
                    }
                }
                // for (let i = 0; i < this.sizeObj[3].length; i++) {
                //     let item = this.sizeObj[3][i]
                //     if (item.diameter) {
                //         let res = await this.drumSkinLists({
                //             diameter_id: item.diameter,
                //         })
                //         if (res && res.code == 200) {
                //             let data = res.data
                //             let skinList = this.$cloneDeep(this.skinList)
                //             let skinObj = this.$cloneDeep(this.skinObj)
                //             skinList[3][i] = data.list
                //             skinObj[3][i] = {
                //                 strike_arr: '',
                //                 resonance_arr: '',
                //             }
                //             this.skinList = skinList
                //             this.skinObj = skinObj
                //         }
                //     }
                // }

                // 获取落地嗵皮（和嗵鼓放一起）
                // for (let i = 0; i < this.sizeObj[4].length; i++) {
                //     let item = this.sizeObj[4][i]
                //     if (item.diameter) {
                //         let res = await this.drumSkinLists({
                //             diameter_id: item.diameter,
                //         })
                //         if (res && res.code == 200) {
                //             let data = res.data
                //             let skinList = this.$cloneDeep(this.skinList)
                //             let skinObj = this.$cloneDeep(this.skinObj)
                //             skinList[4][i] = data.list
                //             skinObj[4][i] = {
                //                 strike_arr: '',
                //                 resonance_arr: '',
                //             }
                //             this.skinList = skinList
                //             this.skinObj = skinObj
                //         }
                //     }
                // }

                // 另购鼓
                // 获取底鼓皮
                if (this.another_heaving_floor == 1) {
                    let obj3 = {
                        diameter_id: this.otherSizeObj[1]['diameter'],
                    }
                    let res3 = await this.drumSkinLists(obj3)
                    if (res3 && res3.code == 200) {
                        let data = res3.data
                        let skinList2 = this.$cloneDeep(this.skinList2)
                        let skinObj2 = this.$cloneDeep(this.skinObj2)
                        skinList2[1] = data.list
                        skinObj2[1] = {
                            strike_arr: '',
                            resonance_arr: '',
                        }
                        this.skinList2 = skinList2
                        this.skinObj2 = skinObj2
                    }
                }

                // 获取军鼓皮
                if (this.another_military == 1) {
                    let obj3 = {
                        diameter_id: this.otherSizeObj[2]['diameter'],
                    }
                    let res3 = await this.drumSkinLists(obj3)
                    if (res3 && res3.code == 200) {
                        let data = res3.data
                        let skinList2 = this.$cloneDeep(this.skinList2)
                        let skinObj2 = this.$cloneDeep(this.skinObj2)
                        skinList2[2] = data.list
                        skinObj2[2] = {
                            strike_arr: '',
                            resonance_arr: '',
                        }
                        this.skinList2 = skinList2
                        this.skinObj2 = skinObj2
                    }
                }

                // 获取嗵鼓皮
                // if (this.another_tom == 1) {
                //     let obj3 = {
                //         diameter_id: this.otherSizeObj[3]['diameter'],
                //     }
                //     let res3 = await this.drumSkinLists(obj3)
                //     if (res3 && res3.code == 200) {
                //         let data = res3.data
                //         let skinList2 = this.$cloneDeep(this.skinList2)
                //         let skinObj2 = this.$cloneDeep(this.skinObj2)
                //         skinList2[3] = data.list
                //         skinObj2[3] = {
                //             strike_arr: '',
                //             resonance_arr: '',
                //         }
                //         this.skinList2 = skinList2
                //         this.skinObj2 = skinObj2
                //     }
                // }

                // 获取落地嗵皮
                // if (this.another_landing_punch == 1) {
                //     let obj3 = {
                //         diameter_id: this.otherSizeObj[4]['diameter'],
                //     }
                //     let res3 = await this.drumSkinLists(obj3)
                //     if (res3 && res3.code == 200) {
                //         let data = res3.data
                //         let skinList2 = this.$cloneDeep(this.skinList2)
                //         let skinObj2 = this.$cloneDeep(this.skinObj2)
                //         skinList2[4] = data.list
                //         skinObj2[4] = {
                //             strike_arr: '',
                //             resonance_arr: '',
                //         }
                //         this.skinList2 = skinList2
                //         this.skinObj2 = skinObj2
                //     }
                // }

                resolve()
            })
        },
        // 获取鼓腔表面工艺
        async getDrumTechnologyList() {
            return new Promise(async (resolve, reject) => {
                let checkObj = this.checkOtherSelect()
                let obj4 = {
                    plane_id: this.planeObj.id,
                }
                if (checkObj[1]) {
                    obj4['another_heaving_floor'] = 1
                }
                if (checkObj[2]) {
                    obj4['another_military'] = 1
                }
                if (checkObj[3]) {
                    obj4['another_tom'] = 1
                }
                if (checkObj[4]) {
                    obj4['another_landing_punch'] = 1
                }
                let res4 = await this.drumTechnologyLists(obj4)
                if (res4 && res4.code == 200) {
                    let data = res4.data
                    this.technologyList = data.list
                }
                resolve()
            })
        },
        // 获取底鼓腿
        async getDrumLegList() {
            return new Promise(async (resolve, reject) => {
                this.checkOtherSelect()
                let obj3 = {
                    plane_id: this.planeObj.id,
                }
                if (this.another_heaving_floor == 1) {
                    obj3['another_heaving_floor'] = 1
                }
                let res3 = await this.drumLegLists(obj3)
                if (res3 && res3.code == 200) {
                    let data = res3.data
                    this.diLegList = data.list
                    this.diLegObj = ''
                }
                resolve()
            })
        },
        // 获取响弦
        async getDrumSnareList() {
            return new Promise(async (resolve, reject) => {
                // 获取标准鼓响弦
                let diameterIdList = []
                for (let index = 0; index < this.sizeObj[2].length; index++) {
                    let item = this.sizeObj[2][index]
                    if (item.diameter != '') {
                        diameterIdList.push(item.diameter)
                    }
                }
                // 判断是否选择了军鼓直径
                if (diameterIdList.length > 0) {
                    let obj3 = {
                        diameter_id: diameterIdList.toString(),
                        plane_id: this.planeObj.id,
                    }
                    let res3 = await this.drumSnareLists(obj3)
                    if (res3 && res3.code == 200) {
                        let data = res3.data
                        if (data) {
                            let snareList = this.$cloneDeep(data.list)
                            let snareObj = this.$cloneDeep(data.list)
                            snareList[0].list.forEach((item, index) => {
                                item.num = 1
                            })
                            snareObj.forEach((item, index) => {
                                item.id = ''
                            })
                            this.snareList = snareList
                            this.snareObj = snareObj
                        }
                    }
                }

                // 获取另购鼓响弦
                if (this.otherSizeObj[2]['diameter']) {
                    let obj3 = {
                        diameter_id: this.otherSizeObj[2]['diameter'],
                        plane_id: this.planeObj.id,
                        another_military: 1,
                    }
                    let res3 = await this.drumSnareLists(obj3)
                    if (res3 && res3.code == 200) {
                        let data = res3.data
                        if (data) {
                            let snareList2 = this.$cloneDeep(data.list)
                            let snareObj2 = this.$cloneDeep(data.list)
                            snareList2[0].list.forEach((item, index) => {
                                item.num = 1
                            })
                            snareObj2.forEach((item, index) => {
                                item.id = ''
                            })
                            this.snareList2 = snareList2
                            this.snareObj2 = snareObj2
                        }
                    }
                }
                resolve()
            })
        },
        // 任意一个鼓另购后，刷新数据
        async refreshData() {
            this.$load.open()
            this.checkOtherSelect()
            let another_heaving_floor = this.another_heaving_floor // 底鼓另购数量
            let another_military = this.another_military // 军鼓另购数量
            let another_tom = this.another_tom // 嗵鼓另购数量
            let another_landing_punch = this.another_landing_punch // 落地嗵另购数量
            let otherSizeObj = this.otherSizeObj // 另购鼓的尺寸对象

            // 另购军鼓
            if (another_military == 1) {
                // 获取鼓压圈
                let res = await this.drumRingLists({
                    type: 2,
                    diameter_id: otherSizeObj[2]['diameter'],
                    nail_id: otherSizeObj[2]['nail'],
                })
                if (res && res.code == 200) {
                    let data = res.data
                    if (data) {
                        let ringList2 = this.$cloneDeep(this.ringList2)
                        ringList2[2] = data.list.up
                        this.ringList2 = ringList2
                    }
                }

                // 获取响弦开关
                let obj2 = {
                    plane_id: this.planeObj.id,
                }
                let res2 = await this.drumSnareSwitchLists(obj2)
                if (res2 && res2.code == 200) {
                    let data = res2.data
                    data.list.a_arr.forEach((item, index) => {
                        item.num = 1
                    })
                    data.list.b_arr.forEach((item, index) => {
                        item.num = 1
                    })
                    this.snareSwitchList2 = {
                        a: data.list.a_arr,
                        b: data.list.b_arr,
                    }
                    this.snareSwitchObj2 = {
                        a: '',
                        b: '',
                    }
                }
            }

            if (another_tom == 1) {
                // 标准鼓选择了军鼓鼓压圈
                if (this.ringObj[2] && this.ringObj[2][0]) {
                    let res = await this.drumRingLists({
                        type: 3,
                        diameter_id: otherSizeObj[3]['diameter'],
                        nail_id: otherSizeObj[3]['nail'],
                        id: this.ringObj[2][0],
                    })
                    if (res && res.code == 200) {
                        let data = res.data
                        if (data) {
                            let ringList2 = this.$cloneDeep(this.ringList2)
                            ringList2[3] = data.list.up
                            this.ringList2 = ringList2

                            // 默认选中
                            let ringObj2 = this.$cloneDeep(this.ringObj2)
                            ringObj2[3] = data.list.up[0]['id']
                            this.ringObj2 = ringObj2
                        }
                    }
                } else {
                    let ringList2 = this.$cloneDeep(this.ringList2)
                    let ringObj2 = this.$cloneDeep(this.ringObj2)
                    ringList2[3] = []
                    ringObj2[3] = ''
                    this.ringList2 = ringList2
                    this.ringObj2 = ringObj2
                }
            }

            if (another_landing_punch == 1) {
                // 标准鼓选择了军鼓鼓压圈
                if (this.ringObj[2] && this.ringObj[2][0]) {
                    let res = await this.drumRingLists({
                        type: 4,
                        diameter_id: otherSizeObj[4]['diameter'],
                        nail_id: otherSizeObj[4]['nail'],
                        id: this.ringObj[2][0],
                    })
                    if (res && res.code == 200) {
                        let data = res.data
                        if (data) {
                            let ringList2 = this.$cloneDeep(this.ringList2)
                            ringList2[4] = data.list.up
                            this.ringList2 = ringList2

                            // 默认选中
                            let ringObj2 = this.$cloneDeep(this.ringObj2)
                            ringObj2[4] = data.list.up[0]['id']
                            this.ringObj2 = ringObj2
                        }
                    }
                } else {
                    let ringList2 = this.$cloneDeep(this.ringList2)
                    let ringObj2 = this.$cloneDeep(this.ringObj2)
                    ringList2[4] = []
                    ringObj2[4] = ''
                    this.ringList2 = ringList2
                    this.ringObj2 = ringObj2
                }
            }

            // 获取悬挂系统
            if (another_tom == 1) {
                // 如果选择了第一个嗵鼓悬挂系统，则获取另购的嗵鼓悬挂系统
                if (this.hangObj[3] && this.hangObj[3][0]) {
                    let res2 = await this.drumHangLists({
                        type: 3,
                        diameter_id: otherSizeObj[3]['diameter'],
                        id: this.hangObj[3][0],
                    })
                    if (res2 && res2.code == 200) {
                        let data2 = res2.data
                        if (data2) {
                            let hangList2 = this.$cloneDeep(this.hangList2)
                            let hangObj2 = this.$cloneDeep(this.hangObj2)
                            hangList2[3] = data2.list
                            hangObj2[3] = data2.list[0].id
                            this.hangList2 = hangList2
                            this.hangObj2 = hangObj2
                        }
                    }
                }
            }

            if (another_landing_punch == 1) {
                // 如果选择了第一个嗵鼓悬挂系统，则获取另购的落地嗵悬挂系统
                if (this.hangObj[3] && this.hangObj[3][0]) {
                    let res2 = await this.drumHangLists({
                        type: 4,
                        diameter_id: otherSizeObj[4]['diameter'],
                        gl_id: this.hangObj[3][0],
                    })
                    if (res2 && res2.code == 200) {
                        let data2 = res2.data
                        if (data2) {
                            let hangList2 = this.$cloneDeep(this.hangList2)
                            let hangObj2 = this.$cloneDeep(this.hangObj2)
                            hangList2[4] = data2.list
                            hangObj2[4] = data2.list[0].id
                            this.hangList2 = hangList2
                            this.hangObj2 = hangObj2
                        }
                    }
                }
            }

            // 更新落地嗵腿（会自动计算另购鼓）
            await this.getTongLeg()

            // 更新鼓耳数量（会自动计算另购鼓）
            await this.getEar()

            // 获取鼓螺丝（会自动计算另购鼓）
            await this.getScrew()

            // 获取响弦（会自动计算另购鼓）
            await this.getDrumSnareList()

            // 获取底鼓腿（会自动计算另购鼓）
            await this.getDrumLegList()

            // 获取底鼓抓钩（会自动计算另购鼓）
            await this.getGrapple()

            // 获取工艺（会自动计算另购鼓）
            await this.getDrumTechnologyList()

            // 获取鼓皮（会自动计算另购鼓）
            await this.getDrumSkinList()
            this.$load.close()
        },
        // 初始化sizeList
        sizeListInit() {
            // 1：底鼓、2：军鼓、3：嗵鼓、4：落地嗵
            let obj = {
                1: [],
                2: [],
                3: [],
                4: [],
            }
            let heaving_floor_num = this.planeObj.heaving_floor_num // 底鼓数量
            let military_drum_num = this.planeObj.military_drum_num // 军鼓数量
            let tom_drum_num = this.planeObj.tom_drum_num // 嗵鼓数量
            let landing_punch_num = this.planeObj.landing_punch_num // 落地嗵数量

            for (let index = 0; index < heaving_floor_num; index++) {
                obj[1].push({
                    diameter: [],
                    depth: [],
                    nail: [],
                })
            }

            for (let index = 0; index < military_drum_num; index++) {
                obj[2].push({
                    diameter: [],
                    depth: [],
                    nail: [],
                })
            }

            for (let index = 0; index < tom_drum_num; index++) {
                obj[3].push({
                    diameter: [],
                    depth: [],
                    nail: [],
                })
            }

            for (let index = 0; index < landing_punch_num; index++) {
                obj[4].push({
                    diameter: [],
                    depth: [],
                    nail: [],
                })
            }

            this.sizeList = obj
        },
        // 烤漆表面处理，计算3行高度
        mathColorHeight() {
            if (this.mathHeightTimer) {
                clearInterval(this.mathHeightTimer)
                this.mathHeightTimer = null
            }
            this.mathHeightTimer = setInterval(() => {
                let h = this.$refs['colorBox0'][0].offsetHeight
                let num = h * 3 + 40
                this.$refs.scrollBox.style.maxHeight = num + 'px'
                this.$refs.scrollBox2.style.maxHeight = num + 'px'
                this.$refs.scrollBox3.style.maxHeight = num + 'px'

                let h2 = this.$refs['winColorBox0'][0].offsetHeight
                let num2 = h2 * 3 + 12
                this.$refs.scrollBoxWin.style.maxHeight = num2 + 'px'
                this.$refs.scrollBoxWin2.style.maxHeight = num2 + 'px'
                this.$refs.scrollBoxWin3.style.maxHeight = num2 + 'px'
            }, 2000)
        },
        // 选择外层和颜色后会触发
        async get3dData() {
            return new Promise(async (resolve, reject) => {
                if (this.caizhiName && this.yanseName) {
                    let nameStr = this.caizhiName + '-' + this.yanseName
                    let path_prefix = ''
                    if (this.compress3d) {
                        path_prefix = 'https://hailungushang.oss-cn-beijing.aliyuncs.com/compress/'
                    } else {
                        path_prefix = 'https://hailungushang.oss-cn-beijing.aliyuncs.com/'
                    }
                    console.log(' ')
                    console.log('  ')
                    console.log('   ')
                    console.log(nameStr + '-基础.jpg')
                    console.log(nameStr + '-法线.jpg')
                    console.log(' ')
                    console.log('  ')
                    console.log('   ')
                    let info = {
                        render_type: '鼓腔',
                        path_prefix,
                        map: nameStr + '-基础.jpg',
                        normal: nameStr + '-法线.jpg',
                        // roughness: nameStr + '-粗糙.jpg',
                    }
                    if (this.yanseName == '透明色') {
                        // 选择了亚克力透明色
                        this.$refs['model_3d'].transparentType = '全部'
                        await this.$refs['model_3d'].tietu_update(info)
                        this.$refs['model_3d'].set_other_gu_transparent()
                    } else {
                        // 选择了普通颜色
                        this.$refs['model_3d'].transparentType = '鼓皮'
                        await this.$refs['model_3d'].tietu_update(info)
                        this.$refs['model_3d'].set_digu_gongming_fangshoupi()
                        this.$refs['model_3d'].set_other_gu_transparent()
                    }
                    resolve()
                } else {
                    resolve()
                }
            })
        },
        snareSwitch2(type, item, index, index2) {
            let snareList2 = this.$cloneDeep(this.snareList2)
            if (type == 1) {
                // 响弦开关 +
                if (snareList2[0]['list'][index2]['num'] == 99) {
                    return
                }
                snareList2[0]['list'][index2]['num']++
            } else {
                // 响弦开关 -
                if (snareList2[0]['list'][index2]['num'] == 0) {
                    return
                }
                snareList2[0]['list'][index2]['num']--
            }
            this.snareList2 = snareList2
        },
        snareSwitch(type, item, index, index2) {
            let snareList = this.$cloneDeep(this.snareList)
            if (type == 1) {
                // 响弦开关 +
                if (snareList[index]['list'][index2]['num'] == 99) {
                    return
                }
                snareList[index]['list'][index2]['num']++
            } else {
                // 响弦开关 -
                if (snareList[index]['list'][index2]['num'] == 0) {
                    return
                }
                snareList[index]['list'][index2]['num']--
            }
            this.snareList = snareList
        },
        snareOnOffSwitch2(type, type2, item, index) {
            let snareSwitchList2 = this.$cloneDeep(this.snareSwitchList2)
            if (type == 1) {
                // 响弦开关 +
                if (snareSwitchList2[type2][index]['num'] == 99) {
                    return
                }
                snareSwitchList2[type2][index]['num']++
            } else {
                // 响弦开关 -
                if (snareSwitchList2[type2][index]['num'] == 0) {
                    return
                }
                snareSwitchList2[type2][index]['num']--
            }
            this.snareSwitchList2 = snareSwitchList2
        },
        snareOnOffSwitch(type, type2, item, index) {
            let snareSwitchList = this.$cloneDeep(this.snareSwitchList)
            if (type == 1) {
                // 响弦开关 +
                if (snareSwitchList[type2][index]['num'] == 99) {
                    return
                }
                snareSwitchList[type2][index]['num']++
            } else {
                // 响弦开关 -
                if (snareSwitchList[type2][index]['num'] == 0) {
                    return
                }
                snareSwitchList[type2][index]['num']--
            }
            this.snareSwitchList = snareSwitchList
        },
        // 判断另购鼓状态
        checkOtherSelect() {
            let otherSizeObj = this.$cloneDeep(this.otherSizeObj)
            let obj = {
                1: false,
                2: false,
                3: false,
                4: false,
            }
            this.another_heaving_floor = 0 // 底鼓数量
            this.another_military = 0 // 军鼓数量
            this.another_tom = 0 // 嗵鼓数量
            this.another_landing_punch = 0 // 落地嗵数量
            if (otherSizeObj[1]['diameter'] && otherSizeObj[1]['depth'] && otherSizeObj[1]['nail']) {
                obj[1] = true
                this.another_heaving_floor = 1
            }
            if (otherSizeObj[2]['diameter'] && otherSizeObj[2]['depth'] && otherSizeObj[2]['nail']) {
                obj[2] = true
                this.another_military = 1
            }
            if (otherSizeObj[3]['diameter'] && otherSizeObj[3]['depth'] && otherSizeObj[3]['nail']) {
                obj[3] = true
                this.another_tom = 1
            }
            if (otherSizeObj[4]['diameter'] && otherSizeObj[4]['depth'] && otherSizeObj[4]['nail']) {
                obj[4] = true
                this.another_landing_punch = 1
            }
            return obj
        },
        async selectSize2(item, index, type) {
            let otherBuyType = this.otherBuyType
            let otherSizeObjShow = this.$cloneDeep(this.otherSizeObjShow)
            otherSizeObjShow[otherBuyType][type] = item.id
            this.otherSizeObjShow = otherSizeObjShow

            if (type == 'diameter') {
                // 切换直径,重置深度和钉数
                let otherSizeObjShow = this.$cloneDeep(this.otherSizeObjShow)
                otherSizeObjShow[otherBuyType]['depth'] = ''
                otherSizeObjShow[otherBuyType]['nail'] = ''
                this.otherSizeObjShow = otherSizeObjShow

                this.$load.open()
                // 获取深度
                let res = await this.drum_drumDepthListsAjax({
                    type: this.otherBuyType,
                    diameter_id: item.id,
                })
                if (res && res.code == 200) {
                    let data = res.data
                    this.otherSizeList['depth'] = data.list
                }
                // 获取钉数
                let res2 = await this.drum_drumNailListsAjax({
                    type: this.otherBuyType,
                    diameter_id: item.id,
                })
                if (res2 && res2.code == 200) {
                    let data = res2.data
                    this.otherSizeList['nail'] = data.list

                    // 数组长度是1,需要选中
                    if (data.list.length == 1) {
                        let otherSizeObjShow = this.$cloneDeep(this.otherSizeObjShow)
                        otherSizeObjShow[otherBuyType]['nail'] = data.list[0].id
                        this.otherSizeObjShow = otherSizeObjShow
                    }
                }
                await this.$load.close()
            }
        },
        async delOther() {
            let canGo = await this.$refs['HintTextWin'].init('此操作将永久删除该配置, 是否继续?', 1)
            if (canGo != 'confirm') {
                return
            }
            this.$load.open()
            let otherBuyType = this.otherBuyType

            // 删除鼓尺寸深度钉数
            this.otherSizeObj[otherBuyType] = {}
            this.checkOtherSelect()

            // 删除材质
            this.materialObj2[otherBuyType] = {
                inside: '',
                outside: '',
            }

            // 删除颜色
            this.colorListId2[otherBuyType] = ''

            // 删除鼓压圈（军鼓，嗵鼓，落地嗵）
            if (otherBuyType == 2 || otherBuyType == 3 || otherBuyType == 4) {
                this.ringList2[otherBuyType] = this.$options.data().ringList2[otherBuyType]
                this.ringObj2[otherBuyType] = this.$options.data().ringObj2[otherBuyType]
            }

            // 删除悬挂（嗵鼓，落地嗵）
            if (otherBuyType == 3 || otherBuyType == 4) {
                this.hangList2[otherBuyType] = this.$options.data().hangList2[otherBuyType]
                this.hangObj2[otherBuyType] = this.$options.data().hangObj2[otherBuyType]
            }

            // 获取鼓耳（会自动计算另购鼓）
            await this.getEar()

            // 获取鼓螺丝（会自动计算另购鼓）
            await this.getScrew()

            // 获取响弦（会自动计算另购鼓）
            await this.getDrumSnareList()

            // 获取底鼓腿（会自动计算另购鼓）
            await this.getDrumLegList()

            // 获取底鼓抓钩（会自动计算另购鼓）
            await this.getGrapple()

            // 获取工艺（会自动计算另购鼓）
            await this.getDrumTechnologyList()

            // 删除鼓皮（底鼓，军鼓，嗵鼓，落地嗵）
            this.skinList2[otherBuyType] = this.$options.data().skinList2[otherBuyType]
            this.skinObj2[otherBuyType] = this.$options.data().skinObj2[otherBuyType]

            // 删除军鼓
            if (otherBuyType == 2) {
                // 删除响弦开关
                this.snareSwitchList2 = this.$options.data().snareSwitchList2
                this.snareSwitchObj2 = this.$options.data().snareSwitchObj2

                // 删除响弦
                this.snareList2 = this.$options.data().snareList2
                this.snareObj2 = this.$options.data().snareObj2
            }

            await this.$load.close()
            alertSucc('删除成功')
            this.otherBuyWin = false
        },
        onOtherBuyWinClose() {
            this.otherBuyWin = false
        },
        // 打开另购鼓弹窗
        async buyGu(type) {
            if (JSON.stringify(this.planeObj) == '{}') {
                alertErr('请先选择一个鼓方案')
                return
            }

            // 判断底鼓、军鼓、嗵鼓、落地嗵，是否选择了直径、深度、钉数，若没有选择方法不进行
            let sizeObj = this.sizeObj
            for (let i = 0; i < sizeObj[1].length; i++) {
                let item = sizeObj[1][i]
                if (!item.diameter || !item.nail || !item.depth) {
                    alertErr('请先选择底鼓的尺寸/深度/钉数!')
                    return
                }
            }
            for (let i = 0; i < sizeObj[2].length; i++) {
                let item = sizeObj[2][i]
                if (!item.diameter || !item.nail || !item.depth) {
                    alertErr('请先选择军鼓的尺寸/深度/钉数!')
                    return
                }
            }
            for (let i = 0; i < sizeObj[3].length; i++) {
                let item = sizeObj[3][i]
                if (!item.diameter || !item.nail || !item.depth) {
                    alertErr('请先选择嗵鼓的尺寸/深度/钉数!')
                    return
                }
            }
            for (let i = 0; i < sizeObj[4].length; i++) {
                let item = sizeObj[4][i]
                if (!item.diameter || !item.nail || !item.depth) {
                    alertErr('请先选择落地嗵的尺寸/深度/钉数!')
                    return
                }
            }

            this.$load.open()
            this.otherBuyType = type
            // 获取直径
            let obj3 = {
                type: this.otherBuyType,
            }
            let res3 = await this.drum_drumDiameterListsAjax(obj3)
            if (res3 && res3.code == 200) {
                let data = res3.data
                this.otherSizeList = {
                    diameter: [],
                    depth: [],
                    nail: [],
                }
                this.otherSizeList['diameter'] = data.list

                // 如果选择过尺寸，需要继续获取
                if (this.otherSizeObj[type]['diameter']) {
                    // 获取深度
                    let res = await this.drum_drumDepthListsAjax({
                        type: this.otherBuyType,
                        diameter_id: this.otherSizeObj[type]['diameter'],
                    })
                    if (res && res.code == 200) {
                        let data = res.data
                        this.otherSizeList['depth'] = data.list
                    }
                    // 获取钉数
                    let res2 = await this.drum_drumNailListsAjax({
                        type: this.otherBuyType,
                        diameter_id: this.otherSizeObj[type]['diameter'],
                    })
                    if (res2 && res2.code == 200) {
                        let data = res2.data
                        this.otherSizeList['nail'] = data.list
                    }
                }
            }

            this.colorListId2Show = this.$cloneDeep(this.colorListId2)
            this.materialObj2Show = this.$cloneDeep(this.materialObj2)
            this.otherSizeObjShow = this.$cloneDeep(this.otherSizeObj)
            let material_id = this.materialObj2Show[this.otherBuyType].outside
            // 重置内层接口获取推荐
            let obj = {
                material_id: material_id ? material_id : '',
            }
            let res = await this.drumMaterialLists(obj)
            if (res && res.code == 200) {
                let data = res.data
                if (this.otherBuyType == 1) {
                    this.materialList2 = data.list
                } else if (this.otherBuyType == 2) {
                    this.materialList3 = data.list
                } else if (this.otherBuyType == 3) {
                    this.materialList4 = data.list
                } else if (this.otherBuyType == 4) {
                    this.materialList5 = data.list
                }
            }

            // 重置鼓颜色接口获取推荐
            let obj2 = {
                material_id: material_id ? material_id : '',
            }
            let res2 = await this.drumColorLists(obj2)
            if (res2 && res2.code == 200) {
                let data = res2.data
                if (this.otherBuyType == 1) {
                    this.colorList2 = data.list
                } else if (this.otherBuyType == 2) {
                    this.colorList3 = data.list
                } else if (this.otherBuyType == 3) {
                    this.colorList4 = data.list
                } else if (this.otherBuyType == 4) {
                    this.colorList5 = data.list
                }
            }

            await this.$load.close()
            this.otherBuyWin = true

            if (type == 1) {
                // 底鼓
            } else if (type == 2) {
                // 军鼓
            } else if (type == 3) {
                // 嗵鼓
            } else if (type == 4) {
                // 落地嗵
            }
        },
        // 获取落地嗵腿
        getTongLeg() {
            return new Promise(async (resolve, reject) => {
                this.checkOtherSelect()

                let obj = {
                    plane_id: this.planeObj.id,
                }

                // 是否另购了落地嗵
                if (this.another_landing_punch == 1) {
                    obj['another_landing_punch'] = 1
                }

                let res = await this.drumTongLegLists(obj)
                if (res && res.code == 200) {
                    let data = res.data
                    this.tongLeg = data.list
                }
                resolve()
            })
        },
        // 记录草稿
        async setDraft() {
            if (!this.vuex_is_login) {
                return
            }
            let obj = {
                planeList: this.$cloneDeep(this.planeList),
                planeObj: this.$cloneDeep(this.planeObj),
                planeColumn: this.$cloneDeep(this.planeColumn),
                supporterList: this.$cloneDeep(this.supporterList),
                supporterObj: this.$cloneDeep(this.supporterObj),
                materialList: this.$cloneDeep(this.materialList),
                materialObj: this.$cloneDeep(this.materialObj),
                colorList: this.$cloneDeep(this.colorList),
                colorListId: this.$cloneDeep(this.colorListId),
                sizeList: this.$cloneDeep(this.sizeList),
                sizeObj: this.$cloneDeep(this.sizeObj),
                sizeListId: this.$cloneDeep(this.sizeListId),
                ringList: this.$cloneDeep(this.ringList),
                ringObj: this.$cloneDeep(this.ringObj),
                hangList: this.$cloneDeep(this.hangList),
                hangObj: this.$cloneDeep(this.hangObj),
                tongLeg: this.$cloneDeep(this.tongLeg),
                earList: this.$cloneDeep(this.earList),
                earObj: this.$cloneDeep(this.earObj),
                screwList: this.$cloneDeep(this.screwList),
                snareSwitchList: this.$cloneDeep(this.snareSwitchList),
                snareSwitchObj: this.$cloneDeep(this.snareSwitchObj),
                snareList: this.$cloneDeep(this.snareList),
                snareObj: this.$cloneDeep(this.snareObj),
                diLegList: this.$cloneDeep(this.diLegList),
                diLegObj: this.$cloneDeep(this.diLegObj),
                grappleList: this.$cloneDeep(this.grappleList),
                grappleObj: this.$cloneDeep(this.grappleObj),
                technologyList: this.$cloneDeep(this.technologyList),
                technologyObj: this.$cloneDeep(this.technologyObj),
                skinList: this.$cloneDeep(this.skinList),
                skinObj: this.$cloneDeep(this.skinObj),
                madeType: this.$cloneDeep(this.madeType),
                inputType: this.$cloneDeep(this.inputType),
                uploadFileList: this.$cloneDeep(this.uploadFileList),
                hardwareList: this.$cloneDeep(this.hardwareList),
                otherSizeList: this.$cloneDeep(this.otherSizeList),
                otherSizeObjShow: this.$cloneDeep(this.otherSizeObjShow),
                otherSizeObj: this.$cloneDeep(this.otherSizeObj),
                another_heaving_floor: this.another_heaving_floor,
                another_military: this.another_military,
                another_tom: this.another_tom,
                another_landing_punch: this.another_landing_punch,
                materialList2: this.$cloneDeep(this.materialList2),
                colorList2: this.$cloneDeep(this.colorList2),
                materialList3: this.$cloneDeep(this.materialList3),
                colorList3: this.$cloneDeep(this.colorList3),
                materialList4: this.$cloneDeep(this.materialList4),
                colorList4: this.$cloneDeep(this.colorList4),
                materialList5: this.$cloneDeep(this.materialList5),
                colorList5: this.$cloneDeep(this.colorList5),
                materialObj2Show: this.$cloneDeep(this.materialObj2Show),
                materialObj2: this.$cloneDeep(this.materialObj2),
                colorListId2Show: this.$cloneDeep(this.colorListId2Show),
                colorListId2: this.$cloneDeep(this.colorListId2),
                snareList2: this.$cloneDeep(this.snareList2),
                snareObj2: this.$cloneDeep(this.snareObj2),
                skinList2: this.$cloneDeep(this.skinList2),
                skinObj2: this.$cloneDeep(this.skinObj2),
                ringList2: this.$cloneDeep(this.ringList2),
                ringObj2: this.$cloneDeep(this.ringObj2),
                hangList2: this.$cloneDeep(this.hangList2),
                hangObj2: this.$cloneDeep(this.hangObj2),
                snareSwitchList2: this.$cloneDeep(this.snareSwitchList2),
                snareSwitchObj2: this.$cloneDeep(this.snareSwitchObj2),
                caizhiName: this.caizhiName,
                yanseName: this.yanseName,
                modelUrl: this.modelUrl,
            }
            let formData = new FormData()
            formData.append('action', 'drumorder_draft')
            formData.append('version', this.$store.state.vuex_config.version)
            formData.append('token', localStorage.getItem('token'))
            formData.append('userId', localStorage.getItem('userId'))
            formData.append('info', JSON.stringify(obj))
            let res = await this.setDraftAjax(formData)
        },
        showVideo(item) {
            if (item.video_url) {
                this.videoUrl = item.video_url
                this.$nextTick(() => {
                    this.videoWinShow = true
                })
            }
        },
        onModalClose() {
            this.videoUrl = ''
            this.videoWinShow = false
        },
        kefuBtn() {
            this.kefuWin = true
        },
        formSub() {
            if (!this.vuex_is_login) {
                alertErr('请先登录！')
                this.$router.push({
                    path: '/login',
                })
                return
            }
            if (this.queryForm.length == 0) {
                alertErr('请先选择配置')
                return
            }
            let madeObj = {
                remark: this.remark,
                obj: this.getQueryFromParams(),
                madeTypeObj: {
                    madeType: this.madeType,
                    uploadFileList: this.uploadFileList,
                },
            }
            sessionStorage.setItem('madeObj', JSON.stringify(madeObj))
            this.$router.push({
                path: '/order-submit2',
            })
        },
        // 另购鼓保存
        async saveOtherWin() {
            // 另购鼓，必填项判断
            if (!this.materialObj2Show[this.otherBuyType]['outside']) {
                alertErr('请选择外层材质')
                return
            }
            if (!this.materialObj2Show[this.otherBuyType]['inside']) {
                alertErr('请选择内层材质')
                return
            }
            if (!this.colorListId2Show[this.otherBuyType]) {
                alertErr('请选择鼓腔表面处理')
                return
            }
            if (!this.otherSizeObjShow[this.otherBuyType]['diameter']) {
                alertErr('请选择尺寸')
                return
            }
            if (!this.otherSizeObjShow[this.otherBuyType]['depth']) {
                alertErr('请选择深度')
                return
            }
            if (!this.otherSizeObjShow[this.otherBuyType]['nail']) {
                alertErr('请选择钉数')
                return
            }
            this.otherBuyWin = false
            this.colorListId2 = this.$cloneDeep(this.colorListId2Show)
            this.materialObj2 = this.$cloneDeep(this.materialObj2Show)
            this.otherSizeObj = this.$cloneDeep(this.otherSizeObjShow)

            this.refreshData()
        },
        // 选择颜色
        selectColor(item) {
            this.colorListId = item.id
            this.yanseName = item.title
            if (!this.isH5) {
                this.get3dData()
            }
        },
        // 另购-选择颜色
        selectColor2(item) {
            let otherBuyType = this.otherBuyType
            this.colorListId2Show[otherBuyType] = item.id
        },
        // 选择内外层材质
        async selectMaterial(item, type) {
            if (type == 1) {
                // 外层
                this.materialObj.outside = item.id

                // 重置内层接口获取推荐
                let obj = {
                    material_id: item.id,
                }
                let res = await this.drumMaterialLists(obj)
                if (res && res.code == 200) {
                    let data = res.data
                    this.materialList = data.list
                }

                // 重置鼓颜色接口获取推荐
                let obj2 = {
                    material_id: item.id,
                }
                let res2 = await this.drumColorLists(obj2)
                if (res2 && res2.code == 200) {
                    let data = res2.data
                    this.colorList = data.list
                }

                this.caizhiName = item.title
                if (!this.isH5) {
                    this.get3dData()
                }
            } else if (type == 2) {
                // 内层
                this.materialObj.inside = item.id
            }
        },
        // 另购-选择内外层材质
        async selectMaterial2(item, type) {
            let otherBuyType = this.otherBuyType
            if (type == 1) {
                // 外层
                this.materialObj2Show[otherBuyType].outside = item.id

                // 重置内层接口获取推荐
                let obj = {
                    material_id: item.id,
                }
                let res = await this.drumMaterialLists(obj)
                if (res && res.code == 200) {
                    let data = res.data
                    if (this.otherBuyType == 1) {
                        this.materialList2 = data.list
                    } else if (this.otherBuyType == 2) {
                        this.materialList3 = data.list
                    } else if (this.otherBuyType == 3) {
                        this.materialList4 = data.list
                    } else if (this.otherBuyType == 4) {
                        this.materialList5 = data.list
                    }
                }

                // 重置鼓颜色接口获取推荐
                let obj2 = {
                    material_id: item.id,
                }
                let res2 = await this.drumColorLists(obj2)
                if (res2 && res2.code == 200) {
                    let data = res2.data
                    if (this.otherBuyType == 1) {
                        this.colorList2 = data.list
                    } else if (this.otherBuyType == 2) {
                        this.colorList3 = data.list
                    } else if (this.otherBuyType == 3) {
                        this.colorList4 = data.list
                    } else if (this.otherBuyType == 4) {
                        this.colorList5 = data.list
                    }
                }
            } else if (type == 2) {
                // 内层
                this.materialObj2Show[otherBuyType].inside = item.id
            }
        },
        addHardWare(item, index) {
            if (item.num == 99) {
                return
            }
            let hardwareList = this.$cloneDeep(this.hardwareList)
            let list = hardwareList[Number(this.hardwareId) - 1].child
            list[index].num += 1
            this.hardwareList = hardwareList
        },
        delHardWare(item, index) {
            if (item.num == 0) {
                return
            }
            let hardwareList = this.$cloneDeep(this.hardwareList)
            let list = hardwareList[Number(this.hardwareId) - 1].child
            list[index].num -= 1
            this.hardwareList = hardwareList
        },
        // 选择硬件配置
        selectHardWare(item, index) {
            let hardwareList = this.$cloneDeep(this.hardwareList)
            let list = hardwareList[Number(this.hardwareId) - 1].child
            if (item.select == 1) {
                list[index].select = 0
            } else {
                list[index].select = 1
            }

            // if (Number(this.hardwareId) - 1 == 0) {
            //     if (hardwareList[1] && hardwareList[1].child) {
            //         hardwareList[1].child.forEach((item, index) => {
            //             item.select = 0
            //             item.num = 1
            //         })
            //     }
            //     if (hardwareList[2] && hardwareList[2].child) {
            //         hardwareList[2].child.forEach((item, index) => {
            //             item.select = 0
            //             item.num = 1
            //         })
            //     }
            // } else if (Number(this.hardwareId) - 1 == 1) {
            //     if (hardwareList[0] && hardwareList[0].child) {
            //         hardwareList[0].child.forEach((item, index) => {
            //             item.select = 0
            //             item.num = 1
            //         })
            //     }
            //     if (hardwareList[2] && hardwareList[2].child) {
            //         hardwareList[2].child.forEach((item, index) => {
            //             item.select = 0
            //             item.num = 1
            //         })
            //     }
            // } else if (Number(this.hardwareId) - 1 == 2) {
            //     if (hardwareList[0] && hardwareList[0].child) {
            //         hardwareList[0].child.forEach((item, index) => {
            //             item.select = 0
            //             item.num = 1
            //         })
            //     }
            //     if (hardwareList[1] && hardwareList[1].child) {
            //         hardwareList[1].child.forEach((item, index) => {
            //             item.select = 0
            //             item.num = 1
            //         })
            //     }
            // }
            this.hardwareList = hardwareList
        },
        async getDrumHardwareLists(id) {
            return new Promise(async (resolve, reject) => {
                let res = await this.drumHardwareLists({
                    gl_id: id,
                })
                if (res && res.code == 200) {
                    let data = res.data
                    data.list.forEach((item, index) => {
                        if (item.child) {
                            item.child.forEach((item2, index2) => {
                                item2.num = 1
                                item2.select = 0
                            })
                        }
                    })
                    this.hardwareList = data.list
                }
                resolve()
            })
        },
        async drumSupporterLists() {
            return new Promise(async (resolve, reject) => {
                let res = await this.drumSupporterListsAjax()
                if (res && res.code == 200) {
                    this.supporterList = res.data
                }
                resolve()
            })
        },
        earObjInit() {
            // 1.底鼓，2.军鼓，3.嗵鼓
            let obj = {
                1: [],
                2: [],
                3: [],
            }

            let obj2 = {
                1: '',
                2: '',
                3: '',
            }

            this.earList = obj
            this.earObj = obj2
        },
        hangObjInit() {
            // 3：嗵鼓、4：落地嗵
            let obj = {
                3: [],
                4: [],
            }

            let obj2 = {
                3: [],
                4: [],
            }

            // let tom_drum_num = this.planeObj.tom_drum_num // 嗵鼓数量
            // let landing_punch_num = this.planeObj.landing_punch_num // 落地嗵数量

            // for (let index = 0; index < tom_drum_num; index++) {
            //     obj[3].push([])
            //     obj2[3].push('')
            // }

            // for (let index = 0; index < landing_punch_num; index++) {
            //     obj[4].push([])
            //     obj2[4].push('')
            // }

            this.hangList = obj
            this.hangObj = obj2
        },
        ringObjInit() {
            // 2：军鼓、3：嗵鼓、4：落地嗵
            let obj = {
                2: [],
                3: [],
                4: [],
            }

            let obj2 = {
                2: [],
                3: [],
                4: [],
            }

            let military_drum_num = this.planeObj.military_drum_num // 军鼓数量
            let tom_drum_num = this.planeObj.tom_drum_num // 嗵鼓数量
            let landing_punch_num = this.planeObj.landing_punch_num // 落地嗵数量

            for (let index = 0; index < military_drum_num; index++) {
                obj2[2].push('')
            }

            for (let index = 0; index < tom_drum_num; index++) {
                obj2[3].push('')
            }

            for (let index = 0; index < landing_punch_num; index++) {
                obj2[4].push('')
            }

            this.ringList = obj
            this.ringObj = obj2
        },
        skinObjInit() {
            this.skinList = {}
            this.skinObj = {}
            this.skinListId = 1
            this.skinList2 = {
                1: {
                    resonance_arr: [],
                    strike_arr: [],
                },
                2: {
                    resonance_arr: [],
                    strike_arr: [],
                },
                3: {
                    resonance_arr: [],
                    strike_arr: [],
                },
                4: {
                    resonance_arr: [],
                    strike_arr: [],
                },
            }
            this.skinObj2 = {
                1: {
                    resonance_arr: '',
                    strike_arr: '',
                },
                2: {
                    resonance_arr: '',
                    strike_arr: '',
                },
                3: {
                    resonance_arr: '',
                    strike_arr: '',
                },
                4: {
                    resonance_arr: '',
                    strike_arr: '',
                },
            }
            // 1：底鼓、2：军鼓、3：嗵鼓
            let obj = {
                1: [],
                2: [],
                3: [],
                4: [],
            }

            let obj2 = {
                1: [],
                2: [],
                3: [],
                4: [],
            }

            let heaving_floor_num = this.planeObj.heaving_floor_num // 底鼓数量
            let military_drum_num = this.planeObj.military_drum_num // 军鼓数量
            let tom_drum_num = this.planeObj.tom_drum_num // 嗵鼓数量
            let landing_punch_num = this.planeObj.landing_punch_num // 落地嗵数量

            for (let index = 0; index < heaving_floor_num; index++) {
                obj[1].push({
                    strike_arr: [],
                    resonance_arr: [],
                })

                obj2[1].push({
                    strike_arr: '',
                    resonance_arr: '',
                })
            }

            for (let index = 0; index < military_drum_num; index++) {
                obj[2].push({
                    strike_arr: [],
                    resonance_arr: [],
                })

                obj2[2].push({
                    strike_arr: '',
                    resonance_arr: '',
                })
            }

            for (let index = 0; index < tom_drum_num; index++) {
                obj[3].push({
                    strike_arr: [],
                    resonance_arr: [],
                })

                obj2[3].push({
                    strike_arr: '',
                    resonance_arr: '',
                })
            }

            for (let index = 0; index < landing_punch_num; index++) {
                obj[4].push({
                    strike_arr: [],
                    resonance_arr: [],
                })

                obj2[4].push({
                    strike_arr: '',
                    resonance_arr: '',
                })
            }

            this.skinList = obj
            this.skinObj = obj2
        },
        sizeObjInit() {
            // 1：底鼓、2：军鼓、3：嗵鼓、4：落地嗵
            let obj = {
                1: [],
                2: [],
                3: [],
                4: [],
            }
            let heaving_floor_num = this.planeObj.heaving_floor_num // 底鼓数量
            let military_drum_num = this.planeObj.military_drum_num // 军鼓数量
            let tom_drum_num = this.planeObj.tom_drum_num // 嗵鼓数量
            let landing_punch_num = this.planeObj.landing_punch_num // 落地嗵数量

            for (let index = 0; index < heaving_floor_num; index++) {
                obj[1].push({
                    diameter: '',
                    depth: '',
                    nail: '',
                })
            }

            for (let index = 0; index < military_drum_num; index++) {
                obj[2].push({
                    diameter: '',
                    depth: '',
                    nail: '',
                })
            }

            for (let index = 0; index < tom_drum_num; index++) {
                obj[3].push({
                    diameter: '',
                    depth: '',
                    nail: '',
                })
            }

            for (let index = 0; index < landing_punch_num; index++) {
                obj[4].push({
                    diameter: '',
                    depth: '',
                    nail: '',
                })
            }

            this.sizeObj = obj
        },
        // 选择个性定制
        selectMade(type) {
            if (type == 1) {
                // if (this.uploadFileList[0] == '') {
                //     alertErr('请上传鼓腔个性铭牌定制文件！')
                // } else {
                if (this.madeType[1]) {
                    this.madeType[1] = false
                } else {
                    this.madeType[1] = true
                }
                // }
            } else if (type == 2) {
                // if (this.uploadFileList[1] == '') {
                //     alertErr('请上传共鸣皮个性铭牌定制文件！')
                // } else {
                if (this.madeType[2]) {
                    this.madeType[2] = false
                } else {
                    this.madeType[2] = true
                }
                // }
            } else if (type == 3) {
                if (this.madeType[3]) {
                    this.madeType[3] = false
                } else {
                    this.madeType[3] = true
                }
            }
        },
        // 选择底鼓抓钩
        selectGrapple(item, type) {
            // 只有一项弹窗提示
            if (type) {
                // this.$alert('900JL底鼓抓钩根据900JL嗵鼓悬挂自动生成，无需重复选择', '提示', {
                //     confirmButtonText: '确定',
                //     callback: (action) => {},
                // })
                this.$refs['HintTextWin'].init('900JL底鼓抓钩根据900JL嗵鼓悬挂自动生成，无需重复选择。')
            }
            this.grappleObj = item.id
        },
        // 选择响弦开关
        selectsnareSwitch(item, type) {
            if (type == 'a') {
                // this.snareSwitchObj.a = item.id
                if (this.snareSwitchObj.a != item.id) {
                    this.snareSwitchObj.a = item.id
                } else {
                    this.snareSwitchObj.a = ''
                }
            } else {
                // this.snareSwitchObj.b = item.id
                if (this.snareSwitchObj.b != item.id) {
                    this.snareSwitchObj.b = item.id
                } else {
                    this.snareSwitchObj.b = ''
                }
            }
        },
        // 选择响弦开关
        selectsnareSwitch2(item, type) {
            if (type == 'a') {
                // this.snareSwitchObj2.a = item.id
                if (this.snareSwitchObj2.a != item.id) {
                    this.snareSwitchObj2.a = item.id
                } else {
                    this.snareSwitchObj2.a = ''
                }
            } else {
                // this.snareSwitchObj2.b = item.id
                if (this.snareSwitchObj2.b != item.id) {
                    this.snareSwitchObj2.b = item.id
                } else {
                    this.snareSwitchObj2.b = ''
                }
            }
        },
        // 选择响弦
        selectSnare(item, index) {
            let snareObj = this.$cloneDeep(this.snareObj)
            // snareObj[index]['id'] = item.id
            if (snareObj[index]['id'] != item.id) {
                snareObj[index]['id'] = item.id
            } else {
                snareObj[index]['id'] = ''
            }
            this.snareObj = snareObj
        },
        // 选择响弦
        selectSnare2(item, index) {
            let snareObj2 = this.$cloneDeep(this.snareObj2)
            // snareObj2[index]['id'] = item.id
            if (snareObj2[index]['id'] != item.id) {
                snareObj2[index]['id'] = item.id
            } else {
                snareObj2[index]['id'] = ''
            }
            this.snareObj2 = snareObj2
        },
        // 选择底鼓腿
        selectDiLeg(item, type) {
            // this.diLegObj = item.id
            if (this.diLegObj != item.id) {
                this.diLegObj = item.id
            } else {
                this.diLegObj = ''
            }
        },
        // 选择鼓耳
        // earSelect(item, id) {
        //     if (!this.earObj[id]) {
        //         this.earObj[id] = item.id
        //     } else {
        //         if (this.earObj[id] != item.id) {
        //             this.earObj[id] = item.id
        //         } else {
        //             this.earObj[id] = ''
        //         }
        //     }
        // },
        // 选择表面工艺
        selectTechnology(item) {
            // this.technologyObj = item.id
            if (this.technologyObj != item.id) {
                this.technologyObj = item.id
            } else {
                this.technologyObj = ''
            }
        },
        // 选择尺寸
        async selectSize(item, index, type) {
            let sizeListId = this.sizeListId
            let sizeObj = this.$cloneDeep(this.sizeObj)
            if (sizeObj[sizeListId][index][type] == item.id) {
                return
            }
            this.$load.open()
            sizeObj[sizeListId][index][type] = item.id
            this.sizeObj = sizeObj

            // 切换直径、深度、钉数，任意一项，重置标准鼓和另购鼓的鼓压圈
            this.ringObjInit() // 重置标准鼓鼓压圈
            // 重置另购鼓，鼓压圈（另购的军鼓，鼓压圈不用重置）
            let ringList2 = this.$cloneDeep(this.ringList2)
            let ringObj2 = this.$cloneDeep(this.ringObj2)
            ringList2[3] = []
            ringObj2[3] = ''
            ringList2[4] = []
            ringObj2[4] = ''
            this.ringList2 = ringList2
            this.ringObj2 = ringObj2

            // 切换直径、深度、钉数，任意一项，重置标准鼓和另购鼓的悬挂系统
            this.hangObjInit() // 重置标准鼓的悬挂
            // 重置另购鼓的悬挂
            let hangList2 = this.$cloneDeep(this.hangList2)
            let hangObj2 = this.$cloneDeep(this.hangObj2)
            hangList2[3] = []
            hangList2[4] = []
            hangObj2[3] = ''
            hangObj2[4] = ''
            this.hangList2 = hangList2
            this.hangObj2 = hangObj2
            let canGetHang = true // 是否可以获取悬挂（所有标准鼓的嗵鼓都选择了尺寸后，才可以获取标准鼓的悬挂）
            for (let i = 0; i < this.sizeObj[3].length; i++) {
                let item = this.sizeObj[3][i]
                if (!item['diameter']) {
                    canGetHang = false
                    break
                }
            }
            if (canGetHang) {
                let res2 = await this.drumHangLists({
                    type: 3,
                    diameter_id: this.sizeObj[3][0]['diameter'],
                })
                if (res2 && res2.code == 200) {
                    let data2 = res2.data
                    if (data2) {
                        this.hangObjInit()
                        let hangList = this.$cloneDeep(this.hangList)
                        let hangObj = this.$cloneDeep(this.hangObj)
                        hangList[3][0] = data2.list
                        this.hangList = hangList
                    }
                }
            }

            // 重置鼓螺丝
            this.screwList = []

            // 重置响弦
            this.snareList = []
            this.snareObj = []

            // 重置底鼓抓钩
            this.grappleList = []
            this.grappleObj = ''

            // 重置鼓耳
            this.earObjInit()

            // 选择直径，获取深度和钉数，重置已经选择的深度和钉数
            if (type == 'diameter') {
                let sizeObj = this.$cloneDeep(this.sizeObj)
                sizeObj[sizeListId][index]['depth'] = ''
                sizeObj[sizeListId][index]['nail'] = ''
                this.sizeObj = sizeObj
                // 获取深度
                let res = await this.drum_drumDepthListsAjax({
                    type: this.sizeListId,
                    diameter_id: item.id,
                })
                if (res && res.code == 200) {
                    let data = res.data
                    let sizeList = this.$cloneDeep(this.sizeList)
                    sizeList[sizeListId][index].depth = data.list
                    this.sizeList = sizeList
                }
                // 获取钉数
                let res2 = await this.drum_drumNailListsAjax({
                    type: this.sizeListId,
                    diameter_id: item.id,
                })
                if (res2 && res2.code == 200) {
                    let data = res2.data
                    let sizeList = this.$cloneDeep(this.sizeList)
                    sizeList[sizeListId][index].nail = data.list
                    this.sizeList = sizeList
                    if (data.list.length == 1) {
                        let sizeObj = this.$cloneDeep(this.sizeObj)
                        sizeObj[sizeListId][index]['nail'] = data.list[0].id
                        this.sizeObj = sizeObj
                    }
                }
            }

            // 检测军鼓是否已经选择了尺寸和钉数，若选择了，则获取军鼓鼓压圈
            if (this.sizeObj[2][0]['diameter'] && this.sizeObj[2][0]['nail']) {
                let res = await this.drumRingLists({
                    type: 2,
                    diameter_id: this.sizeObj[2][0]['diameter'],
                    nail_id: this.sizeObj[2][0]['nail'],
                })
                if (res && res.code == 200) {
                    let data = res.data
                    if (data) {
                        this.ringObjInit()
                        let ringList = this.$cloneDeep(this.ringList)
                        let ringObj = this.$cloneDeep(this.ringObj)
                        let arr = data.list.up
                        ringList[2][0] = arr
                        ringObj[2][0] = ''
                        this.ringList = ringList
                        this.ringObj = ringObj
                    }
                }
            }
            await this.$load.close()
        },
        // 鼓腔尺寸切换鼓类型
        async switchSizeTab(id) {
            // this.$load.open()
            this.sizeListId = id
            let sizeListId = this.sizeListId
            let sizeObj = this.$cloneDeep(this.sizeObj)
            if (sizeObj[sizeListId] && sizeObj[sizeListId].length) {
                for (let i = 0; i < sizeObj[sizeListId].length; i++) {
                    // 获取直径
                    let item = sizeObj[sizeListId][i]
                    let obj = {
                        type: sizeListId,
                    }
                    let res = await this.drum_drumDiameterListsAjax(obj)
                    if (res && res.code == 200) {
                        let data = res.data
                        let sizeList = this.$cloneDeep(this.sizeList)
                        sizeList[sizeListId][i].diameter = data.list
                        this.sizeList = sizeList
                    }
                    if (item.diameter) {
                        // 获取深度和钉数
                        // 获取深度
                        let res = await this.drum_drumDepthListsAjax({
                            type: sizeListId,
                            diameter_id: item.diameter,
                        })
                        if (res && res.code == 200) {
                            let data = res.data
                            let sizeList = this.$cloneDeep(this.sizeList)
                            sizeList[sizeListId][i].depth = data.list
                            this.sizeList = sizeList
                        }
                        // 获取钉数
                        let res2 = await this.drum_drumNailListsAjax({
                            type: sizeListId,
                            diameter_id: item.diameter,
                        })
                        if (res2 && res2.code == 200) {
                            let data = res2.data
                            let sizeList = this.$cloneDeep(this.sizeList)
                            sizeList[sizeListId][i].nail = data.list
                            this.sizeList = sizeList
                        }
                    }
                }
            }
            this.$load.close()
        },
        switchSkin(id) {
            this.skinListId = id
        },
        switchHardware(id) {
            this.hardwareId = id
        },
        // 选择嗵鼓悬挂
        async selectHang() {
            this.checkOtherSelect()
            // 判断底鼓、军鼓、嗵鼓、落地嗵，是否选择了直径、深度、钉数，若没有选择方法不进行
            let sizeObj = this.sizeObj
            let hangObj = this.$cloneDeep(this.hangObj)
            for (let i = 0; i < sizeObj[1].length; i++) {
                let item = sizeObj[1][i]
                if (!item.diameter || !item.nail || !item.depth) {
                    alertErr('请先选择底鼓的尺寸/深度/钉数!')
                    hangObj[3][0] = ''
                    this.hangObj = hangObj
                    return
                }
            }
            for (let i = 0; i < sizeObj[2].length; i++) {
                let item = sizeObj[2][i]
                if (!item.diameter || !item.nail || !item.depth) {
                    alertErr('请先选择军鼓的尺寸/深度/钉数!')
                    hangObj[3][0] = ''
                    this.hangObj = hangObj
                    return
                }
            }
            for (let i = 0; i < sizeObj[3].length; i++) {
                let item = sizeObj[3][i]
                if (!item.diameter || !item.nail || !item.depth) {
                    alertErr('请先选择嗵鼓的尺寸/深度/钉数!')
                    hangObj[3][0] = ''
                    this.hangObj = hangObj
                    return
                }
            }
            for (let i = 0; i < sizeObj[4].length; i++) {
                let item = sizeObj[4][i]
                if (!item.diameter || !item.nail || !item.depth) {
                    alertErr('请先选择落地嗵的尺寸/深度/钉数!')
                    hangObj[3][0] = ''
                    this.hangObj = hangObj
                    return
                }
            }

            this.$load.open()
            // 获取所有嗵鼓的悬挂系统
            for (let i = 0; i < sizeObj[3].length; i++) {
                let item = sizeObj[3][i]
                if (i > 0) {
                    let res2 = await this.drumHangLists({
                        type: 3,
                        diameter_id: item['diameter'],
                        id: this.hangObj[3][0],
                    })
                    if (res2 && res2.code == 200) {
                        let data2 = res2.data
                        if (data2) {
                            let hangList = this.$cloneDeep(this.hangList)
                            let hangObj = this.$cloneDeep(this.hangObj)
                            hangList[3][i] = data2.list
                            hangObj[3][i] = data2.list[0].id
                            this.hangList = hangList
                            this.hangObj = hangObj
                        }
                    }
                }
            }

            // 获取所有落地嗵的悬挂系统
            for (let i = 0; i < sizeObj[4].length; i++) {
                let item = sizeObj[4][i]
                let res2 = await this.drumHangLists({
                    type: 4,
                    diameter_id: item['diameter'],
                    gl_id: this.hangObj[3][0],
                })
                if (res2 && res2.code == 200) {
                    let data2 = res2.data
                    if (data2) {
                        let hangList = this.$cloneDeep(this.hangList)
                        let hangObj = this.$cloneDeep(this.hangObj)
                        hangList[4][i] = data2.list
                        hangObj[4][i] = data2.list[0].id
                        this.hangList = hangList
                        this.hangObj = hangObj
                    }
                }
            }

            // 获取另购嗵鼓，悬挂系统
            if (this.another_tom == 1) {
                // 如果选择了第一个嗵鼓悬挂系统，则获取另购的嗵鼓悬挂系统
                if (this.hangObj[3][0]) {
                    let res2 = await this.drumHangLists({
                        type: 3,
                        diameter_id: this.otherSizeObj[3]['diameter'],
                        id: this.hangObj[3][0],
                    })
                    if (res2 && res2.code == 200) {
                        let data2 = res2.data
                        if (data2) {
                            let hangList2 = this.$cloneDeep(this.hangList2)
                            let hangObj2 = this.$cloneDeep(this.hangObj2)
                            hangList2[3] = data2.list
                            hangObj2[3] = data2.list[0].id
                            this.hangList2 = hangList2
                            this.hangObj2 = hangObj2
                        }
                    }
                }
            }

            // 获取另购落地嗵，悬挂系统
            if (this.another_landing_punch == 1) {
                // 如果选择了第一个嗵鼓悬挂系统，则获取另购的落地嗵悬挂系统
                if (this.hangObj[3][0]) {
                    let res2 = await this.drumHangLists({
                        type: 4,
                        diameter_id: this.otherSizeObj[4]['diameter'],
                        gl_id: this.hangObj[3][0],
                    })
                    if (res2 && res2.code == 200) {
                        let data2 = res2.data
                        if (data2) {
                            let hangList2 = this.$cloneDeep(this.hangList2)
                            let hangObj2 = this.$cloneDeep(this.hangObj2)
                            hangList2[4] = data2.list
                            hangObj2[4] = data2.list[0].id
                            this.hangList2 = hangList2
                            this.hangObj2 = hangObj2
                        }
                    }
                }
            }

            // 获取底鼓鼓耳（会自动计算另购鼓）
            await this.getEar()

            // 获取鼓螺丝（会自动计算另购鼓）
            await this.getScrew()

            // 获取响弦（会自动计算另购鼓）
            await this.getDrumSnareList()

            // 获取底鼓抓钩（会自动计算另购鼓）
            await this.getGrapple()

            // 获取鼓皮（会自动计算另购鼓）
            await this.getDrumSkinList()

            this.$load.close()
        },
        // 选择军鼓鼓压圈
        async selectRing() {
            // 判断嗵鼓/落地嗵,是否被选择. 没有被选择,不可以选军鼓鼓压圈
            let sizeObj = this.sizeObj
            let ringObj = this.$cloneDeep(this.ringObj)
            for (let i = 0; i < sizeObj[3].length; i++) {
                let item = sizeObj[3][i]
                if (!item.diameter || !item.nail || !item.depth) {
                    alertErr('请先选择嗵鼓的尺寸/深度/钉数!')
                    ringObj[2][0] = ''
                    this.ringObj = ringObj
                    return
                }
            }
            for (let i = 0; i < sizeObj[4].length; i++) {
                let item = sizeObj[4][i]
                if (!item.diameter || !item.nail || !item.depth) {
                    alertErr('请先选择落地嗵的尺寸/深度/钉数!')
                    ringObj[2][0] = ''
                    this.ringObj = ringObj
                    return
                }
            }

            // 获取嗵鼓和落地嗵的鼓压圈
            let ringObj2 = this.$cloneDeep(this.ringObj)
            let ringList = this.$cloneDeep(this.ringList)

            for (let i = 0; i < sizeObj[3].length; i++) {
                let item = sizeObj[3][i]
                let obj = {
                    type: 3,
                    diameter_id: item['diameter'],
                    nail_id: item['nail'],
                    id: this.ringObj[2][0],
                }
                let res = await this.drumRingLists(obj)
                if (res && res.code == 200) {
                    let data = res.data
                    if (data) {
                        ringObj2[3][i] = data.list['up'][0]['id']
                        if (i == 0) {
                            // 先重置嗵鼓鼓压圈数据
                            ringList[3] = []
                        }
                        ringList[3].push(data.list['up'][0])
                    }
                }
            }

            for (let i = 0; i < sizeObj[4].length; i++) {
                let item = sizeObj[4][i]
                let obj = {
                    type: 4,
                    diameter_id: item['diameter'],
                    nail_id: item['nail'],
                    id: this.ringObj[2][0],
                }
                let res = await this.drumRingLists(obj)
                if (res && res.code == 200) {
                    let data = res.data
                    if (data) {
                        ringObj2[4][i] = data.list['up'][0]['id']
                        if (i == 0) {
                            // 先重置嗵鼓鼓压圈数据
                            ringList[4] = []
                        }
                        ringList[4].push(data.list['up'][0])
                    }
                }
            }

            this.ringObj = ringObj2
            this.ringList = ringList

            // 获取另购鼓，嗵鼓/落地嗵的鼓压圈，并且帮忙选中
            this.checkOtherSelect()
            let another_tom = this.another_tom // 嗵鼓另购数量
            let another_landing_punch = this.another_landing_punch // 落地嗵另购数量
            if (another_tom == 1) {
                // 标准鼓选择了军鼓鼓压圈
                if (this.ringObj[2][0]) {
                    let res = await this.drumRingLists({
                        type: 3,
                        diameter_id: this.otherSizeObj[3]['diameter'],
                        nail_id: this.otherSizeObj[3]['nail'],
                        id: this.ringObj[2][0],
                    })
                    if (res && res.code == 200) {
                        let data = res.data
                        if (data) {
                            let ringList2 = this.$cloneDeep(this.ringList2)
                            ringList2[3] = data.list.up
                            this.ringList2 = ringList2

                            // 默认选中
                            let ringObj2 = this.$cloneDeep(this.ringObj2)
                            ringObj2[3] = data.list.up[0]['id']
                            this.ringObj2 = ringObj2
                        }
                    }
                } else {
                    let ringList2 = this.$cloneDeep(this.ringList2)
                    let ringObj2 = this.$cloneDeep(this.ringObj2)
                    ringList2[3] = []
                    ringObj2[3] = ''
                    this.ringList2 = ringList2
                    this.ringObj2 = ringObj2
                }
            }

            if (another_landing_punch == 1) {
                // 标准鼓选择了军鼓鼓压圈
                if (this.ringObj[2][0]) {
                    let res = await this.drumRingLists({
                        type: 4,
                        diameter_id: this.otherSizeObj[4]['diameter'],
                        nail_id: this.otherSizeObj[4]['nail'],
                        id: this.ringObj[2][0],
                    })
                    if (res && res.code == 200) {
                        let data = res.data
                        if (data) {
                            let ringList2 = this.$cloneDeep(this.ringList2)
                            ringList2[4] = data.list.up
                            this.ringList2 = ringList2

                            // 默认选中
                            let ringObj2 = this.$cloneDeep(this.ringObj2)
                            ringObj2[4] = data.list.up[0]['id']
                            this.ringObj2 = ringObj2
                        }
                    }
                } else {
                    let ringList2 = this.$cloneDeep(this.ringList2)
                    let ringObj2 = this.$cloneDeep(this.ringObj2)
                    ringList2[4] = []
                    ringObj2[4] = ''
                    this.ringList2 = ringList2
                    this.ringObj2 = ringObj2
                }
            }
        },
        // 选择鼓方案
        async selectPlane(item, id, sItem) {
            // if (!this.vuex_is_login) {
            //     alertErr('请先登录！')
            //     this.$router.push({
            //         path: '/login',
            //     })
            //     return
            // }

            // 判断是否为重复点击
            if (this.planeObj.id && this.planeObj.id == item.id && this.supporterObj == id) {
                console.log('重复点击！！')
                return
            }

            if (this.supporterObj) {
                let canGo = await this.$refs['HintTextWin'].init('此操作会删除您已选择的配置项，是否继续？', 1)
                if (canGo != 'confirm') {
                    return
                }
                // 切换鼓方案需要重置所有内容
                this.materialList = []
                this.materialObj = {
                    inside: '',
                    outside: '',
                }
                this.colorList = []
                this.colorListId = ''
                this.sizeList = {}
                this.sizeObj = {}
                this.sizeListId = 1
                this.ringList = {}
                this.ringObj = {}
                this.hangList = {}
                this.hangObj = {}
                this.tongLeg = {}
                this.earList = []
                this.earObj = {}
                this.screwList = []
                this.snareSwitchList = {
                    a: [],
                    b: [],
                }
                this.snareSwitchObj = {
                    a: '',
                    b: '',
                }
                this.snareList = []
                this.snareObj = []
                this.diLegList = []
                this.diLegObj = ''
                this.grappleList = []
                this.grappleObj = ''
                this.technologyList = []
                this.technologyObj = ''
                this.skinList = {}
                this.skinObj = {}
                this.skinListId = 1
                this.madeType = {
                    1: false,
                    2: false,
                    3: false,
                }
                this.inputType = 0
                this.uploadFileList = ['', '']
                this.hardwareList = []
                this.hardwareId = 1
                this.queryForm = []
                this.queryPrice = '--'
                this.remark = ''
                this.otherSizeList = {
                    diameter: [],
                    depth: [],
                    nail: [],
                }
                this.otherSizeObjShow = {
                    1: {},
                    2: {},
                    3: {},
                    4: {},
                }
                this.otherSizeObj = {
                    1: {},
                    2: {},
                    3: {},
                    4: {},
                }
                this.another_heaving_floor = 0
                this.another_military = 0
                this.another_tom = 0
                this.another_landing_punch = 0
                this.materialObj2Show = {
                    1: {
                        inside: '',
                        outside: '',
                    },
                    2: {
                        inside: '',
                        outside: '',
                    },
                    3: {
                        inside: '',
                        outside: '',
                    },
                    4: {
                        inside: '',
                        outside: '',
                    },
                }
                this.materialObj2 = {
                    1: {
                        inside: '',
                        outside: '',
                    },
                    2: {
                        inside: '',
                        outside: '',
                    },
                    3: {
                        inside: '',
                        outside: '',
                    },
                    4: {
                        inside: '',
                        outside: '',
                    },
                }
                this.colorListId2Show = {
                    1: '',
                    2: '',
                    3: '',
                    4: '',
                }
                this.colorListId2 = {
                    1: '',
                    2: '',
                    3: '',
                    4: '',
                }
                this.snareList2 = []
                this.snareObj2 = []
                this.skinList2 = {}
                this.skinObj2 = {
                    1: {
                        resonance_arr: '',
                        strike_arr: '',
                    },
                    2: {
                        resonance_arr: '',
                        strike_arr: '',
                    },
                    3: {
                        resonance_arr: '',
                        strike_arr: '',
                    },
                    4: {
                        resonance_arr: '',
                        strike_arr: '',
                    },
                }
                this.ringList2 = {
                    2: [],
                    3: [],
                    4: [],
                }
                this.ringObj2 = {
                    2: '',
                    3: '',
                    4: '',
                }
                this.hangList2 = {
                    3: [],
                    4: [],
                }
                this.hangObj2 = {
                    3: '',
                    4: '',
                }
                this.snareSwitchList2 = {
                    a: [],
                    b: [],
                }
                this.snareSwitchObj2 = {
                    a: '',
                    b: '',
                }
                this.caizhiName = ''
                this.yanseName = ''
                this.modelUrl = ''
            }

            this.getDrumMaterialLists() // 获取木材
            this.getDrumColorLists() // 获取颜色
            this.getDrumHardwareLists(id) // 获取硬件配置

            if ((item.id == 1 && sItem.id == 8) || (item.id == 1 && sItem.id == 37)) {
                this.caizhiName = '球形花梨木'
                this.yanseName = '淡琥珀哑光'
            } else if (item.id == 1 && sItem.id == 9) {
                this.caizhiName = '杨木'
                this.yanseName = '流光银'
            } else if (item.id == 1 && sItem.id == 12) {
                this.caizhiName = '雀眼枫木'
                this.yanseName = '苹果绿'
            } else if ((item.id == 2 && sItem.id == 14) || (item.id == 2 && sItem.id == 38)) {
                this.caizhiName = '橡木'
                this.yanseName = '黑色双渐层'
            } else if (item.id == 2 && sItem.id == 16) {
                this.caizhiName = '桦木'
                this.yanseName = '星空蓝单渐层'
            } else if (item.id == 2 && sItem.id == 17) {
                this.caizhiName = '杨木'
                this.yanseName = '酒红色'
            } else if ((item.id == 3 && sItem.id == 22) || (item.id == 3 && sItem.id == 39)) {
                this.caizhiName = '雀眼枫木'
                this.yanseName = '鎏金黄渐变'
            } else if (item.id == 3 && sItem.id == 24) {
                this.caizhiName = '水曲柳球影'
                this.yanseName = '日落三渐变'
            } else if (item.id == 3 && sItem.id == 25) {
                this.caizhiName = '杨木'
                this.yanseName = '金属紫'
            } else if (item.id == 4 && sItem.id == 27) {
                this.caizhiName = '大理石纹'
                this.yanseName = '原木色亮光'
            } else if (item.id == 4 && sItem.id == 28) {
                this.caizhiName = '大理石纹'
                this.yanseName = '原木色亮光'
            }
            // 此处3d模型渲染用
            let supporterList = item.supporter
            if (!this.isH5) {
                for (let index2 = 0; index2 < supporterList.length; index2++) {
                    let item2 = supporterList[index2]
                    if (item2.id == id) {
                        // if (this.modelUrl != item2.file_url) {
                        try {
                            let file_url = item2.file_url
                            let indexNum = file_url.indexOf('.gltf')
                            let small_file_url = file_url.slice(0, indexNum) + '-processed' + '.gltf'
                            // let small_file_url = file_url.slice(0, indexNum) + '.gltf'
                            this.modelUrl = small_file_url
                            this.$load.open()
                            await this.$refs['model_3d'].loadNewModel(small_file_url) // 切换模型
                            await this.get3dData() // 给新模型渲染颜色和材质
                            this.$load.close()
                        } catch (error) {}
                        break
                        // }
                    }
                }
            }

            this.planeObj = item
            this.supporterObj = id

            if (!this.isH5) {
                this.$refs['model_3d'].changeTop(item.id)
            }

            this.sizeListInit()
            this.sizeObjInit()
            // 获取底鼓直径
            let obj = {
                type: this.sizeListId,
            }
            let res = await this.drum_drumDiameterListsAjax(obj)
            if (res && res.code == 200) {
                let data = res.data
                let sizeList = this.$cloneDeep(this.sizeList)
                sizeList[this.sizeListId][0].diameter = data.list
                this.sizeList = sizeList
            }
            // this.ringObjInit() // 鼓压圈初始化
            // this.hangObjInit() // 悬挂初始化
            // this.earObjInit() // 鼓耳初始化
            // this.skinObjInit() // 鼓皮初始化

            // 获取落地嗵腿（会自动计算另购鼓）
            this.getTongLeg()

            // 获取响弦开关
            let obj2 = {
                plane_id: this.planeObj.id,
            }
            let res2 = await this.drumSnareSwitchLists(obj2)
            if (res2 && res2.code == 200) {
                let data = res2.data
                data.list.a_arr.forEach((item, index) => {
                    item.num = 1
                })
                data.list.b_arr.forEach((item, index) => {
                    item.num = 1
                })
                this.snareSwitchList = {
                    a: data.list.a_arr,
                    b: data.list.b_arr,
                }
                this.snareSwitchObj = {
                    a: '',
                    b: '',
                }
            }

            // 获取底鼓腿（会自动计算另购鼓）
            this.getDrumLegList()

            // 获取工艺（会自动计算另购鼓）
            await this.getDrumTechnologyList()
        },
        // 鼓方案列表
        async getDrumPlaneLists() {
            return new Promise(async (resolve, reject) => {
                let obj = {}
                let res = await this.drumPlaneLists(obj)
                if (res && res.code == 200) {
                    let data = res.data
                    this.planeList = data.list
                }
                resolve()
            })
        },
        // 材质
        async getDrumMaterialLists() {
            return new Promise(async (resolve, reject) => {
                let obj = {}
                let res = await this.drumMaterialLists(obj)
                if (res && res.code == 200) {
                    let data = res.data
                    this.materialList = data.list
                    this.materialList2 = data.list
                    this.materialList3 = data.list
                    this.materialList4 = data.list
                    this.materialList5 = data.list
                }
                resolve()
            })
        },
        // 颜色
        async getDrumColorLists() {
            return new Promise(async (resolve, reject) => {
                let obj = {}
                let res = await this.drumColorLists(obj)
                if (res && res.code == 200) {
                    let data = res.data
                    this.colorList = data.list
                    this.colorList2 = data.list
                    this.colorList3 = data.list
                    this.colorList4 = data.list
                    this.colorList5 = data.list
                }
                resolve()
            })
        },
        // 获取底鼓抓勾
        async getGrapple() {
            return new Promise(async (resolve, reject) => {
                this.checkOtherSelect()
                if (this.hangObj[3][0]) {
                    let obj = {
                        plane_id: this.planeObj.id,
                        gl_id: this.hangObj[3][0],
                    }
                    let nailList = []
                    this.sizeObj[1].forEach((item, index) => {
                        if (item.nail) {
                            nailList.push(item.nail)
                        }
                    })
                    if (this.another_heaving_floor == 1) {
                        if (this.otherSizeObj[1]['nail']) {
                            nailList.push(this.otherSizeObj[1]['nail'])
                            obj['another_heaving_floor'] = 1
                        }
                    }
                    obj['nail_id'] = nailList.toString()
                    let res = await this.drumGrappleLists(obj)
                    if (res && res.code == 200) {
                        let data = res.data
                        this.grappleList = data.list
                        if (data.list.length == 1) {
                            // 如果只有一项默认选中
                            this.grappleObj = data.list[0].id
                        } else {
                            // 否则要重新选择
                            this.grappleObj = ''
                        }
                    }
                }
                resolve()
            })
        },
        // 获取鼓螺丝
        async getScrew() {
            return new Promise(async (resolve, reject) => {
                // 4个for循环判断所有鼓是否选择了钉数，所有鼓都选择了钉数，才会获取鼓螺丝
                for (let i = 0; i < this.sizeObj[1].length; i++) {
                    let item = this.sizeObj[1][i]
                    if (!item.nail) {
                        resolve()
                        return
                    }
                }
                for (let i = 0; i < this.sizeObj[2].length; i++) {
                    let item = this.sizeObj[2][i]
                    if (!item.nail) {
                        resolve()
                        return
                    }
                }
                for (let i = 0; i < this.sizeObj[3].length; i++) {
                    let item = this.sizeObj[3][i]
                    if (!item.nail) {
                        resolve()
                        return
                    }
                }
                for (let i = 0; i < this.sizeObj[4].length; i++) {
                    let item = this.sizeObj[4][i]
                    if (!item.nail) {
                        resolve()
                        return
                    }
                }
                let slist = this.sizeObj[1]
                let slist2 = this.sizeObj[2]
                let slist3 = this.sizeObj[3]
                slist3 = [...this.sizeObj[3], ...this.sizeObj[4]] // 嗵鼓 和 落地嗵 算到一起
                let sListAll = [] // 底鼓钉id
                let sListAll2 = [] // 军鼓钉id
                let sListAll3 = [] // 嗵鼓钉id
                for (let index = 0; index < slist.length; index++) {
                    let item = slist[index]
                    if (item.nail != '') {
                        sListAll.push(item.nail)
                    }
                }
                for (let index = 0; index < slist2.length; index++) {
                    let item = slist2[index]
                    if (item.nail != '') {
                        sListAll2.push(item.nail)
                    }
                }
                for (let index = 0; index < slist3.length; index++) {
                    let item = slist3[index]
                    if (item.diameter != '' && item.nail != '') {
                        sListAll3.push({
                            diameter_id: item.diameter,
                            nail_id: item.nail,
                        })
                    }
                }
                let obj2 = {}
                if (this.otherSizeObj[1].nail) {
                    sListAll.push(this.otherSizeObj[1].nail)
                }
                if (this.otherSizeObj[2].nail) {
                    sListAll2.push(this.otherSizeObj[2].nail)
                }
                if (this.otherSizeObj[3].diameter && this.otherSizeObj[3].nail) {
                    sListAll3.push({
                        diameter_id: this.otherSizeObj[3].diameter,
                        nail_id: this.otherSizeObj[3].nail,
                    })
                }
                if (this.otherSizeObj[4].diameter && this.otherSizeObj[4].nail) {
                    sListAll3.push({
                        diameter_id: this.otherSizeObj[4].diameter,
                        nail_id: this.otherSizeObj[4].nail,
                    })
                }
                if (sListAll.length > 0) {
                    obj2['heaving_nail_id'] = sListAll.toString()
                }
                if (sListAll2.length > 0) {
                    obj2['military_nail_id'] = sListAll2.toString()
                }
                if (sListAll3.length > 0) {
                    obj2['tom_nail_id'] = JSON.stringify(sListAll3)
                }
                let res2 = await this.drumScrewLists(obj2)
                if (res2 && res2.code == 200) {
                    let data = res2.data
                    this.screwList = data.list
                }
                resolve()
            })
        },
        // 获取鼓耳
        async getEar(type) {
            return new Promise(async (resolve, reject) => {
                if (!(this.hangObj[3] && this.hangObj[3][0])) {
                    resolve()
                    return
                }

                if (!type) {
                    // 获取底鼓鼓耳
                    // 获取鼓耳前，需要重置鼓耳数据
                    this.earObjInit()
                    let nailArr = []
                    let depthArr = []
                    for (let i = 0; i < this.sizeObj[1].length; i++) {
                        let item = this.sizeObj[1][i]
                        nailArr.push(item.nail)
                        depthArr.push(item.depth)
                    }
                    // 加上另购鼓的深度和钉数
                    if (this.otherSizeObj[1]['nail'] && this.otherSizeObj[1]['depth']) {
                        nailArr.push(this.otherSizeObj[1]['nail'])
                        depthArr.push(this.otherSizeObj[1]['depth'])
                    }
                    let earRes = await this.drumEarLists({
                        type: 1,
                        nail_id: nailArr.toString(),
                        depth_id: depthArr.toString(),
                        hang_id: this.hangObj[3][0],
                    })
                    if (earRes && earRes.code == 200) {
                        let data = earRes.data
                        if (data) {
                            let earList = this.$cloneDeep(this.earList)
                            earList[1] = data.list
                            this.earList = earList
                            // 如果只有一项，默认选中
                            if (data.list.length == 1) {
                                let earObj = this.$cloneDeep(this.earObj)
                                earObj[1] = data.list[0]['id']
                                this.earObj = earObj
                                this.getEar('other')
                            }
                        }
                    }
                    resolve()
                } else {
                    // 获取军鼓和嗵鼓鼓耳
                    // 获取军鼓鼓耳
                    let nailArr2 = []
                    let depthArr2 = []
                    for (let i = 0; i < this.sizeObj[2].length; i++) {
                        let item = this.sizeObj[2][i]
                        nailArr2.push(item.nail)
                        depthArr2.push(item.depth)
                    }
                    // 加上另购鼓的深度和钉数
                    if (this.otherSizeObj[2]['nail'] && this.otherSizeObj[2]['depth']) {
                        nailArr2.push(this.otherSizeObj[2]['nail'])
                        depthArr2.push(this.otherSizeObj[2]['depth'])
                    }
                    let earRes2 = await this.drumEarLists({
                        type: 2,
                        nail_id: nailArr2.toString(),
                        depth_id: depthArr2.toString(),
                        hang_id: this.hangObj[3][0],
                        gl_id: this.earObj[1],
                    })
                    if (earRes2 && earRes2.code == 200) {
                        let data = earRes2.data
                        if (data) {
                            let earList = this.$cloneDeep(this.earList)
                            earList[2] = data.list
                            this.earList = earList

                            // 如果只有一项，默认选中
                            if (data.list.length == 1) {
                                let earObj = this.$cloneDeep(this.earObj)
                                earObj[2] = data.list[0]['id']
                                this.earObj = earObj
                            }
                        }
                    }

                    // 获取嗵鼓鼓耳（嗵鼓和落地嗵一起计算）
                    let nailArr3 = []
                    let depthArr3 = []
                    for (let i = 0; i < this.sizeObj[3].length; i++) {
                        let item = this.sizeObj[3][i]
                        nailArr3.push(item.nail)
                        depthArr3.push(item.depth)
                    }
                    for (let i = 0; i < this.sizeObj[4].length; i++) {
                        let item = this.sizeObj[4][i]
                        nailArr3.push(item.nail)
                        depthArr3.push(item.depth)
                    }
                    // 加上另购鼓的深度和钉数
                    if (this.otherSizeObj[3]['nail'] && this.otherSizeObj[3]['depth']) {
                        nailArr3.push(this.otherSizeObj[3]['nail'])
                        depthArr3.push(this.otherSizeObj[3]['depth'])
                    }
                    // 加上另购鼓的深度和钉数
                    if (this.otherSizeObj[4]['nail'] && this.otherSizeObj[4]['depth']) {
                        nailArr3.push(this.otherSizeObj[4]['nail'])
                        depthArr3.push(this.otherSizeObj[4]['depth'])
                    }
                    let earRes3 = await this.drumEarLists({
                        type: 3,
                        nail_id: nailArr3.toString(),
                        depth_id: depthArr3.toString(),
                        hang_id: this.hangObj[3][0],
                        gl_id: this.earObj[1],
                    })
                    if (earRes3 && earRes3.code == 200) {
                        let data = earRes3.data
                        if (data) {
                            let earList = this.$cloneDeep(this.earList)
                            earList[3] = data.list
                            this.earList = earList

                            // 如果只有一项，默认选中
                            if (data.list.length == 1) {
                                let earObj = this.$cloneDeep(this.earObj)
                                earObj[3] = data.list[0]['id']
                                this.earObj = earObj
                            }
                        }
                    }
                    resolve()
                }
            })
        },
        // 底鼓腿
        drumLegLists(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'drum_drumLegLists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        // 响弦开关
        drumSnareSwitchLists(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'drum_drumSnareSwitchLists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        // 鼓螺丝
        drumScrewLists(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'drum_drumScrewLists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        // 抓钩
        drumGrappleLists(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'drum_drumGrappleLists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        // 鼓耳
        drumEarLists(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'drum_drumEarLists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        // 落地嗵腿
        drumTongLegLists(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'drum_drumTongLegLists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        drumHangLists(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'drum_drumHangLists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        drumRenderingListsAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'drum_drumRenderingLists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        drumSupporterListsAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'drum_drumSupporterLists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        drumPlaneLists(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'drum_drumPlaneLists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        drumMaterialLists(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'drum_drumMaterialLists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        drumColorLists(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'drum_drumcolorLists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        drum_drumNailListsAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'drum_drumNailLists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        drum_drumDepthListsAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'drum_drumDepthLists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        drum_drumDiameterListsAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'drum_drumDiameterLists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        drumSnareLists(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'drum_drumSnareLists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        drumRingLists(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'drum_drumRingLists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        drumTechnologyLists(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'drum_drumTechnologyLists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        drumSkinLists(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'drum_drumSkinLists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        drumHardwareLists(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'drum_drumHardwareLists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        drumPayinfo(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'drumorder_drumPayinfo',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        setDraftAjax(obj) {
            return new Promise(async (resolve, reject) => {
                axios({
                    method: 'post',
                    url: 'https://hailungushang.com/service.php',
                    headers: {},
                    data: obj,
                }).then((res) => {})
            })
        },
        getDraftAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'drumorder_getDraft',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        getQueryFromParams() {
            this.checkOtherSelect()

            let plane_id = this.planeObj.id // 方案

            let price_json = []
            {
                // 标准鼓
                let heaving_floor_num = this.planeObj.heaving_floor_num // 底鼓
                let military_drum_num = this.planeObj.military_drum_num // 军鼓
                let tom_drum_num = this.planeObj.tom_drum_num // 嗵鼓
                let landing_punch_num = this.planeObj.landing_punch_num // 落地嗵
                for (let i = 0; i < heaving_floor_num; i++) {
                    price_json.push({
                        type_id: 1,
                        material: {
                            nei: this.materialObj.inside,
                            wai: this.materialObj.outside,
                        },
                        diameter: this.sizeObj[1][i]['diameter'],
                        depth: this.sizeObj[1][i]['depth'],
                    })
                }
                for (let i = 0; i < military_drum_num; i++) {
                    price_json.push({
                        type_id: 2,
                        material: {
                            nei: this.materialObj.inside,
                            wai: this.materialObj.outside,
                        },
                        diameter: this.sizeObj[2][i]['diameter'],
                        depth: this.sizeObj[2][i]['depth'],
                    })
                }
                for (let i = 0; i < tom_drum_num; i++) {
                    price_json.push({
                        type_id: 3,
                        material: {
                            nei: this.materialObj.inside,
                            wai: this.materialObj.outside,
                        },
                        diameter: this.sizeObj[3] ? this.sizeObj[3][i]['diameter'] : '',
                        depth: this.sizeObj[3] ? this.sizeObj[3][i]['depth'] : '',
                    })
                }
                for (let i = 0; i < landing_punch_num; i++) {
                    price_json.push({
                        type_id: 4,
                        material: {
                            nei: this.materialObj.inside,
                            wai: this.materialObj.outside,
                        },
                        diameter: this.sizeObj[4][i]['diameter'],
                        depth: this.sizeObj[4][i]['depth'],
                    })
                }

                // 另购-底鼓
                let otherType = this.checkOtherSelect()
                if (otherType[1]) {
                    price_json.push({
                        type_id: 1,
                        material: {
                            nei: this.materialObj2[1].inside,
                            wai: this.materialObj2[1].outside,
                        },
                        diameter: this.otherSizeObj[1]['diameter'],
                        depth: this.otherSizeObj[1]['depth'],
                    })
                }
                if (otherType[2]) {
                    price_json.push({
                        type_id: 2,
                        material: {
                            nei: this.materialObj2[2].inside,
                            wai: this.materialObj2[2].outside,
                        },
                        diameter: this.otherSizeObj[2]['diameter'],
                        depth: this.otherSizeObj[2]['depth'],
                    })
                }
                if (otherType[3]) {
                    price_json.push({
                        type_id: 3,
                        material: {
                            nei: this.materialObj2[3].inside,
                            wai: this.materialObj2[3].outside,
                        },
                        diameter: this.otherSizeObj[3]['diameter'],
                        depth: this.otherSizeObj[3]['depth'],
                    })
                }
                if (otherType[4]) {
                    price_json.push({
                        type_id: 4,
                        material: {
                            nei: this.materialObj2[4].inside,
                            wai: this.materialObj2[4].outside,
                        },
                        diameter: this.otherSizeObj[4]['diameter'],
                        depth: this.otherSizeObj[4]['depth'],
                    })
                }
            }

            // 尺寸
            let size_json = []
            let sizeObj = this.sizeObj
            for (let key in sizeObj) {
                let value = sizeObj[key]
                value.forEach((item, index) => {
                    size_json.push({
                        type: key,
                        ...item,
                    })
                })
            }

            let otherSizeObj = this.otherSizeObj
            size_json.push({
                type: 1,
                ...otherSizeObj[1],
            })
            size_json.push({
                type: 2,
                ...otherSizeObj[2],
            })
            size_json.push({
                type: 3,
                ...otherSizeObj[3],
            })
            size_json.push({
                type: 4,
                ...otherSizeObj[4],
            })

            // 材质
            let material_json = []
            let materialObj = this.materialObj
            material_json.push({
                type: 2,
                id: materialObj.outside,
                g_type: 0,
            })
            material_json.push({
                type: 1,
                id: materialObj.inside,
                g_type: 0,
            })
            for (let key in this.materialObj2) {
                let value = this.materialObj2[key]
                material_json.push({
                    type: 2,
                    id: value.outside,
                    g_type: key,
                })
                material_json.push({
                    type: 1,
                    id: value.inside,
                    g_type: key,
                })
            }

            // 颜色
            let color_arr = []
            if (this.colorListId) {
                color_arr.push(this.colorListId)
            }
            for (let key in this.colorListId2) {
                let value = this.colorListId2[key]
                if (value) {
                    color_arr.push(value)
                }
            }
            let color_str = color_arr.toString()

            // 鼓压圈
            let ring_json = []
            let ringObj = this.ringObj
            for (let key in ringObj) {
                let value = ringObj[key]
                value.forEach((item, index) => {
                    ring_json.push({
                        type: key,
                        up: item,
                    })
                })
            }
            let ringObj2 = this.ringObj2
            for (let key in ringObj2) {
                let value = ringObj2[key]
                ring_json.push({
                    type: key,
                    up: value,
                })
            }

            // 鼓悬挂
            let hang_json = []
            let hangObj = this.hangObj
            for (let key in hangObj) {
                let value = hangObj[key]
                value.forEach((item, index) => {
                    hang_json.push({
                        type: key,
                        id: item,
                    })
                })
            }
            let hangObj2 = this.hangObj2
            for (let key in hangObj2) {
                let value = hangObj2[key]
                hang_json.push({
                    type: key,
                    id: value,
                })
            }

            // 落地嗵腿
            let tongleg_id = this.tongLeg.id

            // 鼓耳
            let ear_json = []
            let earObj = this.earObj
            for (let key in earObj) {
                let value = earObj[key]
                if (key == 2) {
                    // 军鼓需要传 钉数 和 深度
                    let objs = {
                        type: key,
                        id: value,
                    }

                    // 传标准鼓 钉数 和 深度
                    if (this.sizeObj[2][0].nail) {
                        objs['nail_id'] = this.sizeObj[2][0].nail
                    }

                    if (this.sizeObj[2][0].depth) {
                        objs['depth_id'] = this.sizeObj[2][0].depth
                    }

                    if (this.planeObj.military_drum_num == 1) {
                        // 传 另购鼓 钉数 和 深度
                        if (this.otherSizeObj[2].nail) {
                            objs['nail_id2'] = this.otherSizeObj[2].nail
                        }

                        if (this.otherSizeObj[2].depth) {
                            objs['depth_id2'] = this.otherSizeObj[2].depth
                        }
                    }
                    ear_json.push({
                        ...objs,
                    })
                } else {
                    ear_json.push({
                        type: key,
                        id: value,
                    })
                }
            }

            // 响弦开关
            let snare_switch_json = []
            let snareSwitchObj = this.snareSwitchObj
            let snareSwitchObj2 = this.snareSwitchObj2
            if (true) {
                let list = this.snareSwitchList.a
                for (let index = 0; index < list.length; index++) {
                    let item = list[index]
                    if (item.id == snareSwitchObj.a) {
                        snare_switch_json.push({
                            type: 1,
                            id: snareSwitchObj.a,
                            num: item.num,
                        })
                        break
                    }
                }

                let list2 = this.snareSwitchList.b
                for (let index2 = 0; index2 < list2.length; index2++) {
                    let item2 = list2[index2]
                    if (item2.id == snareSwitchObj.b) {
                        snare_switch_json.push({
                            type: 2,
                            id: snareSwitchObj.b,
                            num: item2.num,
                        })
                        break
                    }
                }

                let list3 = this.snareSwitchList2.a
                for (let index3 = 0; index3 < list3.length; index3++) {
                    let item3 = list3[index3]
                    if (item3.id == snareSwitchObj2.a) {
                        snare_switch_json.push({
                            type: 1,
                            id: snareSwitchObj2.a,
                            num: item3.num,
                        })
                        break
                    }
                }

                let list4 = this.snareSwitchList2.b
                for (let index4 = 0; index4 < list4.length; index4++) {
                    let item4 = list4[index4]
                    if (item4.id == snareSwitchObj2.b) {
                        snare_switch_json.push({
                            type: 2,
                            id: snareSwitchObj2.b,
                            num: item4.num,
                        })
                        break
                    }
                }
            }

            // 响弦
            let snare_json = []
            if (this.snareObj[0] && this.snareObj[0].id) {
                let snareId = this.snareObj[0].id
                let list = this.snareList[0].list
                for (let index = 0; index < list.length; index++) {
                    let item = list[index]
                    if (item.id == snareId) {
                        snare_json.push({
                            id: snareId,
                            num: item.num,
                        })
                        break
                    }
                }
            }
            if (this.snareObj2[0] && this.snareObj2[0].id) {
                let snareId2 = this.snareObj2[0].id
                let list = this.snareList2[0].list
                for (let index = 0; index < list.length; index++) {
                    let item = list[index]
                    if (item.id == snareId2) {
                        snare_json.push({
                            id: snareId2,
                            num: item.num,
                        })
                        break
                    }
                }
            }

            // 底鼓腿
            let leg_json = []
            let diLegObj = this.diLegObj
            leg_json.push({
                id: diLegObj,
            })

            // 底鼓抓钩
            let grapple_id = this.grappleObj

            // 工艺
            let technology_id = this.technologyObj

            // 鼓皮
            let skin_json = []
            let skinObj = this.skinObj
            for (let key in skinObj) {
                let value = skinObj[key]
                value.forEach((item, index) => {
                    skin_json.push({
                        type: key,
                        resonance_id: item.resonance_arr,
                        strike_id: item.strike_arr,
                    })
                })
            }
            let skinObj2 = this.skinObj2
            for (let key in skinObj2) {
                let value = skinObj2[key]
                skin_json.push({
                    type: key,
                    resonance_id: value.resonance_arr,
                    strike_id: value.strike_arr,
                })
            }

            // 硬件配置
            let hardware_json = []
            let hardwareList = this.hardwareList
            hardwareList.forEach((item, index) => {
                if (item.child && item.child.length) {
                    item.child.forEach((item2, index2) => {
                        if (item2.select == 1) {
                            hardware_json.push({
                                id: item2.id,
                                num: item2.num,
                            })
                        }
                    })
                }
            })

            // 鼓螺丝
            let screw_json = []
            {
                let slist = this.sizeObj[1]
                let slist2 = this.sizeObj[2]
                let slist3 = this.sizeObj[3]
                slist3 = [...this.sizeObj[3], ...this.sizeObj[4]] // 嗵鼓 和 落地嗵 算到一起
                let sListAll = [] // 底鼓钉id
                let sListAll2 = [] // 军鼓钉id
                let sListAll3 = [] // 嗵鼓钉id
                for (let index = 0; index < slist.length; index++) {
                    let item = slist[index]
                    if (item.nail != '') {
                        sListAll.push(item.nail)
                    }
                }
                for (let index = 0; index < slist2.length; index++) {
                    let item = slist2[index]
                    if (item.nail != '') {
                        sListAll2.push(item.nail)
                    }
                }
                for (let index = 0; index < slist3.length; index++) {
                    let item = slist3[index]
                    if (item.diameter != '' && item.nail != '') {
                        sListAll3.push({
                            diameter_id: item.diameter,
                            nail_id: item.nail,
                        })
                    }
                }
                let obj2 = {}
                if (this.otherSizeObj[1].nail) {
                    sListAll.push(this.otherSizeObj[1].nail)
                }
                if (this.otherSizeObj[2].nail) {
                    sListAll2.push(this.otherSizeObj[2].nail)
                }
                if (this.otherSizeObj[3].diameter && this.otherSizeObj[3].nail) {
                    sListAll3.push({
                        diameter_id: this.otherSizeObj[3].diameter,
                        nail_id: this.otherSizeObj[3].nail,
                    })
                }
                if (this.otherSizeObj[4].diameter && this.otherSizeObj[4].nail) {
                    sListAll3.push({
                        diameter_id: this.otherSizeObj[4].diameter,
                        nail_id: this.otherSizeObj[4].nail,
                    })
                }
                if (sListAll.length > 0) {
                    obj2['heaving_nail_id'] = sListAll.toString()
                }
                if (sListAll2.length > 0) {
                    obj2['military_nail_id'] = sListAll2.toString()
                }
                if (sListAll3.length > 0) {
                    obj2['tom_nail_id'] = JSON.stringify(sListAll3)
                }
                screw_json = obj2
            }

            let obj = {
                supporter_id: this.supporterObj,
                plane_id,
                price_json: JSON.stringify(price_json),
                size_json: JSON.stringify(size_json),
                material_json: JSON.stringify(material_json),
                color_str,
                ring_json: JSON.stringify(ring_json),
                hang_json: JSON.stringify(hang_json),
                tongleg_id,
                ear_json: JSON.stringify(ear_json),
                snare_switch_json: JSON.stringify(snare_switch_json),
                snare_json: JSON.stringify(snare_json),
                leg_json: JSON.stringify(leg_json),
                grapple_id,
                technology_id,
                skin_json: JSON.stringify(skin_json),
                hardware_json: JSON.stringify(hardware_json),
                screw_json: JSON.stringify(screw_json),
            }

            if (this.another_heaving_floor == 1) {
                obj['another_heaving_floor'] = 1
            }

            if (this.another_military == 1) {
                obj['another_military'] = 1
            }

            if (this.another_tom == 1) {
                obj['another_tom'] = 1
            }

            if (this.another_landing_punch == 1) {
                obj['another_landing_punch'] = 1
            }

            if (this.planeColumn == 1 || this.planeColumn == 2) {
                if (this.planeObj.id == 4) {
                    obj['parameter1'] = 1
                    obj['parameter2'] = 1
                } else {
                    obj['parameter2'] = 1
                }
            } else if (this.planeColumn == 3) {
                if (this.planeObj.id == 1) {
                    obj['parameter3'] = 1
                }
            } else if (this.planeColumn == 4) {
                if (this.planeObj.id == 2) {
                    obj['parameter4'] = 1
                } else if (this.planeObj.id == 3) {
                    obj['parameter4'] = 1
                }
            } else if (this.planeColumn == 5) {
                if (this.planeObj.id == 2) {
                    obj['parameter5'] = 1
                } else if (this.planeObj.id == 3) {
                    obj['parameter5'] = 1
                }
            } else if (this.planeColumn == 6) {
                if (this.planeObj.id == 1) {
                    obj['parameter6'] = 1
                }
            }

            return obj
        },
        // 查看配置清单弹出
        async queryCheckList() {
            this.setDraft()
            this.checklistWin = true
            let res = await this.drumPayinfo(this.getQueryFromParams())
            if (res && res.code == 200) {
                let data = res.data
                // 去除基础价格
                // if (data.list) {
                //     data.list.splice(0, 1)
                // }
                this.queryForm = data.list ? data.list : []
                this.queryPrice = data.price
            }
        },
        uploadFun(type) {
            this.inputType = type
            this.$refs.fileInput.click()
        },
        // 上传input变化
        async imgInputChange() {
            const file = this.$refs['fileInput'].files[0]
            const fileName = file.name // 文件名字
            const index = file.name.lastIndexOf('.')
            const ext = file.name.substr(index + 1) // 文件类型
            const size = file.size / 1024 / 1024 // 文件大小（单位：MB）

            let fileType = ['pdf', 'PDF', 'ai'] // 有效文件类型
            if (!fileType.includes(ext)) {
                alertErr('请上传pdf文件或ai文件')
                return
            }
            this.$load.open()
            let res = await this.$uploadFile(file)
            this.$load.close()
            if (res) {
                let uploadFileList = this.$cloneDeep(this.uploadFileList)
                if (this.inputType == 1) {
                    // 上传的鼓腔
                    uploadFileList[0] = res
                } else if (this.inputType == 2) {
                    // 上传的共鸣皮
                    uploadFileList[1] = res
                }
                this.uploadFileList = uploadFileList
            } else {
                alert('上传失败')
            }
            this.$refs['fileInput'].value = ''
            this.inputType = 0
        },
    },
}
</script>

<style scoped lang="less">
// 分割线、标题、灰色标题、计数器、x5、个性签名定制、圆形select，样式写在最外层了
// 圆形select：在 dianBox 加 active 是橘黄色；加 unActive 是灰色
// 分割线：<div class="commonLine"></div>
// 大标题：<div class="titleBox"><div class="title">底鼓抓钩</div></div>
// 灰色标题：<div class="greyTitleBox">9系硬件</div>
// 计数器：<div class="selectNumBox"><div class="del"><img src="@/assets/img/productList/jian.png" class="jianIcon" alt="" /></div><div class="numInput">99</div><div class="add"><img src="@/assets/img/productList/jia.png" class="jiaIcon" alt="" /></div></div>
.wrap {
    width: @width;
    overflow: hidden;
    margin: 0 auto;

    &.martop {
        margin-top: -70px;
    }
}

.flexLeftBtn {
}

.video-js .vjs-volume-control,
.video-js .vjs-fullscreen-control {
    display: none;
}

.cell-move {
    transition: transform 0.5s;
}

/deep/ .modal-custom {
    .videoBox {
        width: 100%;
        height: 500px;
        margin: 0 auto;

        .video {
            display: block;
            width: 100%;
            height: 100%;
        }
    }
}

.kefuImg {
    display: block;
    margin: 0 auto;
    width: 250px;
}

.selectTitleFlexBox {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .mySelectTitle {
        width: 75%;
    }

    .mySelectNum {
        widows: 25%;
    }
}

.winTitleComm {
    width: 100%;
    text-align: left;
    font-weight: bold;
    font-size: 18px;
    color: #000000;
    line-height: 18px;
    margin-bottom: 20px;
    margin-top: 35px;
}

.recommend {
    width: 40px;
    height: 21px;
    background: #ff4d00;
    border-radius: 3px 3px 3px 3px;
    font-size: 12px;
    color: #ffffff;
    line-height: 21px;
    text-align: center;
}

.previewImgBox {
    width: 330px;
    height: 330px;
    background: #ffffff;
    box-sizing: border-box;
    // padding-top: 20px;

    .previewImg {
        width: 330px;
        height: 330px;
        margin: 0 auto;
        display: block;
    }

    .previewImgText {
        display: none;
        box-sizing: border-box;
        padding: 12px 0;
        font-size: 20px;
        color: #000000;
        line-height: 20px;
        text-align: center;
    }
}

.fill50 {
    width: 100%;
    height: 50px;
}

.fill40 {
    width: 100%;
    height: 40px;
}

// 灰色背景标题
.greyTitleBox {
    width: 100%;
    box-sizing: border-box;
    padding: 0 23px;
    height: 40px;
    background: rgba(85, 85, 85, 0.15);
    border-radius: 0px 0px 0px 0px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 18px;
    color: #000000;
    line-height: 34px;
    font-weight: 500;
    position: relative;

    .small {
        font-size: 14px;
        color: #999999;
        line-height: 34px;
        height: 30px;
    }
}

// 选中圆圈
.dianBox {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #000000;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
    position: relative;

    .dianActive {
        width: 12px;
        height: 12px;
        background: #ff4d00;
        border-radius: 50%;
        box-sizing: border-box;
        display: none;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    &.active {
        .dianActive {
            display: block;
        }
    }

    &.unActive {
        .dianActive {
            display: block !important;
            background: #555555 !important;
        }
    }
}

.forItem {
    width: 100%;
    margin-top: 20px;

    &:nth-child(1) {
        margin-top: 0;
    }
}

.numBigBox {
    margin-top: 20px;
    margin-bottom: 20ox;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .title {
        font-weight: bold;
        font-size: 16px;
        color: #000000;
        line-height: 16px;
        margin-right: 30px;
    }
}

.delOther {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
}

.winBuySub {
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
    line-height: 0px;
    width: 200px;
    height: 50px;
    display: block;
    margin: 30px auto 0 auto;
}

.otherWin {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 12;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;

    .winBox {
        width: 1400px;
        height: 90vh;
        background: #ffffff;
        border-radius: 16px;
        box-sizing: border-box;
        padding: 26px;

        .winContentScrollBox {
            width: 100%;
            height: calc(100% - 50px - 20px - 20px - 20px);
            overflow-x: hidden;
            overflow-y: auto;
            box-sizing: border-box;
            // padding-right: 10px;

            // &::-webkit-scrollbar {
            //     width: 8px;
            // }

            // &::-webkit-scrollbar-track {
            //     // 背景
            //     background-color: #999999;
            // }

            // &::-webkit-scrollbar-thumb {
            //     // 滚动块
            //     background-color: #ff4d00;
            // }
        }

        .bottomBtnBox {
            width: 100%;
            height: 50px;
            margin-top: 20px;

            .subWinBtn {
                display: block;
                margin: 0 auto;
                width: 200px;
                height: 50px;
                background: #ff4d00;
            }
        }

        .titleBox {
            width: 100%;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 20px;

            .title {
                font-weight: bold;
                font-size: 20px;
                color: #000000;
                line-height: 20px;
            }

            .winCloseBtnI {
                font-size: 30px;
                line-height: 20px;
                cursor: pointer;
            }
        }
    }
}

.colorBox {
    width: 100%;
    overflow: hidden;

    .flexWrapBox12ScrollBox {
        width: 100%;
        max-height: 250px;
        // margin-top: 10px;
        overflow-x: hidden;
        overflow-y: auto;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-wrap: wrap;
        // padding-right: 1.5%;

        // &::-webkit-scrollbar {
        //     width: 8px;
        // }

        // &::-webkit-scrollbar-track {
        //     // 背景
        //     background-color: #999999;
        // }

        // &::-webkit-scrollbar-thumb {
        //     // 滚动块
        //     background-color: #ff4d00;
        // }

        & > span {
            width: calc(((100% - 6px) - 18px * 15) / 16);
            margin-right: 18px;
            margin-top: 6px;
            cursor: pointer;

            .elImgBox {
                width: 100%;
                height: 0;
                padding-bottom: 100%;
                margin-bottom: 5px;
                position: relative;

                .img {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                }
            }

            .title {
                font-weight: 400;
                font-size: 12px;
                color: #555555;
                line-height: 20px;
                height: 60px;
                width: 100%;
                text-align: start;
                display: flex;
                align-items: center;
                justify-content: flex-start;
            }

            .bottomFlexBox {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .selectBtn {
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    border: 1px solid #000000;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    &.active {
                        .selectBtnActive {
                            display: block;
                        }
                    }

                    .selectBtnActive {
                        display: none;
                        width: 12px;
                        height: 12px;
                        background: #ff4d00;
                        border-radius: 50%;
                    }
                }
            }

            &:nth-child(-n + 16) {
                margin-top: 0;
            }

            &:nth-child(16n) {
                margin-right: 0;
            }
        }

        .itemBox {
            width: 100%;
        }
    }

    .flexWrapBox12ScrollBox1-2 {
        width: 100%;
        max-height: 250px;
        // margin-top: 10px;
        overflow-x: hidden;
        overflow-y: auto;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-wrap: wrap;
        // padding-right: 1.5%;

        // &::-webkit-scrollbar {
        //     width: 8px;
        // }

        // &::-webkit-scrollbar-track {
        //     // 背景
        //     background-color: #999999;
        // }

        // &::-webkit-scrollbar-thumb {
        //     // 滚动块
        //     background-color: #ff4d00;
        // }

        & > span {
            width: calc(((100% - 6px) - 18px * 7) / 8);
            margin-right: 18px;
            margin-top: 6px;
            cursor: pointer;

            .elImgBox {
                width: 100%;
                height: 0;
                padding-bottom: 100%;
                margin-bottom: 5px;
                position: relative;

                .img {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                }
            }

            .title {
                font-weight: 400;
                font-size: 14px;
                color: #555555;
                line-height: 20px;
                height: 60px;
                width: 100%;
                text-align: start;
                display: flex;
                align-items: center;
                justify-content: flex-start;
            }

            .bottomFlexBox {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .selectBtn {
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    border: 1px solid #000000;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    &.active {
                        .selectBtnActive {
                            display: block;
                        }
                    }

                    .selectBtnActive {
                        display: none;
                        width: 12px;
                        height: 12px;
                        background: #ff4d00;
                        border-radius: 50%;
                    }
                }
            }

            &:nth-child(-n + 8) {
                margin-top: 0;
            }

            &:nth-child(8n) {
                margin-right: 0;
            }
        }

        .itemBox {
            width: 100%;
        }
    }

    .flexWrapBox12ScrollBox2 {
        width: 100%;
        max-height: 250px;
        // margin-top: 10px;
        overflow-x: hidden;
        overflow-y: auto;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-wrap: wrap;
        // padding-right: 1.5%;

        // &::-webkit-scrollbar {
        //     width: 8px;
        // }

        // &::-webkit-scrollbar-track {
        //     // 背景
        //     background-color: #999999;
        // }

        // &::-webkit-scrollbar-thumb {
        //     // 滚动块
        //     background-color: #ff4d00;
        // }

        & > span {
            width: calc(((100% - 6px) - 14px * 1) / 2);
            margin-right: 14px;
            margin-top: 20px;
            cursor: pointer;

            .elImgBox {
                width: 100%;
                height: 0;
                padding-bottom: 100%;
                margin-bottom: 5px;
                position: relative;

                .img {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                }
            }

            .title {
                font-weight: 400;
                font-size: 14px;
                color: #555555;
                line-height: 20px;
                height: 60px;
                width: 100%;
                text-align: start;
                display: flex;
                align-items: center;
                justify-content: flex-start;
            }

            .bottomFlexBox {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .selectBtn {
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    border: 1px solid #000000;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    &.active {
                        .selectBtnActive {
                            display: block;
                        }
                    }

                    .selectBtnActive {
                        display: none;
                        width: 12px;
                        height: 12px;
                        background: #ff4d00;
                        border-radius: 50%;
                    }
                }
            }

            &:nth-child(-n + 2) {
                margin-top: 0;
            }

            &:nth-child(2n) {
                margin-right: 0;
            }
        }

        .itemBox {
            width: 100%;
        }
    }
}

.caizhiBox {
    width: 100%;
    overflow: hidden;

    .centerLine {
        width: 1px;
        height: calc(100% - 60px);
        background: rgba(112, 112, 112, 0.9);
        position: absolute;
        top: 60px;
        left: 50%;
        transform: translateX(-50%);
    }

    .wrapBox > span {
        width: calc((100% - 20px * 7) / 8);
        margin-right: 20px;
        margin-top: 20px;

        &:nth-child(8n) {
            margin-right: 0;
        }

        &:nth-child(-n + 8) {
            margin-top: 0;
        }
    }

    .wrapBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;
        margin-top: 10px;
        position: relative;

        .item {
            width: 100%;
            min-height: 120px;
            cursor: pointer;

            .bottomFlexBox {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .selectBtn {
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    border: 1px solid #000000;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    &.active {
                        .selectBtnActive {
                            display: block;
                        }
                    }

                    .selectBtnActive {
                        display: none;
                        width: 12px;
                        height: 12px;
                        background: #ff4d00;
                        border-radius: 50%;
                    }
                }

                .playVideoIcon {
                    width: 23px;
                    height: 15px;
                    background: url('../../assets/img/productList/video.png') no-repeat;
                    background-size: 100% 100%;
                    position: relative;
                    cursor: pointer;

                    .hintVideoText {
                        width: 60px;
                        height: 23px;
                        background: #ededed;
                        border-radius: 0px 0px 0px 0px;
                        border: 1px solid rgba(112, 112, 112, 0.5);
                        display: none;
                        align-items: center;
                        justify-content: center;
                        font-weight: 400;
                        font-size: 12px;
                        color: #555555;
                        line-height: 12px;
                        position: absolute;
                        top: 15px;
                        left: 23px;
                    }

                    &:hover {
                        background: url('../../assets/img/productList/video2.png') no-repeat;
                        background-size: 100% 100%;

                        .hintVideoText {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                    }
                }
            }

            .elImgBox {
                width: 100%;
                height: 0;
                padding-bottom: 100%;
                position: relative;
                margin-bottom: 3px;

                .img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                }
            }

            .title {
                width: 100%;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                font-weight: 400;
                font-size: 12px;
                color: #555555;
                line-height: 20px;
                text-align: start;
            }

            &:nth-child(7n) {
                margin-right: 0;
            }

            &:nth-child(-n + 7) {
                margin-top: 0;
            }
        }
    }
}

.winContentBox {
    width: 100%;
    margin-top: 20px;
    overflow: hidden;

    .item {
        width: 100%;

        .title {
            width: 100%;
            text-align: left;
            font-weight: bold;
            font-size: 16px;
            color: #000000;
            line-height: 16px;
            margin-bottom: 26px;
        }

        .flexBox {
            width: 100%;
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            flex-wrap: wrap;
            margin-top: 20px;

            .flexItemBox {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 10px;
                margin-bottom: 20px;

                .itemTitle {
                    font-weight: 400;
                    font-size: 16px;
                    color: #555555;
                    line-height: 20px;
                    margin-left: 12px;
                }
            }
        }
    }
}

// 选数字加减
.selectNumBox {
    width: 80px;
    height: 24px;
    background: #ffffff;
    border-radius: 0px 0px 0px 0px;
    border: 1px solid #d5d8de;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .del {
        flex: 1;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border-right: 1px solid #d5d8de;

        .jianIcon {
            width: 10px;
            height: 10px;
        }
    }

    .numInput {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 14px;
    }

    .add {
        flex: 1;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border-left: 1px solid #d5d8de;

        .jiaIcon {
            width: 10px;
            height: 10px;
        }
    }
}

// 数字展示
.selectNum {
    width: 80px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #555555;
    height: 24px;
    text-align: right;
}

.winCloseImg {
    font-size: 25px;
    color: #ffffff;
    cursor: pointer;
}

.contentScrollView {
    width: 100%;
    // height: calc(100vh - 50px - 35px - 532px + 88px);
    height: 59.65vh;
    overflow-x: hidden;
    overflow-y: auto;
    // padding-right: 12px;
    box-sizing: border-box;

    // &::-webkit-scrollbar-button:start:decrement {
    //     background-image: url('../../assets/img/index/up.png');
    //     background-repeat: no-repeat;
    //     background-position: center center;
    //     background-size: 18px 18px;
    // }

    // &::-webkit-scrollbar-button:end:increment {
    //     background-image: url('../../assets/img/index/down.png');
    //     background-repeat: no-repeat;
    //     background-position: center center;
    //     background-size: 18px 18px;
    // }

    // 上传个性签名定制
    .uploadBigLine {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .uploadIntroTitle {
            font-weight: bold;
            font-size: 16px;
            color: #555555;
            line-height: 16px;
            margin: 0 24px 0 12px;
            cursor: pointer;

            .smallText {
                font-size: 12px;
                color: #555555;
                line-height: 12px;
            }
        }

        .redHintText {
            font-weight: 400;
            font-size: 12px;
            color: rgba(255, 77, 0, 0.7);
            line-height: 12px;
            cursor: pointer;
        }
    }

    // 标题
    .titleBox {
        width: 100%;
        display: flex;
        align-items: flex-end;
        justify-content: flex-start;
        margin-bottom: 20px;

        .title {
            font-weight: bold;
            font-size: 20px;
            color: #000000;
            line-height: 20px;
            margin-right: 24px;
        }

        .title2 {
            font-weight: 400;
            font-size: 15px;
            color: #555555;
            line-height: 15px;
        }
    }

    // 分割线
    .commonLine {
        width: 100%;
        height: 30px;
        // background: #dddddd;
        // background: rgba(0, 0, 0, 0.8);
        // background: #ff4d00;
        // margin: 10px 0;
    }

    .flexWrapBox {
        width: 100%;

        .sizeSwitchBigBox {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;

            .item {
                width: calc((100% - 20px * 3) / 4);
                height: 40px;
                margin-right: 20px;
                background: rgba(85, 85, 85, 0.15);
                border-radius: 3px 3px 3px 3px;
                font-size: 18px;
                color: #000000;
                line-height: 18px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                padding: 0 23px;
                cursor: pointer;
                // opacity: 0.25;

                &:nth-child(4n) {
                    margin-right: 0;
                }

                &.active {
                    background: #ff4d00;
                    color: #ffffff;
                    opacity: 1;
                }

                &:hover {
                    background: #ff4d00;
                    color: #ffffff;
                    opacity: 1;
                }
            }
        }

        .myFlex {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
        }

        .sizeBigBoxContent {
            width: calc(((100% - 20px * 3) / 4));
            margin-top: 10px;
            overflow: hidden;
        }

        .sizeBigBox {
            width: 100%;
            // display: flex;
            // align-items: flex-start;
            // justify-content: flex-start;
            // flex-wrap: wrap;
            background: #dddddd;
            margin-top: 10px;
            padding: 0 23px;

            &:nth-child(1) {
                margin-top: 0;
            }

            .item {
                width: 100%;
                // width: calc(((100% - 20px * 3) / 4) + 20px);
                // margin-right: 20px;
                margin-top: 20px;
                // background: #dddddd;
                padding: 10px 0;
                border-radius: 3px;

                &:nth-child(4n) {
                    margin-right: 0;
                }

                &:nth-child(3n) {
                    width: calc(((100% - 20px * 3) / 4));
                    margin-right: 0;
                }

                &:nth-child(-n + 4) {
                    margin-top: 0px;
                }

                .sizeTitle {
                    font-weight: bold;
                    font-size: 16px;
                    color: #000000;
                    line-height: 16px;
                }

                .sizeFlexBox {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    flex-wrap: wrap;

                    & > span {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-top: 20px;
                        margin-right: 20px;

                        .title {
                            font-weight: 400;
                            font-size: 16px;
                            color: #555555;
                            line-height: 16px;
                            margin-left: 12px;
                        }
                    }

                    .sizeBtnFlexBox {
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                    }
                }
            }
        }
    }

    .flexWrapBox2 {
        width: 100%;

        .switchBigBox {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;

            .item {
                width: calc((100% - 30px * 2) / 3);
                height: 40px;
                margin-right: 30px;
                background: rgba(85, 85, 85, 0.15);
                border-radius: 3px 3px 3px 3px;
                font-size: 18px;
                color: #000000;
                line-height: 18px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                cursor: pointer;
                padding: 0 23px;

                &:nth-child(3n) {
                    margin-right: 0;
                }

                &.active {
                    background: #ff4d00;
                    color: #ffffff;
                    opacity: 1;
                }

                &:hover {
                    background: #ff4d00;
                    color: #ffffff;
                    opacity: 1;
                }
            }
        }

        .selectLineBox {
            width: 100%;
            margin-top: 16px;
            background: #dddddd;
            padding-bottom: 16px;

            .item {
                display: block;
                padding: 0;
                width: 100%;

                &:nth-child(3n) {
                    margin-right: 0;
                }

                .orangeTitle {
                    width: 100%;
                    font-weight: bold;
                    font-size: 18px;
                    color: #ff4d00;
                    line-height: 40px;
                    padding: 0 23px;
                }

                .select {
                    width: calc(100%);
                }
            }
        }

        .gupiFlexBox {
            width: 100%;
            display: flex;
            align-items: flex-start;

            .gupiWidthBox {
                width: calc((100% - 30px * 2) / 3);
            }

            .gupiWidthBox100 {
                width: 100%;
            }

            &.start {
                justify-content: flex-start;
            }

            &.center {
                justify-content: center;
            }

            &.end {
                justify-content: flex-end;
            }
        }
    }

    .flexWrapBox5 {
        width: 100%;

        .flexBoxM {
            width: 100%;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;

            .itemBox {
                display: block;
                width: calc((100% - 30px * 2) / 3);
                margin-right: 30px;
                margin-top: 20px;

                &:nth-child(3n) {
                    margin-right: 0;
                }
            }
        }

        .ringItem {
            width: 100%;

            .ringItemMyBox {
                width: 100%;
                height: 40px;
                display: flex;
                align-items: center;

                & > span {
                    width: 100%;
                }

                &:nth-child(1) {
                    margin-top: 0;
                }
            }

            .item {
                display: flex;
                align-items: center;
                justify-content: flex-start;

                .smallTitle {
                    width: 85%;
                    font-size: 16px;
                    line-height: 16px;
                    margin-left: 10px;
                }

                .selectNum {
                    width: calc(100% - 85% - 10px - 16px);
                }
            }
        }

        .switchBigBox {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;

            .item {
                width: calc((100% - 30px * 2) / 3);
                height: 40px;
                margin-right: 30px;
                background: rgba(85, 85, 85, 0.15);
                border-radius: 3px 3px 3px 3px;
                font-size: 18px;
                color: #000000;
                line-height: 18px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                padding: 0 23px;

                &:nth-child(3n) {
                    margin-right: 0;
                }

                // &.active {
                //     background: #ff4d00;
                //     color: #ffffff;
                // }

                // &:hover {
                //     background: #ff4d00;
                //     color: #ffffff;
                // }
            }
        }

        .selectBigFlexBox {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            flex-wrap: wrap;

            .select {
                display: block;
                width: calc(100%);
                margin-top: 20px;

                &:nth-child(-n + 3) {
                    margin-top: 0px;
                }
            }
        }
    }

    .flexWrapBox3 {
        width: 100%;
        display: flex;
        align-items: flex-end;
        justify-content: flex-start;

        .kefuBtnYellow {
            width: 170px;
            height: 50px;
            background: #ff4d00;
            border-radius: 0px 0px 0px 0px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            .kefuText {
                font-weight: bold;
                font-size: 20px;
                color: #ffffff;
                line-height: 20px;
                margin-right: 10px;
            }

            .el-icon-service {
                color: #ffffff;
                font-size: 26px;
                line-height: 26px;
                font-weight: bold;
            }
        }

        .item {
            display: block;
            width: calc((100% - 30px * 2) / 3);
            margin-right: 30px;
            margin-top: 20px;

            &:nth-child(3n) {
                margin-right: 0;
            }

            &:nth-child(-n + 3) {
                margin-top: 20px;
            }
        }
    }

    .flexWrapBox6 {
        width: 100%;

        .flexWrapBox6FlexBox {
            width: 100%;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;

            .flexWrapBox6FlexBoxItemBox {
                width: 100%;
                display: flex;
                align-items: flex-start;
                justify-content: space-between;

                .itemBoxM {
                    width: calc((100% - 30px * 2) / 3);
                    justify-content: space-between;
                    flex-wrap: nowrap;
                    margin-right: 30px;
                    margin-top: 20px;

                    &:nth-child(3n) {
                        margin-right: 0;
                    }
                }

                .hangItemBox {
                    width: 100%;

                    & > span {
                        width: 100%;
                    }
                }

                .selectBigFlexBox {
                    width: 100%;
                    cursor: pointer;
                    height: 40px;
                    display: flex;
                    align-items: center;

                    & > span {
                        width: 100%;
                    }

                    &.myWidth {
                        width: calc((100% - 30px * 2) / 3);
                        justify-content: space-between;
                        flex-wrap: nowrap;
                        margin-top: 20px;
                    }

                    .title {
                        font-size: 16px;
                        color: #555555;
                        font-weight: 400;
                        line-height: 16px;
                        margin-left: 30px;
                    }

                    .num {
                        font-size: 16px;
                        color: #555555;
                        font-weight: 400;
                        line-height: 16px;
                    }

                    .selectflexTextBox {
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;

                        .title {
                            width: calc(100% - 16px - 20px);
                            margin-left: 16px;
                        }
                    }

                    .select {
                        display: block;
                        width: 100%;

                        &:nth-child(3n) {
                            margin-right: 0;
                        }
                    }

                    .myItem {
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        width: 100%;
                        margin-right: 30px;
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;

                        &.auto {
                            margin-left: auto;
                            margin-right: auto;
                        }

                        .smallTitle {
                            font-size: 16px;
                            line-height: 26px;
                            margin-left: 16px;
                            width: calc(100% - 16px - 20px - 64px);
                        }
                    }
                }
            }
        }

        .switchBigBox {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;

            &.center {
                justify-content: center;
            }

            &.end {
                justify-content: flex-end;
            }

            .item {
                width: calc((100% - 30px * 2) / 3);
                height: 40px;
                margin-right: 30px;
                background: rgba(85, 85, 85, 0.15);
                border-radius: 3px 3px 3px 3px;
                font-size: 18px;
                color: #000000;
                line-height: 18px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                padding: 0 23px;

                &:nth-child(3n) {
                    margin-right: 0;
                }
            }
        }

        .flexBox > span {
            width: calc((100% - 26px * 2) / 3);
            margin-top: 20px;
            margin-right: 26px;

            &:nth-child(3n) {
                margin-right: 0;
            }
        }

        .flexBox {
            width: 100%;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;

            .flexItem {
                width: calc((100% - 30px * 2) / 3);
                margin-right: 30px;
                display: flex;
                align-items: center;
                height: 40px;
                margin-top: 20px;

                &:nth-child(3n) {
                    margin-right: 0;
                }

                .select {
                    display: block;
                    width: 100%;
                }

                & > span {
                    width: 100%;
                }
            }

            .item {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;

                &:nth-child(3n) {
                    margin-right: 0;
                }

                .lineFlexBox {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                }

                .title {
                    font-size: 16px;
                    color: #555555;
                    line-height: 20px;
                    font-weight: 400;
                    margin-left: 10px;
                    width: 80%;
                }

                .num {
                    font-size: 16px;
                    color: #555555;
                    font-weight: 40px;
                    line-height: 20px;
                }
            }
        }
    }

    .flexWrapBox7 {
        width: 100%;

        .topBox {
            overflow: hidden;
            width: 100%;
            margin-bottom: 30px;

            .tableBox {
                width: 100%;
                background: rgba(85, 85, 85, 0.02);
                font-weight: 500;
                font-size: 16px;
                color: #000000;
                line-height: 32px;
                border-collapse: collapse;
                /* 合并边框 */
                border: 0px solid transparent;
                /* 设置边框样式、宽度和颜色 */

                .biaotou {
                    background: rgba(85, 85, 85, 0.15)
                        url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiPjxsaW5lIHgxPSIwIiB5MT0iMCIgeDI9IjEwMCUiIHkyPSIxMDAlIiBzdHJva2U9InJnYmEoMTgyLCAxODIsIDE4MiwxKSIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9zdmc+Cg==)
                        no-repeat 100% center;
                }

                .leftTitle {
                    font-size: 16px;
                    line-height: 16px;
                    color: #000000;
                    font-weight: 500;
                    float: left;
                    margin-top: 15px;
                    margin-left: 10px;
                }

                .leftTitle2 {
                    font-size: 16px;
                    line-height: 16px;
                    color: #000000;
                    font-weight: 500;
                    float: right;
                    margin-top: -2px;
                    margin-right: 12px;
                }

                .greyBg {
                    background: rgba(85, 85, 85, 0.15);
                }

                .blodText {
                    font-weight: bold;
                }

                .tableItemBox {
                    min-height: 48px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .flexBox {
                    min-height: 48px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 400;
                    font-size: 14px;
                    color: #555555;
                    line-height: 14px;
                }

                .tableItem {
                    width: 100%;
                    text-align: center;
                }

                th,
                td {
                    text-align: center;
                    border: 1px solid rgba(112, 112, 112, 0.5);
                    cursor: pointer;
                }

                .tableTitle {
                    font-weight: 500;
                    font-size: 14px;
                    color: #000000;
                    line-height: 14px;
                }

                .tableTitle2 {
                    font-weight: 400;
                    font-size: 14px;
                    color: #000000;
                    line-height: 14px;
                }

                .tableTitle3 {
                    font-weight: 400;
                    font-size: 12px;
                    color: #000000;
                    line-height: 12px;
                    margin-top: 8px;
                }
            }
        }

        .bottomBox {
            overflow: hidden;
            width: 100%;

            .rightFlexBox {
                width: 100%;
                display: flex;
                align-items: flex-start;
                justify-content: space-between;
                flex-wrap: wrap;

                .flexItem {
                    overflow: hidden;
                    width: 32%;
                    margin-right: 2%;
                    margin-top: 20px;

                    &:nth-child(-n + 3) {
                        margin-top: 0;
                    }

                    &:nth-child(3n) {
                        margin-right: 0;
                    }

                    .title {
                        width: 100%;
                        font-weight: bold;
                        font-size: 18px;
                        color: #000000;
                        line-height: 30px;
                        text-align: left;
                    }

                    .item {
                        margin-top: 25px;
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        .smallTitle {
                            width: 70%;
                            text-align: left;
                            font-weight: 400;
                            font-size: 16px;
                            color: #555555;
                            line-height: 16px;
                            word-break: break-all;
                        }
                    }
                }
            }
        }
    }

    .flexWrapBox8 {
        width: 100%;

        .xianFlexBox {
            width: 100%;
        }

        .flexItem > span {
            width: 100%;
        }

        .flexItem {
            width: 100%;

            .itemLineBox {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 20px;

                .smallTitle {
                    width: 76%;
                    text-align: left;
                    font-weight: 400;
                    font-size: 14px;
                    color: #555555;
                    line-height: 16px;
                    word-break: break-all;
                }
            }
        }

        .centerItem > span {
        }

        .centerItem2 {
            width: 100%;
            margin-top: 20px;

            // &:nth-child(-n + 2) {
            //     margin-top: 0;
            // }

            .title {
                width: 100%;
                font-weight: bold;
                font-size: 18px;
                color: #000000;
                line-height: 30px;
                text-align: left;
            }

            .item {
                margin-top: 20px;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .smallTitle {
                    width: 76%;
                    text-align: left;
                    font-weight: 400;
                    font-size: 14px;
                    color: #555555;
                    line-height: 18px;
                    word-break: break-all;
                }
            }

            &.justone {
                width: 100%;
                margin-right: 0;

                .smallTitle {
                    width: 77%;
                }
            }
        }

        .centerItem {
            width: 100%;

            .title {
                width: 100%;
                font-weight: bold;
                font-size: 18px;
                color: #000000;
                line-height: 30px;
                text-align: left;
            }

            .item {
                margin-top: 20px;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .smallTitle {
                    width: 50%;
                    text-align: left;
                    font-weight: 400;
                    font-size: 14px;
                    color: #555555;
                    line-height: 18px;
                    word-break: break-all;
                }
            }
        }
    }

    .flexWrapBox9 {
        width: 100%;

        .centerItem {
            width: 100%;

            .title {
                width: 100%;
                font-weight: bold;
                font-size: 18px;
                color: #000000;
                line-height: 30px;
                text-align: left;
            }

            .item {
                cursor: pointer;
                margin-top: 25px;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .smallTitle {
                    width: 75%;
                    text-align: left;
                    font-weight: 400;
                    font-size: 14px;
                    color: #555555;
                    line-height: 24px;
                    word-break: break-all;
                }
            }
        }

        .newFlexBox {
            margin-top: 25px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;

            .smallTitle {
                width: 75%;
                text-align: left;
                font-weight: 400;
                font-size: 14px;
                color: #555555;
                line-height: 16px;
                word-break: break-all;
            }
        }
    }

    .flexWrapBox13 {
        width: 100%;

        .flexBox {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;

            .flexBtnBox {
                width: calc((100% - 20px * 3) / 4);
                margin-right: 20px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                margin-right: 50px;

                &:nth-child(4n) {
                    margin-right: 0;
                }

                &:nth-child(-n + 4) {
                    margin-top: 0;
                }

                .title {
                    font-weight: 500;
                    font-size: 15px;
                    color: #555555;
                    line-height: 15px;
                    margin-right: 30px;
                }

                .otherBuyBtn {
                    width: 55px;
                    height: 26px;
                    background: #ff4d00;
                    border-radius: 3px 3px 3px 3px;
                    font-weight: 500;
                    font-size: 15px;
                    color: #ffffff;
                    line-height: 15px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                }
            }
        }
    }

    .flexWrapBox10 {
        width: 100%;

        .smallTitle {
            width: 65%;
            font-size: 14px;
            line-height: 16px;
            font-weight: 400;
            color: #555555;
        }

        .switchBigBox {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;

            .item {
                width: calc((100% - 26px * 2) / 3);
                height: 40px;
                margin-right: 26px;
                background: rgba(85, 85, 85, 0.15);
                border-radius: 3px 3px 3px 3px;
                font-size: 18px;
                color: #000000;
                line-height: 18px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                padding: 0 23px;
                cursor: pointer;
                // opacity: 0.25;

                &:nth-child(3n) {
                    margin-right: 0;
                }

                &.active {
                    background: #ff4d00;
                    color: #ffffff;
                    opacity: 1;
                }

                &:hover {
                    background: #ff4d00;
                    color: #ffffff;
                    opacity: 1;
                }
            }
        }

        .myFlexBox > span {
            width: calc((100% - 30px * 3) / 4);
            margin-right: 30px;
            margin-top: 20px;

            &:nth-child(4n) {
                margin-right: 0;
            }

            &:nth-child(-n + 4) {
                margin-top: 0;
            }
        }

        .myFlexBox {
            width: 100%;
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            flex-wrap: wrap;
            margin-top: 25px;

            .item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
            }
        }
    }

    .flexWrapBox12 {
        width: 100%;

        .flexWrapBox12ScrollBox {
            width: 100%;
            max-height: 250px;
            // margin-top: 10px;
            overflow-x: hidden;
            overflow-y: auto;
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            flex-wrap: wrap;
            // padding-right: 1.5%;

            // &::-webkit-scrollbar {
            //     width: 8px;
            // }

            // &::-webkit-scrollbar-track {
            //     // 背景
            //     background-color: #999999;
            // }

            // &::-webkit-scrollbar-thumb {
            //     // 滚动块
            //     background-color: #ff4d00;
            // }

            & > span {
                width: calc(((100% - 6px) - 20px * 15) / 16);
                margin-right: 20px;
                margin-top: 20px;
                cursor: pointer;

                .elImgBox {
                    width: 100%;
                    height: 0;
                    padding-bottom: 100%;
                    margin-bottom: 5px;
                    position: relative;

                    .img {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                    }
                }

                .title {
                    font-weight: 400;
                    font-size: 14px;
                    color: #555555;
                    line-height: 20px;
                    min-height: 60px;
                    width: 100%;
                    text-align: start;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                }

                .bottomFlexBox {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .selectBtn {
                        width: 20px;
                        height: 20px;
                        border-radius: 50%;
                        border: 1px solid #000000;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        &.active {
                            .selectBtnActive {
                                display: block;
                            }
                        }

                        .selectBtnActive {
                            display: none;
                            width: 12px;
                            height: 12px;
                            background: #ff4d00;
                            border-radius: 50%;
                        }
                    }
                }

                &:nth-child(-n + 16) {
                    margin-top: 0;
                }

                &:nth-child(16n) {
                    margin-right: 0;
                }
            }

            .itemBox {
                width: 100%;
            }
        }

        .flexWrapBox12ScrollBox1-2 {
            width: 100%;
            max-height: 250px;
            // margin-top: 10px;
            overflow-x: hidden;
            overflow-y: auto;
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            flex-wrap: wrap;
            // padding-right: 1.5%;

            // &::-webkit-scrollbar {
            //     width: 8px;
            // }

            // &::-webkit-scrollbar-track {
            //     // 背景
            //     background-color: #999999;
            // }

            // &::-webkit-scrollbar-thumb {
            //     // 滚动块
            //     background-color: #ff4d00;
            // }

            & > span {
                width: calc(((100% - 6px) - 20px * 7) / 8);
                margin-right: 20px;
                margin-top: 20px;
                cursor: pointer;

                .elImgBox {
                    width: 100%;
                    height: 0;
                    padding-bottom: 100%;
                    margin-bottom: 5px;
                    position: relative;

                    .img {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                    }
                }

                .title {
                    font-weight: 400;
                    font-size: 14px;
                    color: #555555;
                    line-height: 20px;
                    min-height: 60px;
                    width: 100%;
                    text-align: start;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                }

                .bottomFlexBox {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .selectBtn {
                        width: 20px;
                        height: 20px;
                        border-radius: 50%;
                        border: 1px solid #000000;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        &.active {
                            .selectBtnActive {
                                display: block;
                            }
                        }

                        .selectBtnActive {
                            display: none;
                            width: 12px;
                            height: 12px;
                            background: #ff4d00;
                            border-radius: 50%;
                        }
                    }
                }

                &:nth-child(-n + 8) {
                    margin-top: 0;
                }

                &:nth-child(8n) {
                    margin-right: 0;
                }
            }

            .itemBox {
                width: 100%;
            }
        }

        .flexWrapBox12ScrollBox2 {
            width: 100%;
            max-height: 250px;
            // margin-top: 10px;
            overflow-x: hidden;
            overflow-y: auto;
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            flex-wrap: wrap;
            // padding-right: 1.5%;

            // &::-webkit-scrollbar {
            //     width: 8px;
            // }

            // &::-webkit-scrollbar-track {
            //     // 背景
            //     background-color: #999999;
            // }

            // &::-webkit-scrollbar-thumb {
            //     // 滚动块
            //     background-color: #ff4d00;
            // }

            & > span {
                width: calc(((100% - 6px) - 17px * 1) / 2);
                margin-right: 17px;
                margin-top: 20px;
                cursor: pointer;

                .elImgBox {
                    width: 100%;
                    height: 0;
                    padding-bottom: 100%;
                    margin-bottom: 5px;
                    position: relative;

                    .img {
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        top: 0;
                        left: 0;
                    }
                }

                .title {
                    font-weight: 400;
                    font-size: 14px;
                    color: #555555;
                    line-height: 20px;
                    min-height: 60px;
                    width: 100%;
                    text-align: start;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                }

                .bottomFlexBox {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .selectBtn {
                        width: 20px;
                        height: 20px;
                        border-radius: 50%;
                        border: 1px solid #000000;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        &.active {
                            .selectBtnActive {
                                display: block;
                            }
                        }

                        .selectBtnActive {
                            display: none;
                            width: 12px;
                            height: 12px;
                            background: #ff4d00;
                            border-radius: 50%;
                        }
                    }
                }

                &:nth-child(-n + 2) {
                    margin-top: 0;
                }

                &:nth-child(2n) {
                    margin-right: 0;
                }
            }

            .itemBox {
                width: 100%;
            }
        }
    }

    .flexWrapBox11 {
        width: 100%;
        position: relative;

        .centerLine {
            width: 1px;
            height: calc(100% - 60px);
            background: rgba(112, 112, 112, 0.9);
            position: absolute;
            top: 60px;
            left: 50%;
            transform: translateX(-50%);
        }

        .wrapBox > span {
            width: calc((100% - 22px * 7) / 8);
            margin-right: 22px;
            margin-top: 20px;

            &:nth-child(8n) {
                margin-right: 0;
            }

            &:nth-child(-n + 8) {
                margin-top: 0;
            }
        }

        .wrapBox {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            flex-wrap: wrap;
            margin-top: 20px;
            position: relative;

            .item {
                width: 100%;
                min-height: 120px;
                cursor: pointer;

                .bottomFlexBox {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .selectBtn {
                        width: 20px;
                        height: 20px;
                        border-radius: 50%;
                        border: 1px solid #000000;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        &.active {
                            .selectBtnActive {
                                display: block;
                            }
                        }

                        .selectBtnActive {
                            display: none;
                            width: 12px;
                            height: 12px;
                            background: #ff4d00;
                            border-radius: 50%;
                        }
                    }

                    .playVideoIcon {
                        width: 23px;
                        height: 15px;
                        background: url('../../assets/img/productList/video.png') no-repeat;
                        background-size: 100% 100%;
                        position: relative;
                        cursor: pointer;

                        .hintVideoText {
                            width: 60px;
                            height: 23px;
                            background: #ededed;
                            border-radius: 0px 0px 0px 0px;
                            border: 1px solid rgba(112, 112, 112, 0.5);
                            display: none;
                            align-items: center;
                            justify-content: center;
                            font-weight: 400;
                            font-size: 12px;
                            color: #555555;
                            line-height: 12px;
                            position: absolute;
                            top: 15px;
                            left: 23px;
                        }

                        &:hover {
                            background: url('../../assets/img/productList/video2.png') no-repeat;
                            background-size: 100% 100%;

                            .hintVideoText {
                                display: flex;
                                align-items: center;
                                justify-content: center;
                            }
                        }
                    }
                }

                .elImgBox {
                    width: 100%;
                    height: 0;
                    padding-bottom: 100%;
                    position: relative;
                    margin-bottom: 3px;

                    .img {
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        top: 0;
                        left: 0;
                    }
                }

                .title {
                    width: 100%;
                    font-weight: 400;
                    font-size: 14px;
                    color: #555555;
                    line-height: 18px;
                    text-align: start;
                }

                &:nth-child(7n) {
                    margin-right: 0;
                }

                &:nth-child(-n + 7) {
                    margin-top: 0;
                }
            }
        }
    }

    // &::-webkit-scrollbar {
    //     width: 18px;
    // }

    // &::-webkit-scrollbar-track {
    //     // 背景
    //     background-color: #999999;
    // }

    // &::-webkit-scrollbar-thumb {
    //     // 滚动块
    //     background-color: #ff4d00;
    // }

    .text {
        width: 100%;
        font-size: 36px;
        line-height: 36px;
    }
}

.redText2 {
    width: 100%;
    background: #ffffff;
    color: #ff4d00;
    font-size: 16px;
    line-height: 26px;
    text-align: right;
    padding-right: 30px;
}

.topFlexBox {
    width: 100%;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    justify-content: flex-start;
    position: relative;
    height: 20px;

    .title {
        height: 20px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        margin-left: -580px;
        font-weight: bold;
        font-size: 20px;
        color: #ff4d00;
        line-height: 20px;
    }
}

.topBoxTop {
    width: 100%;
    height: calc(40vh);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .redText {
        width: 270px;
        color: #ff4d00;
        font-size: 14px;
        line-height: 24px;
        position: absolute;
        right: 0px;
        bottom: 10px;
        letter-spacing: 1px;
    }

    .redText3 {
        color: #ff4d00;
        font-size: 14px;
        line-height: 24px;
        position: absolute;
        right: 0px;
        bottom: 60px;
    }

    .topBoxImg {
        display: block;
        width: 950px;
        // height: 500px;
        height: 40vh;
        margin: 0 auto;
        background: #f5f5f5;

        .img {
            width: 950px;
            // height: 500px;
            height: 38vh;
        }

        .bannerItem {
            // width: 700px;
            // height: 500px;
            height: 40vh;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}

.checklistWin {
    .drawerContentBox {
        padding: 0px 40px;
        height: calc(100vh - 40px);
        position: relative;

        .drawerBottomBtnFlexBox {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            bottom: 30px;
            left: 50%;
            transform: translateX(-50%);

            .btn {
                width: 200px;
                height: 40px;
                background: #ff4d00;
                font-weight: 400;
                font-size: 14px;
                color: #ffffff;
                line-height: 14px;
                text-align: center;
                margin-right: 20px;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .btn2 {
                width: 200px;
                height: 40px;
                border: 1px solid #000000;
                font-weight: 400;
                font-size: 14px;
                color: #000000;
                line-height: 14px;
                text-align: center;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        .winHintBox {
            width: 100%;
            display: flex;
            align-items: flex-start;
            justify-content: center;
            margin-top: 30px;
            margin-bottom: 30px;

            .icon {
                width: 20px;
                display: block;
                margin-right: 6px;
                // display: inline-block;
                position: relative;
                top: 2px;
            }

            .hintText {
                font-weight: 400;
                font-size: 14px;
                color: #555555;
                line-height: 24px;
                font-weight: 400;
            }
        }

        .scrollView {
            width: 100%;
            height: calc(100vh - 76px - 34px - 44px - 55px - 30px - 30px - 18px - 20px - 20px - 20px - 50px - 100px + 55px);
            overflow-x: hidden;
            overflow-y: auto;
            // margin-bottom: 26px;
            padding-right: 12px;

            // &::-webkit-scrollbar {
            //     width: 12px;
            // }

            // &::-webkit-scrollbar-track {
            //     // 背景
            //     background-color: #999999;
            // }

            // &::-webkit-scrollbar-thumb {
            //     // 滚动块
            //     background-color: #ff4d00;
            // }

            // &::-webkit-scrollbar-button:start:decrement {
            //     background-image: url('../../assets/img/index/up.png');
            //     background-repeat: no-repeat;
            //     background-position: center center;
            //     background-size: 12px 12px;
            // }

            // &::-webkit-scrollbar-button:end:increment {
            //     background-image: url('../../assets/img/index/down.png');
            //     background-repeat: no-repeat;
            //     background-position: center center;
            //     background-size: 12px 12px;
            // }

            .drItem {
                width: 100%;
                display: flex;
                align-items: flex-start;
                justify-content: space-between;
                margin-top: 5px;

                &:nth-child(1) {
                    margin-top: 0px;
                }

                .leftBox {
                    min-width: 82px;
                    max-width: 162px;
                    margin-right: 50px;

                    .title {
                        font-weight: bold;
                        font-size: 16px;
                        color: #000000;
                        line-height: 30px;
                    }
                }

                .rightBox {
                    flex: 1;

                    .checkItemBox {
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        margin-top: 5px;

                        &:nth-child(1) {
                            margin-top: 0;
                        }

                        .title {
                            flex: 2;
                            font-weight: 400;
                            font-size: 16px;
                            color: #555555;
                            line-height: 30px;
                        }

                        .num {
                            flex: 1;
                            font-weight: 400;
                            font-size: 16px;
                            color: #555555;
                            line-height: 30px;
                            text-align: center;
                        }

                        .money {
                            width: 100px;
                            font-weight: 400;
                            font-size: 16px;
                            color: #ff4d00;
                            line-height: 30px;
                        }

                        .deleteBtn {
                            width: 22px;
                            height: 22px;
                            cursor: pointer;
                            background: url('../../assets/img/productList/delete.png') no-repeat;
                            background-size: 100% 100%;
                        }
                    }
                }
            }
        }

        .orangeLineBox {
            width: 100%;
            height: 0.35vh;
            background: #ff4d00;
        }

        .countBigBox {
            width: 100%;
            margin-top: 16px;
            margin-bottom: 10px;
            height: 34px;
            display: flex;
            align-items: flex-end;
            justify-content: flex-end;

            .title {
                font-weight: bold;
                font-size: 18px;
                color: #000000;
                line-height: 34px;
            }

            .money {
                font-weight: bold;
                font-size: 25px;
                color: #ff4d00;
                line-height: 34px;
                margin-right: 20px;
            }

            .changePriceBtn {
                width: 90px;
                height: 34px;
                background: #ffffff;
                border-radius: 5px 5px 5px 5px;
                border: 1px solid #707070;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 500;
                font-size: 17px;
                color: #ff4d00;
                line-height: 30px;
                cursor: pointer;
            }
        }

        .remarkBox {
            width: 100%;

            .title {
                font-weight: bold;
                font-size: 18px;
                color: #000000;
                line-height: 18px;
                margin-bottom: 20px;
                text-align: left;
            }

            .textareaBox {
                width: 100%;
                height: 100px;
                padding: 16px;
                background: #ffffff;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #eeeeee;

                .textarea {
                    width: 100%;
                    height: 100%;
                    resize: none;
                    outline: none;
                    border: 0;
                    font-weight: 400;
                    font-size: 14px;
                    color: #000000;
                    line-height: 24px;
                    font-weight: 500;
                    font-family: Source Han Sans CN, Source Han Sans CN;
                }
            }
        }
    }

    .drawerTitleBox {
        width: 100%;
        height: 40px;
        background: #ff4d00;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 25px 0 30px;
        overflow: hidden;

        .title {
            font-weight: bold;
            font-size: 18px;
            color: #ffffff;
            line-height: 20px;
            flex: 1;
        }

        .barResetBtn {
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            position: relative;

            &::after {
                content: '';
                position: absolute;
                top: -10px;
                right: -10px;
                bottom: -10px;
                left: -10px;
            }

            .btnTitle {
                font-weight: 400;
                font-size: 18px;
                color: #ffffff;
                line-height: 18px;
                margin-right: 14px;
            }

            .resetIcon {
                width: 40px;
                height: 40px;
            }
        }
    }
}

.whiteLineBox {
    width: 100%;
    height: 0.35vh;
    background: #ff4d00;
}

.bgBox {
    width: 100%;
    // height: calc(100vh - 50px - 35px - 532px + 88px);
    height: 59.65vh;
    background: #f9f9f9;
}

.fill30 {
    width: 100%;
    height: 30px;
}

.bottomMyBtnBox {
    width: 250px;
    display: block;
    margin: 30px auto 0 auto;
}

.checklistBar {
    width: 62px;
    height: 200px;
    background: #ff4d00;
    // border-radius: 0px 0px 0px 0px;
    position: fixed;
    top: 100px;
    right: 0;
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 34px 0 34px;
    cursor: pointer;
    border-radius: 15px 0px 0px 15px;
    overflow: hidden;

    .barTitle {
        font-weight: bold;
        font-size: 20px;
        color: #ffffff;
        line-height: 28px;
    }

    .barResetBtn {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;

        .btnTitle {
            font-weight: 500;
            font-size: 16px;
            color: #ffffff;
            line-height: 18px;
            margin-right: 14px;
        }

        .resetIcon {
            width: 40px;
            height: 40px;
        }
    }
}

.checklistBar2 {
    width: 62px;
    height: 220px;
    background: #ff4d00;
    // border-radius: 0px 0px 0px 0px;
    position: fixed;
    top: 100px;
    left: 0;
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 34px 0 34px;
    cursor: pointer;
    border-radius: 0px 15px 15px 0px;
    overflow: hidden;

    .barTitle {
        font-weight: bold;
        font-size: 20px;
        color: #ffffff;
        line-height: 24px;
        // word-break: break-all;
        // writing-mode: vertical-lr;
        // writing-mode: tb-rl;
        // white-space: nowrap;
    }

    .barResetBtn {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;

        .btnTitle {
            font-weight: 500;
            font-size: 16px;
            color: #ffffff;
            line-height: 18px;
            margin-right: 14px;
        }

        .resetIcon {
            width: 40px;
            height: 40px;
        }
    }
}

.fill60 {
    width: 100%;
    height: 30px;
}

.imgLoad {
    position: fixed;
    top: 999999px;
    left: 999999px;

    .playVideoIcon {
        background: url('../../assets/img/productList/video2.png') no-repeat;
        background-size: 100% 100%;
    }
}

.select {
    font-weight: 400;
    font-size: 18px;
    color: #000000;
    line-height: 18px;
}
</style>
<style scoped lang="less" src="@/assets/h5css/mobile/product-made.less"></style>
